import React from 'react';

export const Icon = {
  ICCameraPhoto: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path
        d="M9 13.125C9.9375 13.125 10.7344 12.7969 11.3906 12.1406C12.0469 11.4844 12.375 10.6875 12.375 9.75C12.375 8.8125 12.0469 8.01562 11.3906 7.35938C10.7344 6.70312 9.9375 6.375 9 6.375C8.0625 6.375 7.26562 6.70312 6.60938 7.35938C5.95312 8.01562 5.625 8.8125 5.625 9.75C5.625 10.6875 5.95312 11.4844 6.60938 12.1406C7.26562 12.7969 8.0625 13.125 9 13.125ZM9 11.625C8.475 11.625 8.03125 11.4438 7.66875 11.0813C7.30625 10.7188 7.125 10.275 7.125 9.75C7.125 9.225 7.30625 8.78125 7.66875 8.41875C8.03125 8.05625 8.475 7.875 9 7.875C9.525 7.875 9.96875 8.05625 10.3313 8.41875C10.6938 8.78125 10.875 9.225 10.875 9.75C10.875 10.275 10.6938 10.7188 10.3313 11.0813C9.96875 11.4438 9.525 11.625 9 11.625ZM3 15.75C2.5875 15.75 2.23438 15.6031 1.94063 15.3094C1.64687 15.0156 1.5 14.6625 1.5 14.25V5.25C1.5 4.8375 1.64687 4.48438 1.94063 4.19063C2.23438 3.89688 2.5875 3.75 3 3.75H5.3625L6.75 2.25H11.25L12.6375 3.75H15C15.4125 3.75 15.7656 3.89688 16.0594 4.19063C16.3531 4.48438 16.5 4.8375 16.5 5.25V14.25C16.5 14.6625 16.3531 15.0156 16.0594 15.3094C15.7656 15.6031 15.4125 15.75 15 15.75H3ZM3 14.25H15V5.25H11.9625L10.5938 3.75H7.40625L6.0375 5.25H3V14.25Z"
        fill-opacity="0.6"
      />
    </svg>
  ),
  ICComment: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M4.5 10.5H10.5V9H4.5V10.5ZM4.5 8.25H13.5V6.75H4.5V8.25ZM4.5 6H13.5V4.5H4.5V6ZM1.5 16.5V3C1.5 2.5875 1.64687 2.23438 1.94063 1.94063C2.23438 1.64687 2.5875 1.5 3 1.5H15C15.4125 1.5 15.7656 1.64687 16.0594 1.94063C16.3531 2.23438 16.5 2.5875 16.5 3V12C16.5 12.4125 16.3531 12.7656 16.0594 13.0594C15.7656 13.3531 15.4125 13.5 15 13.5H4.5L1.5 16.5ZM3.8625 12H15V3H3V12.8438L3.8625 12Z" />
    </svg>
  ),
  ICMove: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M2.5 17.5V12.5H4.16667V14.6667L6.75 12.0833L7.91667 13.25L5.33333 15.8333H7.5V17.5H2.5ZM12.5 17.5V15.8333H14.6667L12.0833 13.25L13.25 12.0833L15.8333 14.6667V12.5H17.5V17.5H12.5ZM6.75 7.91667L4.16667 5.33333V7.5H2.5V2.5H7.5V4.16667H5.33333L7.91667 6.75L6.75 7.91667ZM13.25 7.91667L12.0833 6.75L14.6667 4.16667H12.5V2.5H17.5V7.5H15.8333V5.33333L13.25 7.91667ZM10 11.6667C9.54167 11.6667 9.14931 11.5035 8.82292 11.1771C8.49653 10.8507 8.33333 10.4583 8.33333 10C8.33333 9.54167 8.49653 9.14931 8.82292 8.82292C9.14931 8.49653 9.54167 8.33333 10 8.33333C10.4583 8.33333 10.8507 8.49653 11.1771 8.82292C11.5035 9.14931 11.6667 9.54167 11.6667 10C11.6667 10.4583 11.5035 10.8507 11.1771 11.1771C10.8507 11.5035 10.4583 11.6667 10 11.6667Z" />
    </svg>
  ),
  ICDragPan: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M10.0013 18.3334L6.45964 14.7917L7.64714 13.6042L9.16797 15.1251V10.8334H4.89714L6.41797 12.3334L5.20964 13.5417L1.66797 10.0001L5.1888 6.47925L6.3763 7.66675L4.8763 9.16675H9.16797V4.87508L7.64714 6.39591L6.45964 5.20841L10.0013 1.66675L13.543 5.20841L12.3555 6.39591L10.8346 4.87508V9.16675H15.1055L13.5846 7.66675L14.793 6.45841L18.3346 10.0001L14.793 13.5417L13.6055 12.3542L15.1263 10.8334H10.8346V15.1042L12.3346 13.5834L13.543 14.7917L10.0013 18.3334Z" />
    </svg>
  ),
  ICProducts: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M5 8V19H19V8H16V16L12 14L8 16V8H5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V6.525C3 6.29167 3.0375 6.06667 3.1125 5.85C3.1875 5.63333 3.3 5.43333 3.45 5.25L4.7 3.725C4.88333 3.49167 5.1125 3.3125 5.3875 3.1875C5.6625 3.0625 5.95 3 6.25 3H17.75C18.05 3 18.3375 3.0625 18.6125 3.1875C18.8875 3.3125 19.1167 3.49167 19.3 3.725L20.55 5.25C20.7 5.43333 20.8125 5.63333 20.8875 5.85C20.9625 6.06667 21 6.29167 21 6.525V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5.4 6H18.6L17.75 5H6.25L5.4 6ZM10 8V12.75L12 11.75L14 12.75V8H10Z" />
    </svg>
  ),
  ICRounded1: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M15 0L15 1.66667L13.3333 1.66667L13.3333 1.45705e-07L15 0ZM15 3.33333L15 5L13.3333 5L13.3333 3.33333L15 3.33333ZM15 6.66667L15 8.33333L13.3333 8.33333L13.3333 6.66667L15 6.66667ZM15 10L15 11.6667L13.3333 11.6667L13.3333 10L15 10ZM15 13.3333L15 15L13.3333 15L13.3333 13.3333L15 13.3333ZM11.6667 2.91409e-07L11.6667 1.66667L10 1.66667L10 4.37114e-07L11.6667 2.91409e-07ZM11.6667 13.3333L11.6667 15L10 15L10 13.3333L11.6667 13.3333ZM8.33333 5.82818e-07L8.33333 1.66667L6.66667 1.66667L6.66667 7.28523e-07L8.33333 5.82818e-07ZM5 8.74228e-07L5 1.66667L3.33333 1.66667L3.33333 1.01993e-06L5 8.74228e-07ZM1.66667 1.16564e-06L1.66667 1.66667L-1.16564e-06 1.66667L-1.31134e-06 1.31134e-06L1.66667 1.16564e-06ZM1.66667 3.33334L1.66667 5L-8.74228e-07 5L-1.01993e-06 3.33334L1.66667 3.33334ZM-7.28523e-07 6.66667L1.66667 6.66667L1.66667 10.8333C1.66667 11.5278 1.90972 12.1181 2.39583 12.6042C2.88194 13.0903 3.47222 13.3333 4.16667 13.3333L8.33333 13.3333L8.33333 15L4.16667 15C3.01389 15 2.03125 14.5938 1.21875 13.7813C0.40625 12.9688 -2.63483e-07 11.9861 -3.64262e-07 10.8333L-7.28523e-07 6.66667Z"
        fill="black"
      />
    </svg>
  ),
  ICRounded2: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M17.5 17.5L15.8333 17.5L15.8333 15.8333L17.5 15.8333L17.5 17.5ZM14.1667 17.5L12.5 17.5L12.5 15.8333L14.1667 15.8333L14.1667 17.5ZM10.8333 17.5L9.16667 17.5L9.16667 15.8333L10.8333 15.8333L10.8333 17.5ZM7.5 17.5L5.83333 17.5L5.83333 15.8333L7.5 15.8333L7.5 17.5ZM4.16667 17.5L2.5 17.5L2.5 15.8333L4.16667 15.8333L4.16667 17.5ZM17.5 14.1667L15.8333 14.1667L15.8333 12.5L17.5 12.5L17.5 14.1667ZM4.16667 14.1667L2.5 14.1667L2.5 12.5L4.16667 12.5L4.16667 14.1667ZM17.5 10.8333L15.8333 10.8333L15.8333 9.16667L17.5 9.16667L17.5 10.8333ZM17.5 7.5L15.8333 7.5L15.8333 5.83333L17.5 5.83333L17.5 7.5ZM17.5 4.16667L15.8333 4.16667L15.8333 2.5L17.5 2.5L17.5 4.16667ZM14.1667 4.16667L12.5 4.16667L12.5 2.5L14.1667 2.5L14.1667 4.16667ZM10.8333 2.5L10.8333 4.16667L6.66667 4.16667C5.97222 4.16667 5.38194 4.40972 4.89583 4.89583C4.40972 5.38194 4.16667 5.97222 4.16667 6.66667L4.16667 10.8333L2.5 10.8333L2.5 6.66667C2.5 5.51389 2.90625 4.53125 3.71875 3.71875C4.53125 2.90625 5.51389 2.5 6.66667 2.5L10.8333 2.5Z"
        fill="black"
      />
    </svg>
  ),
  ICRounded3: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M2.5 17.5V15.8333H4.16667V17.5H2.5ZM2.5 14.1667V12.5H4.16667V14.1667H2.5ZM2.5 10.8333V9.16667H4.16667V10.8333H2.5ZM2.5 7.5V5.83333H4.16667V7.5H2.5ZM2.5 4.16667V2.5H4.16667V4.16667H2.5ZM5.83333 17.5V15.8333H7.5V17.5H5.83333ZM5.83333 4.16667V2.5H7.5V4.16667H5.83333ZM9.16667 17.5V15.8333H10.8333V17.5H9.16667ZM12.5 17.5V15.8333H14.1667V17.5H12.5ZM15.8333 17.5V15.8333H17.5V17.5H15.8333ZM15.8333 14.1667V12.5H17.5V14.1667H15.8333ZM17.5 10.8333H15.8333V6.66667C15.8333 5.97222 15.5903 5.38194 15.1042 4.89583C14.6181 4.40972 14.0278 4.16667 13.3333 4.16667H9.16667V2.5H13.3333C14.4861 2.5 15.4688 2.90625 16.2812 3.71875C17.0938 4.53125 17.5 5.51389 17.5 6.66667V10.8333Z"
        fill="black"
      />
    </svg>
  ),
  ICRounded4: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M2.5 2.5L4.16667 2.5L4.16667 4.16667L2.5 4.16667L2.5 2.5ZM5.83333 2.5L7.5 2.5L7.5 4.16667L5.83333 4.16667L5.83333 2.5ZM9.16667 2.5L10.8333 2.5L10.8333 4.16667L9.16667 4.16667L9.16667 2.5ZM12.5 2.5L14.1667 2.5L14.1667 4.16667L12.5 4.16667L12.5 2.5ZM15.8333 2.5L17.5 2.5L17.5 4.16667L15.8333 4.16667L15.8333 2.5ZM2.5 5.83333L4.16667 5.83333L4.16667 7.5L2.5 7.5L2.5 5.83333ZM15.8333 5.83333L17.5 5.83333L17.5 7.5L15.8333 7.5L15.8333 5.83333ZM2.5 9.16667L4.16667 9.16667L4.16667 10.8333L2.5 10.8333L2.5 9.16667ZM2.5 12.5L4.16667 12.5L4.16667 14.1667L2.5 14.1667L2.5 12.5ZM2.5 15.8333L4.16667 15.8333L4.16667 17.5L2.5 17.5L2.5 15.8333ZM5.83333 15.8333L7.5 15.8333L7.5 17.5L5.83333 17.5L5.83333 15.8333ZM9.16667 17.5L9.16667 15.8333L13.3333 15.8333C14.0278 15.8333 14.6181 15.5903 15.1042 15.1042C15.5903 14.6181 15.8333 14.0278 15.8333 13.3333L15.8333 9.16667L17.5 9.16667L17.5 13.3333C17.5 14.4861 17.0937 15.4687 16.2812 16.2812C15.4687 17.0937 14.4861 17.5 13.3333 17.5L9.16667 17.5Z"
        fill="black"
      />
    </svg>
  ),
  ICExtend1: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
  
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M2.5 15.4167C2.5 15.1865 2.68655 15 2.91667 15L17.0833 15C17.3135 15 17.5 15.1865 17.5 15.4167L17.5 16.25C17.5 16.4801 17.3135 16.6667 17.0833 16.6667L2.91667 16.6667C2.68655 16.6667 2.5 16.4801 2.5 16.25L2.5 15.4167Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.16667 2.91666C4.16667 2.68654 4.35321 2.49999 4.58333 2.49999L15.4167 2.49999C15.6468 2.49999 15.8333 2.68654 15.8333 2.91665L15.8333 12.9167C15.8333 13.1468 15.6468 13.3333 15.4167 13.3333L4.58333 13.3333C4.35322 13.3333 4.16667 13.1468 4.16667 12.9167L4.16667 2.91666ZM5.83333 11.6667L14.1667 11.6667L14.1667 4.16666L5.83333 4.16666L5.83333 11.6667Z"
        fill="black"
      />
    </svg>
  ),
  ICExtend2: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
     
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M1.25 0C1.48012 0 1.66667 0.186548 1.66667 0.416667V14.5833C1.66667 14.8135 1.48012 15 1.25 15H0.416667C0.186548 15 -3.10518e-08 14.8135 0 14.5833V0.416667C1.38427e-07 0.186549 0.186549 1.02008e-06 0.416667 0H1.25Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.75 1.66667C13.9801 1.66667 14.1667 1.85321 14.1667 2.08333V12.9167C14.1667 13.1468 13.9801 13.3333 13.75 13.3333H3.75C3.51988 13.3333 3.33333 13.1468 3.33333 12.9167V2.08333C3.33333 1.85322 3.51988 1.66667 3.75 1.66667H13.75ZM5 3.33333V11.6667H12.5V3.33333H5Z"
        fill="black"
      />
    </svg>
  ),
  ICExtend3: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M15 1.25C15 1.48012 14.8135 1.66667 14.5833 1.66667L0.416667 1.66667C0.186548 1.66667 -6.4698e-08 1.48012 -5.46392e-08 1.25L-1.82131e-08 0.416666C-8.15427e-09 0.186547 0.186548 -6.78568e-07 0.416667 -6.37458e-07L14.5833 -1.82131e-08C14.8135 1.30272e-07 15 0.186549 15 0.416667L15 1.25Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3333 13.75C13.3333 13.9801 13.1468 14.1667 12.9167 14.1667L2.08333 14.1667C1.85321 14.1667 1.66667 13.9801 1.66667 13.75L1.66667 3.75C1.66667 3.51988 1.85322 3.33333 2.08333 3.33333L12.9167 3.33333C13.1468 3.33333 13.3333 3.51988 13.3333 3.75L13.3333 13.75ZM11.6667 5L3.33333 5L3.33333 12.5L11.6667 12.5L11.6667 5Z"
        fill="black"
      />
    </svg>
  ),
  ICExtend4: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
      fill-opacity="0.5"
    >
      <path
        d="M12.9141 15C12.6839 15 12.4974 14.8135 12.4974 14.5833L12.4974 0.416667C12.4974 0.186548 12.6839 -1.29396e-07 12.9141 -1.09278e-07L13.7474 -3.64262e-08C13.9775 -1.63085e-08 14.1641 0.186548 14.1641 0.416667L14.1641 14.5833C14.1641 14.8135 13.9775 15 13.7474 15L12.9141 15Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.414062 13.3333C0.183943 13.3333 -0.00260432 13.1468 -0.0026043 12.9167L-0.00260336 2.08333C-0.00260334 1.85321 0.183944 1.66667 0.414063 1.66667L10.4141 1.66667C10.6442 1.66667 10.8307 1.85322 10.8307 2.08333L10.8307 12.9167C10.8307 13.1468 10.6442 13.3333 10.4141 13.3333L0.414062 13.3333ZM9.16406 11.6667L9.16406 3.33333L1.66406 3.33333L1.66406 11.6667L9.16406 11.6667Z"
        fill="black"
      />
    </svg>
  ),
  ICAvatar: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M7.79984 22.8C8.93317 21.9333 10.1998 21.25 11.5998 20.75C12.9998 20.25 14.4665 20 15.9998 20C17.5332 20 18.9998 20.25 20.3998 20.75C21.7998 21.25 23.0665 21.9333 24.1998 22.8C24.9776 21.8889 25.5832 20.8556 26.0165 19.7C26.4498 18.5444 26.6665 17.3111 26.6665 16C26.6665 13.0444 25.6276 10.5278 23.5498 8.45C21.4721 6.37222 18.9554 5.33333 15.9998 5.33333C13.0443 5.33333 10.5276 6.37222 8.44984 8.45C6.37206 10.5278 5.33317 13.0444 5.33317 16C5.33317 17.3111 5.54984 18.5444 5.98317 19.7C6.4165 20.8556 7.02206 21.8889 7.79984 22.8ZM15.9998 17.3333C14.6887 17.3333 13.5832 16.8833 12.6832 15.9833C11.7832 15.0833 11.3332 13.9778 11.3332 12.6667C11.3332 11.3556 11.7832 10.25 12.6832 9.35C13.5832 8.45 14.6887 8 15.9998 8C17.3109 8 18.4165 8.45 19.3165 9.35C20.2165 10.25 20.6665 11.3556 20.6665 12.6667C20.6665 13.9778 20.2165 15.0833 19.3165 15.9833C18.4165 16.8833 17.3109 17.3333 15.9998 17.3333ZM15.9998 29.3333C14.1554 29.3333 12.4221 28.9833 10.7998 28.2833C9.17762 27.5833 7.7665 26.6333 6.5665 25.4333C5.3665 24.2333 4.4165 22.8222 3.7165 21.2C3.0165 19.5778 2.6665 17.8444 2.6665 16C2.6665 14.1556 3.0165 12.4222 3.7165 10.8C4.4165 9.17778 5.3665 7.76666 6.5665 6.56666C7.7665 5.36666 9.17762 4.41666 10.7998 3.71666C12.4221 3.01666 14.1554 2.66666 15.9998 2.66666C17.8443 2.66666 19.5776 3.01666 21.1998 3.71666C22.8221 4.41666 24.2332 5.36666 25.4332 6.56666C26.6332 7.76666 27.5832 9.17778 28.2832 10.8C28.9832 12.4222 29.3332 14.1556 29.3332 16C29.3332 17.8444 28.9832 19.5778 28.2832 21.2C27.5832 22.8222 26.6332 24.2333 25.4332 25.4333C24.2332 26.6333 22.8221 27.5833 21.1998 28.2833C19.5776 28.9833 17.8443 29.3333 15.9998 29.3333ZM15.9998 26.6667C17.1776 26.6667 18.2887 26.4944 19.3332 26.15C20.3776 25.8056 21.3332 25.3111 22.1998 24.6667C21.3332 24.0222 20.3776 23.5278 19.3332 23.1833C18.2887 22.8389 17.1776 22.6667 15.9998 22.6667C14.8221 22.6667 13.7109 22.8389 12.6665 23.1833C11.6221 23.5278 10.6665 24.0222 9.79984 24.6667C10.6665 25.3111 11.6221 25.8056 12.6665 26.15C13.7109 26.4944 14.8221 26.6667 15.9998 26.6667ZM15.9998 14.6667C16.5776 14.6667 17.0554 14.4778 17.4332 14.1C17.8109 13.7222 17.9998 13.2444 17.9998 12.6667C17.9998 12.0889 17.8109 11.6111 17.4332 11.2333C17.0554 10.8556 16.5776 10.6667 15.9998 10.6667C15.4221 10.6667 14.9443 10.8556 14.5665 11.2333C14.1887 11.6111 13.9998 12.0889 13.9998 12.6667C13.9998 13.2444 14.1887 13.7222 14.5665 14.1C14.9443 14.4778 15.4221 14.6667 15.9998 14.6667Z" />
    </svg>
  ),
  ICAccountInfo: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M14 13H19V11H14V13ZM14 10H19V8H14V10ZM5 16H13V15.45C13 14.7 12.6333 14.1042 11.9 13.6625C11.1667 13.2208 10.2 13 9 13C7.8 13 6.83333 13.2208 6.1 13.6625C5.36667 14.1042 5 14.7 5 15.45V16ZM9 12C9.55 12 10.0208 11.8042 10.4125 11.4125C10.8042 11.0208 11 10.55 11 10C11 9.45 10.8042 8.97917 10.4125 8.5875C10.0208 8.19583 9.55 8 9 8C8.45 8 7.97917 8.19583 7.5875 8.5875C7.19583 8.97917 7 9.45 7 10C7 10.55 7.19583 11.0208 7.5875 11.4125C7.97917 11.8042 8.45 12 9 12ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V6H4V18Z" />
    </svg>
  ),
  ICLogOut: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H12V21H5ZM16 17L14.625 15.55L17.175 13H9V11H17.175L14.625 8.45L16 7L21 12L16 17Z" />
    </svg>
  ),
  ICOrder: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M3.9998 20V7.1L2.0498 2.85L3.8498 2L6.1998 7.05H17.7998L20.1498 2L21.9498 2.85L19.9998 7.1V20H3.9998ZM9.9998 13H13.9998C14.2831 13 14.5206 12.9042 14.7123 12.7125C14.904 12.5208 14.9998 12.2833 14.9998 12C14.9998 11.7167 14.904 11.4792 14.7123 11.2875C14.5206 11.0958 14.2831 11 13.9998 11H9.9998C9.71647 11 9.47897 11.0958 9.2873 11.2875C9.09564 11.4792 8.9998 11.7167 8.9998 12C8.9998 12.2833 9.09564 12.5208 9.2873 12.7125C9.47897 12.9042 9.71647 13 9.9998 13ZM5.9998 18H17.9998V9.05H5.9998V18Z" />
    </svg>
  ),
  ICModule: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M9.16667 16.1876V10.4792L4.16667 7.58342V13.2917L9.16667 16.1876ZM10.8333 16.1876L15.8333 13.2917V7.58342L10.8333 10.4792V16.1876ZM10 9.04175L14.9375 6.18758L10 3.33341L5.0625 6.18758L10 9.04175ZM3.33333 14.7501C3.06944 14.5973 2.86458 14.3959 2.71875 14.1459C2.57292 13.8959 2.5 13.6181 2.5 13.3126V6.68758C2.5 6.38203 2.57292 6.10425 2.71875 5.85425C2.86458 5.60425 3.06944 5.40286 3.33333 5.25008L9.16667 1.89591C9.43056 1.74314 9.70833 1.66675 10 1.66675C10.2917 1.66675 10.5694 1.74314 10.8333 1.89591L16.6667 5.25008C16.9306 5.40286 17.1354 5.60425 17.2812 5.85425C17.4271 6.10425 17.5 6.38203 17.5 6.68758V13.3126C17.5 13.6181 17.4271 13.8959 17.2812 14.1459C17.1354 14.3959 16.9306 14.5973 16.6667 14.7501L10.8333 18.1042C10.5694 18.257 10.2917 18.3334 10 18.3334C9.70833 18.3334 9.43056 18.257 9.16667 18.1042L3.33333 14.7501Z" />
    </svg>
  ),
  ICDiscount: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M11.15 22C10.9 22 10.65 21.95 10.4 21.85C10.15 21.75 9.925 21.6 9.725 21.4L2.575 14.25C2.375 14.05 2.22917 13.8292 2.1375 13.5875C2.04583 13.3458 2 13.1 2 12.85C2 12.6 2.04583 12.35 2.1375 12.1C2.22917 11.85 2.375 11.625 2.575 11.425L11.375 2.6C11.5583 2.41667 11.775 2.27083 12.025 2.1625C12.275 2.05417 12.5333 2 12.8 2H19.975C20.525 2 20.9958 2.19583 21.3875 2.5875C21.7792 2.97917 21.975 3.45 21.975 4V11.175C21.975 11.4417 21.925 11.6958 21.825 11.9375C21.725 12.1792 21.5833 12.3917 21.4 12.575L12.575 21.4C12.375 21.6 12.15 21.75 11.9 21.85C11.65 21.95 11.4 22 11.15 22ZM11.15 20L19.975 11.15V4H12.825L4 12.85L11.15 20ZM17.475 8C17.8917 8 18.2458 7.85417 18.5375 7.5625C18.8292 7.27083 18.975 6.91667 18.975 6.5C18.975 6.08333 18.8292 5.72917 18.5375 5.4375C18.2458 5.14583 17.8917 5 17.475 5C17.0583 5 16.7042 5.14583 16.4125 5.4375C16.1208 5.72917 15.975 6.08333 15.975 6.5C15.975 6.91667 16.1208 7.27083 16.4125 7.5625C16.7042 7.85417 17.0583 8 17.475 8Z" />
    </svg>
  ),
  ICPercentDiscount: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M8.00004 14.6663C7.73337 14.6663 7.47782 14.6163 7.23337 14.5163C6.98893 14.4163 6.77226 14.2719 6.58337 14.083C6.26115 13.7608 5.98337 13.5497 5.75004 13.4497C5.51671 13.3497 5.16671 13.2997 4.70004 13.2997C4.14448 13.2997 3.67226 13.1052 3.28337 12.7163C2.89449 12.3275 2.70004 11.8552 2.70004 11.2997C2.70004 10.833 2.65004 10.483 2.55004 10.2497C2.45004 10.0163 2.23893 9.73856 1.91671 9.41634C1.72782 9.22745 1.58337 9.01079 1.48337 8.76634C1.38337 8.5219 1.33337 8.26634 1.33337 7.99967C1.33337 7.73301 1.38337 7.47745 1.48337 7.23301C1.58337 6.98856 1.72782 6.7719 1.91671 6.58301C2.23893 6.26079 2.45004 5.98301 2.55004 5.74967C2.65004 5.51634 2.70004 5.16634 2.70004 4.69967C2.70004 4.14412 2.89449 3.6719 3.28337 3.28301C3.67226 2.89412 4.14448 2.69967 4.70004 2.69967C5.16671 2.69967 5.51671 2.64967 5.75004 2.54967C5.98337 2.44967 6.26115 2.23856 6.58337 1.91634C6.77226 1.72745 6.98893 1.58301 7.23337 1.48301C7.47782 1.38301 7.73337 1.33301 8.00004 1.33301C8.26671 1.33301 8.52226 1.38301 8.76671 1.48301C9.01115 1.58301 9.22782 1.72745 9.41671 1.91634C9.73893 2.23856 10.0167 2.44967 10.25 2.54967C10.4834 2.64967 10.8334 2.69967 11.3 2.69967C11.8556 2.69967 12.3278 2.89412 12.7167 3.28301C13.1056 3.6719 13.3 4.14412 13.3 4.69967C13.3 5.16634 13.35 5.51634 13.45 5.74967C13.55 5.98301 13.7612 6.26079 14.0834 6.58301C14.2723 6.7719 14.4167 6.98856 14.5167 7.23301C14.6167 7.47745 14.6667 7.73301 14.6667 7.99967C14.6667 8.26634 14.6167 8.5219 14.5167 8.76634C14.4167 9.01079 14.2723 9.22745 14.0834 9.41634C13.7612 9.73856 13.55 10.0163 13.45 10.2497C13.35 10.483 13.3 10.833 13.3 11.2997C13.3 11.8552 13.1056 12.3275 12.7167 12.7163C12.3278 13.1052 11.8556 13.2997 11.3 13.2997C10.8334 13.2997 10.4834 13.3497 10.25 13.4497C10.0167 13.5497 9.73893 13.7608 9.41671 14.083C9.22782 14.2719 9.01115 14.4163 8.76671 14.5163C8.52226 14.6163 8.26671 14.6663 8.00004 14.6663ZM8.00004 13.333C8.08893 13.333 8.17504 13.3136 8.25837 13.2747C8.34171 13.2358 8.41115 13.1886 8.46671 13.133C8.92226 12.6775 9.35004 12.3691 9.75004 12.208C10.15 12.0469 10.6667 11.9663 11.3 11.9663C11.4889 11.9663 11.6473 11.9025 11.775 11.7747C11.9028 11.6469 11.9667 11.4886 11.9667 11.2997C11.9667 10.6552 12.0473 10.1358 12.2084 9.74134C12.3695 9.3469 12.6778 8.9219 13.1334 8.46634C13.2667 8.33301 13.3334 8.17745 13.3334 7.99967C13.3334 7.8219 13.2667 7.66634 13.1334 7.53301C12.6778 7.07745 12.3695 6.64967 12.2084 6.24967C12.0473 5.84967 11.9667 5.33301 11.9667 4.69967C11.9667 4.51079 11.9028 4.35245 11.775 4.22467C11.6473 4.0969 11.4889 4.03301 11.3 4.03301C10.6556 4.03301 10.1362 3.95245 9.74171 3.79134C9.34726 3.63023 8.92226 3.3219 8.46671 2.86634C8.41115 2.81079 8.34171 2.76356 8.25837 2.72467C8.17504 2.68579 8.08893 2.66634 8.00004 2.66634C7.91115 2.66634 7.82504 2.68579 7.74171 2.72467C7.65837 2.76356 7.58893 2.81079 7.53337 2.86634C7.07782 3.3219 6.65004 3.63023 6.25004 3.79134C5.85004 3.95245 5.33337 4.03301 4.70004 4.03301C4.51115 4.03301 4.35282 4.0969 4.22504 4.22467C4.09726 4.35245 4.03337 4.51079 4.03337 4.69967C4.03337 5.34412 3.95282 5.86356 3.79171 6.25801C3.6306 6.65245 3.32226 7.07745 2.86671 7.53301C2.73337 7.66634 2.66671 7.8219 2.66671 7.99967C2.66671 8.17745 2.73337 8.33301 2.86671 8.46634C3.32226 8.9219 3.6306 9.34967 3.79171 9.74967C3.95282 10.1497 4.03337 10.6663 4.03337 11.2997C4.03337 11.4886 4.09726 11.6469 4.22504 11.7747C4.35282 11.9025 4.51115 11.9663 4.70004 11.9663C5.34448 11.9663 5.86393 12.0469 6.25837 12.208C6.65282 12.3691 7.07782 12.6775 7.53337 13.133C7.58893 13.1886 7.65837 13.2358 7.74171 13.2747C7.82504 13.3136 7.91115 13.333 8.00004 13.333ZM9.66671 10.6663C9.94448 10.6663 10.1806 10.5691 10.375 10.3747C10.5695 10.1802 10.6667 9.94412 10.6667 9.66634C10.6667 9.38856 10.5695 9.15245 10.375 8.95801C10.1806 8.76356 9.94448 8.66634 9.66671 8.66634C9.38893 8.66634 9.15282 8.76356 8.95837 8.95801C8.76393 9.15245 8.66671 9.38856 8.66671 9.66634C8.66671 9.94412 8.76393 10.1802 8.95837 10.3747C9.15282 10.5691 9.38893 10.6663 9.66671 10.6663ZM6.30004 10.633L10.6334 6.29967L9.70004 5.36634L5.36671 9.69967L6.30004 10.633ZM7.04171 7.04134C7.23615 6.8469 7.33337 6.61079 7.33337 6.33301C7.33337 6.05523 7.23615 5.81912 7.04171 5.62467C6.84726 5.43023 6.61115 5.33301 6.33337 5.33301C6.0556 5.33301 5.81948 5.43023 5.62504 5.62467C5.4306 5.81912 5.33337 6.05523 5.33337 6.33301C5.33337 6.61079 5.4306 6.8469 5.62504 7.04134C5.81948 7.23579 6.0556 7.33301 6.33337 7.33301C6.61115 7.33301 6.84726 7.23579 7.04171 7.04134Z" />
    </svg>
  ),
  ICVoucher: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 14 11"
      fill="currentColor"
    >
      <path d="M6.66667 8.66667C6.85556 8.66667 7.01389 8.60278 7.14167 8.475C7.26944 8.34722 7.33333 8.18889 7.33333 8C7.33333 7.81111 7.26944 7.65278 7.14167 7.525C7.01389 7.39722 6.85556 7.33333 6.66667 7.33333C6.47778 7.33333 6.31944 7.39722 6.19167 7.525C6.06389 7.65278 6 7.81111 6 8C6 8.18889 6.06389 8.34722 6.19167 8.475C6.31944 8.60278 6.47778 8.66667 6.66667 8.66667ZM6.66667 6C6.85556 6 7.01389 5.93611 7.14167 5.80833C7.26944 5.68056 7.33333 5.52222 7.33333 5.33333C7.33333 5.14444 7.26944 4.98611 7.14167 4.85833C7.01389 4.73056 6.85556 4.66667 6.66667 4.66667C6.47778 4.66667 6.31944 4.73056 6.19167 4.85833C6.06389 4.98611 6 5.14444 6 5.33333C6 5.52222 6.06389 5.68056 6.19167 5.80833C6.31944 5.93611 6.47778 6 6.66667 6ZM6.66667 3.33333C6.85556 3.33333 7.01389 3.26944 7.14167 3.14167C7.26944 3.01389 7.33333 2.85556 7.33333 2.66667C7.33333 2.47778 7.26944 2.31944 7.14167 2.19167C7.01389 2.06389 6.85556 2 6.66667 2C6.47778 2 6.31944 2.06389 6.19167 2.19167C6.06389 2.31944 6 2.47778 6 2.66667C6 2.85556 6.06389 3.01389 6.19167 3.14167C6.31944 3.26944 6.47778 3.33333 6.66667 3.33333ZM12 10.6667H1.33333C0.966667 10.6667 0.652778 10.5361 0.391667 10.275C0.130556 10.0139 0 9.7 0 9.33333V6.66667C0.366667 6.66667 0.680556 6.53611 0.941667 6.275C1.20278 6.01389 1.33333 5.7 1.33333 5.33333C1.33333 4.96667 1.20278 4.65278 0.941667 4.39167C0.680556 4.13056 0.366667 4 0 4V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H12C12.3667 0 12.6806 0.130556 12.9417 0.391667C13.2028 0.652778 13.3333 0.966667 13.3333 1.33333V4C12.9667 4 12.6528 4.13056 12.3917 4.39167C12.1306 4.65278 12 4.96667 12 5.33333C12 5.7 12.1306 6.01389 12.3917 6.275C12.6528 6.53611 12.9667 6.66667 13.3333 6.66667V9.33333C13.3333 9.7 13.2028 10.0139 12.9417 10.275C12.6806 10.5361 12.3667 10.6667 12 10.6667ZM12 9.33333V7.63333C11.5889 7.38889 11.2639 7.06389 11.025 6.65833C10.7861 6.25278 10.6667 5.81111 10.6667 5.33333C10.6667 4.85556 10.7861 4.41389 11.025 4.00833C11.2639 3.60278 11.5889 3.27778 12 3.03333V1.33333H1.33333V3.03333C1.74444 3.27778 2.06944 3.60278 2.30833 4.00833C2.54722 4.41389 2.66667 4.85556 2.66667 5.33333C2.66667 5.81111 2.54722 6.25278 2.30833 6.65833C2.06944 7.06389 1.74444 7.38889 1.33333 7.63333V9.33333H12Z" />
    </svg>
  ),
  ICAttribute: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M4.4 21C4.08333 20.9333 3.7875 20.7625 3.5125 20.4875C3.2375 20.2125 3.06667 19.9167 3 19.6L19.6 3C19.95 3.08333 20.25 3.25417 20.5 3.5125C20.75 3.77083 20.925 4.06667 21.025 4.4L4.4 21ZM3 14.7V11.9L11.9 3H14.7L3 14.7ZM3 7V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H7L3 7ZM17 21L21 17V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H17ZM9.3 21L21 9.3V12.1L12.1 21H9.3Z" />
    </svg>
  ),
  ICUser: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 20V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333 18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V20H4ZM6 18H18V17.2C18 17.0167 17.9542 16.85 17.8625 16.7C17.7708 16.55 17.65 16.4333 17.5 16.35C16.6 15.9 15.6917 15.5625 14.775 15.3375C13.8583 15.1125 12.9333 15 12 15C11.0667 15 10.1417 15.1125 9.225 15.3375C8.30833 15.5625 7.4 15.9 6.5 16.35C6.35 16.4333 6.22917 16.55 6.1375 16.7C6.04583 16.85 6 17.0167 6 17.2V18ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875 9.4125C10.9792 9.80417 11.45 10 12 10Z" />
    </svg>
  ),
  ICNews: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V3L3.675 4.675L5.325 3L7 4.675L8.675 3L10.325 4.675L12 3L13.675 4.675L15.325 3L17 4.675L18.675 3L20.325 4.675L22 3V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H11V13H4V19ZM13 19H20V17H13V19ZM13 15H20V13H13V15ZM4 11H20V8H4V11Z" />
    </svg>
  ),
  ICDoubleArrowLeft: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M8.25 13.5L3.75 9L8.25 4.5L9.3 5.55L5.86875 9L9.3 12.45L8.25 13.5ZM13.2 13.5L8.7 9L13.2 4.5L14.25 5.55L10.8188 9L14.25 12.45L13.2 13.5Z" />
    </svg>
  ),
  ICPrev: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M9.33333 12L5.33333 8L9.33333 4L10.2667 4.93333L7.2 8L10.2667 11.0667L9.33333 12Z" />
    </svg>
  ),
  ICNext: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M8.4 8L5.33333 4.93333L6.26666 4L10.2667 8L6.26666 12L5.33333 11.0667L8.4 8Z" />
    </svg>
  ),
  ICExpandMore: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M8 10.25L4 6.24998L4.93333 5.31665L8 8.38332L11.0667 5.31665L12 6.24998L8 10.25Z" />
    </svg>
  ),
  ICExpandLess: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M4.93333 10.25L4 9.31667L8 5.31667L12 9.31667L11.0667 10.25L8 7.18333L4.93333 10.25Z" />
    </svg>
  ),
  ICBell: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z" />
    </svg>
  ),
  ICSetting: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M9.25001 22L8.85001 18.8C8.63335 18.7167 8.42918 18.6167 8.23751 18.5C8.04585 18.3833 7.85835 18.2583 7.67501 18.125L4.70001 19.375L1.95001 14.625L4.52501 12.675C4.50835 12.5583 4.50001 12.4458 4.50001 12.3375V11.6625C4.50001 11.5542 4.50835 11.4417 4.52501 11.325L1.95001 9.375L4.70001 4.625L7.67501 5.875C7.85835 5.74167 8.05001 5.61667 8.25001 5.5C8.45001 5.38333 8.65001 5.28333 8.85001 5.2L9.25001 2H14.75L15.15 5.2C15.3667 5.28333 15.5708 5.38333 15.7625 5.5C15.9542 5.61667 16.1417 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4917 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1417 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.25001ZM11 20H12.975L13.325 17.35C13.8417 17.2167 14.3208 17.0208 14.7625 16.7625C15.2042 16.5042 15.6083 16.1917 15.975 15.825L18.45 16.85L19.425 15.15L17.275 13.525C17.3583 13.2917 17.4167 13.0458 17.45 12.7875C17.4833 12.5292 17.5 12.2667 17.5 12C17.5 11.7333 17.4833 11.4708 17.45 11.2125C17.4167 10.9542 17.3583 10.7083 17.275 10.475L19.425 8.85L18.45 7.15L15.975 8.2C15.6083 7.81667 15.2042 7.49583 14.7625 7.2375C14.3208 6.97917 13.8417 6.78333 13.325 6.65L13 4H11.025L10.675 6.65C10.1583 6.78333 9.67918 6.97917 9.23751 7.2375C8.79585 7.49583 8.39168 7.80833 8.02501 8.175L5.55001 7.15L4.57501 8.85L6.72501 10.45C6.64168 10.7 6.58335 10.95 6.55001 11.2C6.51668 11.45 6.50001 11.7167 6.50001 12C6.50001 12.2667 6.51668 12.525 6.55001 12.775C6.58335 13.025 6.64168 13.275 6.72501 13.525L4.57501 15.15L5.55001 16.85L8.02501 15.8C8.39168 16.1833 8.79585 16.5042 9.23751 16.7625C9.67918 17.0208 10.1583 17.2167 10.675 17.35L11 20ZM12.05 15.5C13.0167 15.5 13.8417 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8417 8.84167 13.0167 8.5 12.05 8.5C11.0667 8.5 10.2375 8.84167 9.56251 9.525C8.88751 10.2083 8.55001 11.0333 8.55001 12C8.55001 12.9667 8.88751 13.7917 9.56251 14.475C10.2375 15.1583 11.0667 15.5 12.05 15.5Z" />
    </svg>
  ),
  ICAdd: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      role="img"
      aria-label="Add icon"
      fill="currentColor"
    >
      <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" />
    </svg>
  ),
  ICAddCircle: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M8.25 12.75H9.75V9.75H12.75V8.25H9.75V5.25H8.25V8.25H5.25V9.75H8.25V12.75ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69688 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69688 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69688 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69688 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9 15C10.675 15 12.0938 14.4188 13.2563 13.2563C14.4188 12.0938 15 10.675 15 9C15 7.325 14.4188 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0938 4.74375 13.2563C5.90625 14.4188 7.325 15 9 15Z" />
    </svg>
  ),
  ICAddImage: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M6.66667 28C5.93333 28 5.30556 27.7389 4.78333 27.2167C4.26111 26.6944 4 26.0667 4 25.3333V6.66667C4 5.93333 4.26111 5.30556 4.78333 4.78333C5.30556 4.26111 5.93333 4 6.66667 4H18.6667V6.66667H6.66667V25.3333H25.3333V13.3333H28V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H6.66667ZM22.6667 12V9.33333H20V6.66667H22.6667V4H25.3333V6.66667H28V9.33333H25.3333V12H22.6667ZM8 22.6667H24L19 16L15 21.3333L12 17.3333L8 22.6667Z"
        fill="#ACACAC"
      />
    </svg>
  ),
  ICRemove: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M3.3335 8.66634V7.33301H12.6668V8.66634H3.3335Z" />
    </svg>
  ),
  ICSave: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M21 7V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H17L21 7ZM19 7.85L16.15 5H5V19H19V7.85ZM12 18C12.8333 18 13.5417 17.7083 14.125 17.125C14.7083 16.5417 15 15.8333 15 15C15 14.1667 14.7083 13.4583 14.125 12.875C13.5417 12.2917 12.8333 12 12 12C11.1667 12 10.4583 12.2917 9.875 12.875C9.29167 13.4583 9 14.1667 9 15C9 15.8333 9.29167 16.5417 9.875 17.125C10.4583 17.7083 11.1667 18 12 18ZM6 10H15V6H6V10ZM5 7.85V19V5V7.85Z" />
    </svg>
  ),
  ICSaveAs: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H17L21 7V12.3C20.6833 12.1667 20.3542 12.0792 20.0125 12.0375C19.6708 11.9958 19.3333 12 19 12.05V7.825L16.175 5H5V19H11V21H5ZM13 23V19.925L18.525 14.425C18.675 14.275 18.8417 14.1667 19.025 14.1C19.2083 14.0333 19.3917 14 19.575 14C19.775 14 19.9667 14.0375 20.15 14.1125C20.3333 14.1875 20.5 14.3 20.65 14.45L21.575 15.375C21.7083 15.525 21.8125 15.6917 21.8875 15.875C21.9625 16.0583 22 16.2417 22 16.425C22 16.6083 21.9667 16.7958 21.9 16.9875C21.8333 17.1792 21.725 17.35 21.575 17.5L16.075 23H13ZM14.5 21.5H15.45L18.475 18.45L18.025 17.975L17.55 17.525L14.5 20.55V21.5ZM18.025 17.975L17.55 17.525L18.475 18.45L18.025 17.975ZM6 10H15V6H6V10ZM12 18H12.1L15 15.125V15C15 14.1667 14.7083 13.4583 14.125 12.875C13.5417 12.2917 12.8333 12 12 12C11.1667 12 10.4583 12.2917 9.875 12.875C9.29167 13.4583 9 14.1667 9 15C9 15.8333 9.29167 16.5417 9.875 17.125C10.4583 17.7083 11.1667 18 12 18Z" />
    </svg>
  ),
  ICLibrary: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M10 14H14V12H10V14ZM10 11H18V9H10V11ZM10 8H18V6H10V8ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6H4V20H18V22H4Z" />
    </svg>
  ),
  ICImage: () => (
    <svg
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19ZM6 17H18L14.25 12L11.25 16L9 13L6 17ZM8.5 10C8.91667 10 9.27083 9.85417 9.5625 9.5625C9.85417 9.27083 10 8.91667 10 8.5C10 8.08333 9.85417 7.72917 9.5625 7.4375C9.27083 7.14583 8.91667 7 8.5 7C8.08333 7 7.72917 7.14583 7.4375 7.4375C7.14583 7.72917 7 8.08333 7 8.5C7 8.91667 7.14583 9.27083 7.4375 9.5625C7.72917 9.85417 8.08333 10 8.5 10Z" />
    </svg>
  ),
  ICHome: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M5.00065 15.8333H7.50065V10.8333H12.5007V15.8333H15.0007V8.33333L10.0007 4.58333L5.00065 8.33333V15.8333ZM3.33398 17.5V7.5L10.0007 2.5L16.6673 7.5V17.5H10.834V12.5H9.16732V17.5H3.33398Z" />
    </svg>
  ),
  ICAccount: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M5.85 17.1C6.7 16.45 7.65 15.9375 8.7 15.5625C9.75 15.1875 10.85 15 12 15C13.15 15 14.25 15.1875 15.3 15.5625C16.35 15.9375 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1875 15.6417 19.5125 14.775C19.8375 13.9083 20 12.9833 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 12.9833 4.1625 13.9083 4.4875 14.775C4.8125 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.8708 14.5 19.6125C15.2833 19.3542 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6458 14.5 17.3875C13.7167 17.1292 12.8833 17 12 17C11.1167 17 10.2833 17.1292 9.5 17.3875C8.71667 17.6458 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3542 9.5 19.6125C10.2833 19.8708 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z" />
    </svg>
  ),
  ICLink: () => (
    <svg
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.3335 11.3337H4.66683C3.74461 11.3337 2.9585 11.0087 2.3085 10.3587C1.6585 9.70866 1.3335 8.92255 1.3335 8.00033C1.3335 7.0781 1.6585 6.29199 2.3085 5.64199C2.9585 4.99199 3.74461 4.66699 4.66683 4.66699H7.3335V6.00033H4.66683C4.11127 6.00033 3.63905 6.19477 3.25016 6.58366C2.86127 6.97255 2.66683 7.44477 2.66683 8.00033C2.66683 8.55588 2.86127 9.0281 3.25016 9.41699C3.63905 9.80588 4.11127 10.0003 4.66683 10.0003H7.3335V11.3337ZM5.3335 8.66699V7.33366H10.6668V8.66699H5.3335ZM8.66683 11.3337V10.0003H11.3335C11.8891 10.0003 12.3613 9.80588 12.7502 9.41699C13.1391 9.0281 13.3335 8.55588 13.3335 8.00033C13.3335 7.44477 13.1391 6.97255 12.7502 6.58366C12.3613 6.19477 11.8891 6.00033 11.3335 6.00033H8.66683V4.66699H11.3335C12.2557 4.66699 13.0418 4.99199 13.6918 5.64199C14.3418 6.29199 14.6668 7.0781 14.6668 8.00033C14.6668 8.92255 14.3418 9.70866 13.6918 10.3587C13.0418 11.0087 12.2557 11.3337 11.3335 11.3337H8.66683Z"
        fill="#565E64"
      />
    </svg>
  ),
  ICAddToCart: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M9.16683 7.49992V4.99992H6.66683V3.33325H9.16683V0.833252H10.8335V3.33325H13.3335V4.99992H10.8335V7.49992H9.16683ZM5.8335 18.3333C5.37516 18.3333 4.9828 18.1701 4.65641 17.8437C4.33002 17.5173 4.16683 17.1249 4.16683 16.6666C4.16683 16.2083 4.33002 15.8159 4.65641 15.4895C4.9828 15.1631 5.37516 14.9999 5.8335 14.9999C6.29183 14.9999 6.68419 15.1631 7.01058 15.4895C7.33697 15.8159 7.50016 16.2083 7.50016 16.6666C7.50016 17.1249 7.33697 17.5173 7.01058 17.8437C6.68419 18.1701 6.29183 18.3333 5.8335 18.3333ZM14.1668 18.3333C13.7085 18.3333 13.3161 18.1701 12.9897 17.8437C12.6634 17.5173 12.5002 17.1249 12.5002 16.6666C12.5002 16.2083 12.6634 15.8159 12.9897 15.4895C13.3161 15.1631 13.7085 14.9999 14.1668 14.9999C14.6252 14.9999 15.0175 15.1631 15.3439 15.4895C15.6703 15.8159 15.8335 16.2083 15.8335 16.6666C15.8335 17.1249 15.6703 17.5173 15.3439 17.8437C15.0175 18.1701 14.6252 18.3333 14.1668 18.3333ZM0.833496 3.33325V1.66659H3.56266L7.10433 9.16659H12.9377L16.1877 3.33325H18.0835L14.4168 9.95825C14.2641 10.236 14.0592 10.4513 13.8022 10.6041C13.5453 10.7569 13.2641 10.8333 12.9585 10.8333H6.75016L5.8335 12.4999H15.8335V14.1666H5.8335C5.2085 14.1666 4.7328 13.8958 4.40641 13.3541C4.08002 12.8124 4.06961 12.2638 4.37516 11.7083L5.50016 9.66659L2.50016 3.33325H0.833496Z" />
    </svg>
  ),
  ICPrice: ({ width, height }) => (
    <svg
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M11.1 19H12.85V17.75C13.6833 17.6 14.4 17.275 15 16.775C15.6 16.275 15.9 15.5333 15.9 14.55C15.9 13.85 15.7 13.2083 15.3 12.625C14.9 12.0417 14.1 11.5333 12.9 11.1C11.9 10.7667 11.2083 10.475 10.825 10.225C10.4417 9.975 10.25 9.63333 10.25 9.2C10.25 8.76667 10.4042 8.425 10.7125 8.175C11.0208 7.925 11.4667 7.8 12.05 7.8C12.5833 7.8 13 7.92917 13.3 8.1875C13.6 8.44583 13.8167 8.76667 13.95 9.15L15.55 8.5C15.3667 7.91667 15.0292 7.40833 14.5375 6.975C14.0458 6.54167 13.5 6.3 12.9 6.25V5H11.15V6.25C10.3167 6.43333 9.66667 6.8 9.2 7.35C8.73333 7.9 8.5 8.51667 8.5 9.2C8.5 9.98333 8.72917 10.6167 9.1875 11.1C9.64583 11.5833 10.3667 12 11.35 12.35C12.4 12.7333 13.1292 13.075 13.5375 13.375C13.9458 13.675 14.15 14.0667 14.15 14.55C14.15 15.1 13.9542 15.5042 13.5625 15.7625C13.1708 16.0208 12.7 16.15 12.15 16.15C11.6 16.15 11.1125 15.9792 10.6875 15.6375C10.2625 15.2958 9.95 14.7833 9.75 14.1L8.1 14.75C8.33333 15.55 8.69583 16.1958 9.1875 16.6875C9.67917 17.1792 10.3167 17.5167 11.1 17.7V19ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />
    </svg>
  ),
  ICUpload: () => (
    <svg
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 14"
      fill="currentColor"
    >
      <path d="M6.91634 9.33301V4.57884L5.39967 6.09551L4.58301 5.24967L7.49967 2.33301L10.4163 5.24967L9.59967 6.09551L8.08301 4.57884V9.33301H6.91634ZM3.99967 11.6663C3.67884 11.6663 3.40419 11.5521 3.17572 11.3236C2.94724 11.0952 2.83301 10.8205 2.83301 10.4997V8.74967H3.99967V10.4997H10.9997V8.74967H12.1663V10.4997C12.1663 10.8205 12.0521 11.0952 11.8236 11.3236C11.5952 11.5521 11.3205 11.6663 10.9997 11.6663H3.99967Z" />
    </svg>
  ),
  ICConstruction: () => (
    <svg
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
    >
      <path d="M31.5 35.0007L22.375 25.8757L25.875 22.3757L35 31.5007L31.5 35.0007ZM8.49999 35.0007L4.99999 31.5007L16.5 20.0007L13.6667 17.1673L12.5 18.334L10.375 16.209V19.6257L9.20832 20.7923L4.16666 15.7507L5.33332 14.584H8.74999L6.66666 12.5007L12.5833 6.58398C13.1389 6.02843 13.7361 5.62565 14.375 5.37565C15.0139 5.12565 15.6667 5.00065 16.3333 5.00065C17 5.00065 17.6528 5.12565 18.2917 5.37565C18.9305 5.62565 19.5278 6.02843 20.0833 6.58398L16.25 10.4173L18.3333 12.5007L17.1667 13.6673L20 16.5007L23.75 12.7507C23.6389 12.4451 23.5486 12.1257 23.4792 11.7923C23.4097 11.459 23.375 11.1257 23.375 10.7923C23.375 9.15343 23.9375 7.77148 25.0625 6.64648C26.1875 5.52148 27.5694 4.95898 29.2083 4.95898C29.625 4.95898 30.0208 5.00065 30.3958 5.08398C30.7708 5.16732 31.1528 5.29232 31.5417 5.45898L27.4167 9.58398L30.4167 12.584L34.5417 8.45898C34.7361 8.84787 34.868 9.22982 34.9375 9.60482C35.0069 9.97982 35.0417 10.3757 35.0417 10.7923C35.0417 12.4312 34.4792 13.8132 33.3542 14.9382C32.2292 16.0632 30.8472 16.6257 29.2083 16.6257C28.875 16.6257 28.5417 16.5979 28.2083 16.5423C27.875 16.4868 27.5555 16.3895 27.25 16.2507L8.49999 35.0007Z" />
    </svg>
  ),
  ICEdit: ({ className }) => (
    <svg
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      className={className}
      fill="currentColor"
    >
      <path d="M3.75 15.7492C3.3375 15.7492 2.98438 15.6023 2.69063 15.3086C2.39687 15.0148 2.25 14.6617 2.25 14.2492V3.74922C2.25 3.33672 2.39687 2.98359 2.69063 2.68984C2.98438 2.39609 3.3375 2.24922 3.75 2.24922H10.4438L8.94375 3.74922H3.75V14.2492H14.25V9.03672L15.75 7.53672V14.2492C15.75 14.6617 15.6031 15.0148 15.3094 15.3086C15.0156 15.6023 14.6625 15.7492 14.25 15.7492H3.75ZM6.75 11.2492V8.06172L13.6313 1.18047C13.7813 1.03047 13.95 0.917969 14.1375 0.842969C14.325 0.767969 14.5125 0.730469 14.7 0.730469C14.9 0.730469 15.0906 0.767969 15.2719 0.842969C15.4531 0.917969 15.6188 1.03047 15.7688 1.18047L16.8188 2.24922C16.9563 2.39922 17.0625 2.56484 17.1375 2.74609C17.2125 2.92734 17.25 3.11172 17.25 3.29922C17.25 3.48672 17.2156 3.67109 17.1469 3.85234C17.0781 4.03359 16.9688 4.19922 16.8188 4.34922L9.9375 11.2492H6.75ZM8.25 9.74922H9.3L13.65 5.39922L13.125 4.87422L12.5813 4.34922L8.25 8.68047V9.74922Z" />
    </svg>
  ),
  ICEditText: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 25 24"
      fill="currentColor"
    >
      <path d="M5.12122 19H6.54622L16.3212 9.225L14.8962 7.8L5.12122 17.575V19ZM3.12122 21V16.75L16.3212 3.575C16.5212 3.39167 16.742 3.25 16.9837 3.15C17.2254 3.05 17.4795 3 17.7462 3C18.0129 3 18.2712 3.05 18.5212 3.15C18.7712 3.25 18.9879 3.4 19.1712 3.6L20.5462 5C20.7462 5.18333 20.892 5.4 20.9837 5.65C21.0754 5.9 21.1212 6.15 21.1212 6.4C21.1212 6.66667 21.0754 6.92083 20.9837 7.1625C20.892 7.40417 20.7462 7.625 20.5462 7.825L7.37122 21H3.12122ZM15.5962 8.525L14.8962 7.8L16.3212 9.225L15.5962 8.525Z" />
    </svg>
  ),
  ICDelete: ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      className={className}
      fill="currentColor"
    >
      <path d="M5.83594 17.5C5.3776 17.5 4.98524 17.3368 4.65885 17.0104C4.33247 16.684 4.16927 16.2917 4.16927 15.8333V5H3.33594V3.33333H7.5026V2.5H12.5026V3.33333H16.6693V5H15.8359V15.8333C15.8359 16.2917 15.6727 16.684 15.3464 17.0104C15.02 17.3368 14.6276 17.5 14.1693 17.5H5.83594ZM14.1693 5H5.83594V15.8333H14.1693V5ZM7.5026 14.1667H9.16927V6.66667H7.5026V14.1667ZM10.8359 14.1667H12.5026V6.66667H10.8359V14.1667Z" />
    </svg>
  ),
  ICDoorSetting: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="currentColor"
    >
      <path d="M11.6667 0C12.125 0 12.517 0.16352 12.8434 0.489909C13.1698 0.816298 13.3333 1.20833 13.3333 1.66667V7.22819C12.8153 6.98208 12.2551 6.81107 11.6667 6.72689V1.66667H1.66667V15H5.56234C5.8592 15.6248 6.26369 16.1882 6.75212 16.6667H0V1.66667C0 1.20833 0.16352 0.816298 0.489909 0.489909C0.816298 0.16352 1.20833 0 1.66667 0H11.6667Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.792 9.58333C11.9586 9.65275 12.115 9.72954 12.2607 9.81283C12.4065 9.89612 12.5557 10.0004 12.7083 10.1253L13.9168 9.70866L14.7502 11.167L13.7915 12.0003C13.8193 12.1669 13.833 12.3407 13.833 12.5212C13.833 12.7016 13.8193 12.8754 13.7915 13.042L14.7502 13.8753L13.9168 15.2913L12.7083 14.917C12.5557 15.028 12.4064 15.1214 12.2607 15.1978C12.115 15.2741 11.9586 15.3473 11.792 15.4167L11.5413 16.6667H9.87467L9.62484 15.4167C9.45822 15.3472 9.30188 15.2741 9.15609 15.1978C9.0104 15.1214 8.86112 15.028 8.7085 14.917L7.5 15.2913L6.66667 13.8753L7.62533 13.042C7.59755 12.8475 7.58301 12.6667 7.58301 12.5C7.58301 12.3333 7.59755 12.1525 7.62533 11.958L6.66667 11.1247L7.5 9.70866L8.7085 10.083C8.86112 9.97203 9.0104 9.87857 9.15609 9.80225C9.30188 9.72588 9.45822 9.65276 9.62484 9.58333L9.87467 8.33333H11.5413L11.792 9.58333ZM10.708 10.8333C10.2498 10.8334 9.85756 10.9969 9.53125 11.3232C9.20497 11.6496 9.04134 12.0417 9.04134 12.5C9.04134 12.9583 9.20497 13.3504 9.53125 13.6768C9.85756 14.0031 10.2498 14.1666 10.708 14.1667C11.1663 14.1667 11.5592 14.0031 11.8856 13.6768C12.2118 13.3504 12.3747 12.9582 12.3747 12.5C12.3747 12.0418 12.2118 11.6496 11.8856 11.3232C11.5592 10.9969 11.1663 10.8333 10.708 10.8333Z"
      />
      <path d="M3.75 7.08333C4.09722 7.08333 4.39236 7.20486 4.63542 7.44792C4.87847 7.69097 5 7.98611 5 8.33333C5 8.68056 4.87847 8.97569 4.63542 9.21875C4.39236 9.46181 4.09722 9.58333 3.75 9.58333C3.40278 9.58333 3.10764 9.46181 2.86458 9.21875C2.62153 8.97569 2.5 8.68056 2.5 8.33333C2.5 7.98611 2.62153 7.69097 2.86458 7.44792C3.10764 7.20486 3.40278 7.08333 3.75 7.08333Z" />
    </svg>
  ),
  ICAlignHorizontal: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M10.8333 1.66683L10.8333 5.8335L15 5.8335L15 8.3335L10.8333 8.3335L10.8333 11.6668L17.5 11.6668L17.5 14.1668L10.8333 14.1668L10.8333 18.3335L9.16667 18.3335L9.16667 14.1668L2.5 14.1668L2.5 11.6668L9.16667 11.6668L9.16667 8.3335L5 8.3335L5 5.8335L9.16667 5.8335L9.16667 1.66683L10.8333 1.66683Z" />
    </svg>
  ),
  ICClose: () => (
    <svg
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M4.8 14.25L3.75 13.2L7.95 9L3.75 4.8L4.8 3.75L9 7.95L13.2 3.75L14.25 4.8L10.05 9L14.25 13.2L13.2 14.25L9 10.05L4.8 14.25Z" />
    </svg>
  ),
  ICError: () => (
    <svg
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="currentColor"
    >
      <path d="M24 34C24.5667 34 25.0417 33.8083 25.425 33.425C25.8083 33.0417 26 32.5667 26 32C26 31.4333 25.8083 30.9583 25.425 30.575C25.0417 30.1917 24.5667 30 24 30C23.4333 30 22.9583 30.1917 22.575 30.575C22.1917 30.9583 22 31.4333 22 32C22 32.5667 22.1917 33.0417 22.575 33.425C22.9583 33.8083 23.4333 34 24 34ZM22 26H26V14H22V26ZM24 44C21.2333 44 18.6333 43.475 16.2 42.425C13.7667 41.375 11.65 39.95 9.85 38.15C8.05 36.35 6.625 34.2333 5.575 31.8C4.525 29.3667 4 26.7667 4 24C4 21.2333 4.525 18.6333 5.575 16.2C6.625 13.7667 8.05 11.65 9.85 9.85C11.65 8.05 13.7667 6.625 16.2 5.575C18.6333 4.525 21.2333 4 24 4C26.7667 4 29.3667 4.525 31.8 5.575C34.2333 6.625 36.35 8.05 38.15 9.85C39.95 11.65 41.375 13.7667 42.425 16.2C43.475 18.6333 44 21.2333 44 24C44 26.7667 43.475 29.3667 42.425 31.8C41.375 34.2333 39.95 36.35 38.15 38.15C36.35 39.95 34.2333 41.375 31.8 42.425C29.3667 43.475 26.7667 44 24 44ZM24 40C28.4667 40 32.25 38.45 35.35 35.35C38.45 32.25 40 28.4667 40 24C40 19.5333 38.45 15.75 35.35 12.65C32.25 9.55 28.4667 8 24 8C19.5333 8 15.75 9.55 12.65 12.65C9.55 15.75 8 19.5333 8 24C8 28.4667 9.55 32.25 12.65 35.35C15.75 38.45 19.5333 40 24 40Z" />
    </svg>
  ),
  ICSub: ({ width, height }) => (
    <svg
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M14 21L12.575 19.575L16.175 16H5V4H7V14H16.175L12.575 10.4L13.975 8.975L20 15L14 21Z" />
    </svg>
  ),
  ICHumanResource2: ({ width, height }) => (
    <svg
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M0.95 10.3C0.65 9.7 0.416667 9.09167 0.25 8.475C0.0833333 7.85833 0 7.23333 0 6.6C0 4.73333 0.633333 3.16667 1.9 1.9C3.16667 0.633333 4.73333 0 6.6 0C7.65 0 8.65 0.220833 9.6 0.6625C10.55 1.10417 11.35 1.71667 12 2.5C12.65 1.71667 13.45 1.10417 14.4 0.6625C15.35 0.220833 16.35 0 17.4 0C19.2667 0 20.8333 0.633333 22.1 1.9C23.3667 3.16667 24 4.73333 24 6.6C24 7.23333 23.9167 7.85833 23.75 8.475C23.5833 9.09167 23.35 9.7 23.05 10.3C22.8667 9.98333 22.65 9.7 22.4 9.45C22.15 9.2 21.8583 9 21.525 8.85C21.675 8.46667 21.7917 8.09167 21.875 7.725C21.9583 7.35833 22 6.98333 22 6.6C22 5.3 21.5583 4.20833 20.675 3.325C19.7917 2.44167 18.7 2 17.4 2C16.05 2 15.0125 2.37083 14.2875 3.1125C13.5625 3.85417 12.8 4.68333 12 5.6C11.2 4.66667 10.4375 3.83333 9.7125 3.1C8.9875 2.36667 7.95 2 6.6 2C5.3 2 4.20833 2.44167 3.325 3.325C2.44167 4.20833 2 5.3 2 6.6C2 6.98333 2.04167 7.35833 2.125 7.725C2.20833 8.09167 2.325 8.46667 2.475 8.85C2.14167 9 1.85 9.2 1.6 9.45C1.35 9.7 1.13333 9.98333 0.95 10.3ZM0 19V17.425C0 16.6917 0.370833 16.1042 1.1125 15.6625C1.85417 15.2208 2.81667 15 4 15C4.21667 15 4.425 15.0042 4.625 15.0125C4.825 15.0208 5.01667 15.0417 5.2 15.075C4.96667 15.4083 4.79167 15.7667 4.675 16.15C4.55833 16.5333 4.5 16.9417 4.5 17.375V19H0ZM6 19V17.375C6 16.2917 6.55417 15.4167 7.6625 14.75C8.77083 14.0833 10.2167 13.75 12 13.75C13.8 13.75 15.25 14.0833 16.35 14.75C17.45 15.4167 18 16.2917 18 17.375V19H6ZM19.5 19V17.375C19.5 16.9417 19.4458 16.5333 19.3375 16.15C19.2292 15.7667 19.0667 15.4083 18.85 15.075C19.0333 15.0417 19.2208 15.0208 19.4125 15.0125C19.6042 15.0042 19.8 15 20 15C21.2 15 22.1667 15.2208 22.9 15.6625C23.6333 16.1042 24 16.6917 24 17.425V19H19.5ZM12 15.75C11.05 15.75 10.2 15.875 9.45 16.125C8.7 16.375 8.25833 16.6667 8.125 17H15.9C15.75 16.6667 15.3042 16.375 14.5625 16.125C13.8208 15.875 12.9667 15.75 12 15.75ZM4 14C3.45 14 2.97917 13.8042 2.5875 13.4125C2.19583 13.0208 2 12.55 2 12C2 11.4333 2.19583 10.9583 2.5875 10.575C2.97917 10.1917 3.45 10 4 10C4.56667 10 5.04167 10.1917 5.425 10.575C5.80833 10.9583 6 11.4333 6 12C6 12.55 5.80833 13.0208 5.425 13.4125C5.04167 13.8042 4.56667 14 4 14ZM20 14C19.45 14 18.9792 13.8042 18.5875 13.4125C18.1958 13.0208 18 12.55 18 12C18 11.4333 18.1958 10.9583 18.5875 10.575C18.9792 10.1917 19.45 10 20 10C20.5667 10 21.0417 10.1917 21.425 10.575C21.8083 10.9583 22 11.4333 22 12C22 12.55 21.8083 13.0208 21.425 13.4125C21.0417 13.8042 20.5667 14 20 14ZM12 13C11.1667 13 10.4583 12.7083 9.875 12.125C9.29167 11.5417 9 10.8333 9 10C9 9.15 9.29167 8.4375 9.875 7.8625C10.4583 7.2875 11.1667 7 12 7C12.85 7 13.5625 7.2875 14.1375 7.8625C14.7125 8.4375 15 9.15 15 10C15 10.8333 14.7125 11.5417 14.1375 12.125C13.5625 12.7083 12.85 13 12 13ZM12 9C11.7167 9 11.4792 9.09583 11.2875 9.2875C11.0958 9.47917 11 9.71667 11 10C11 10.2833 11.0958 10.5208 11.2875 10.7125C11.4792 10.9042 11.7167 11 12 11C12.2833 11 12.5208 10.9042 12.7125 10.7125C12.9042 10.5208 13 10.2833 13 10C13 9.71667 12.9042 9.47917 12.7125 9.2875C12.5208 9.09583 12.2833 9 12 9Z" />
    </svg>
  ),
  ICAddGroup: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_4762_20252)">
        <path
          d="M9.375 8.9625C9.7375 8.5625 10.0156 8.10625 10.2094 7.59375C10.4031 7.08125 10.5 6.55 10.5 6C10.5 5.45 10.4031 4.91875 10.2094 4.40625C10.0156 3.89375 9.7375 3.4375 9.375 3.0375C10.125 3.1375 10.75 3.46875 11.25 4.03125C11.75 4.59375 12 5.25 12 6C12 6.75 11.75 7.40625 11.25 7.96875C10.75 8.53125 10.125 8.8625 9.375 8.9625ZM13.5 15V12.75C13.5 12.3 13.4 11.8719 13.2 11.4656C13 11.0594 12.7375 10.7 12.4125 10.3875C13.05 10.6125 13.6406 10.9031 14.1844 11.2594C14.7281 11.6156 15 12.1125 15 12.75V15H13.5ZM15 9.75V8.25H13.5V6.75H15V5.25H16.5V6.75H18V8.25H16.5V9.75H15ZM6 9C5.175 9 4.46875 8.70625 3.88125 8.11875C3.29375 7.53125 3 6.825 3 6C3 5.175 3.29375 4.46875 3.88125 3.88125C4.46875 3.29375 5.175 3 6 3C6.825 3 7.53125 3.29375 8.11875 3.88125C8.70625 4.46875 9 5.175 9 6C9 6.825 8.70625 7.53125 8.11875 8.11875C7.53125 8.70625 6.825 9 6 9ZM0 15V12.9C0 12.475 0.109375 12.0844 0.328125 11.7281C0.546875 11.3719 0.8375 11.1 1.2 10.9125C1.975 10.525 2.7625 10.2344 3.5625 10.0406C4.3625 9.84688 5.175 9.75 6 9.75C6.825 9.75 7.6375 9.84688 8.4375 10.0406C9.2375 10.2344 10.025 10.525 10.8 10.9125C11.1625 11.1 11.4531 11.3719 11.6719 11.7281C11.8906 12.0844 12 12.475 12 12.9V15H0ZM6 7.5C6.4125 7.5 6.76563 7.35313 7.05938 7.05938C7.35313 6.76563 7.5 6.4125 7.5 6C7.5 5.5875 7.35313 5.23438 7.05938 4.94063C6.76563 4.64688 6.4125 4.5 6 4.5C5.5875 4.5 5.23438 4.64688 4.94063 4.94063C4.64688 5.23438 4.5 5.5875 4.5 6C4.5 6.4125 4.64688 6.76563 4.94063 7.05938C5.23438 7.35313 5.5875 7.5 6 7.5ZM1.5 13.5H10.5V12.9C10.5 12.7625 10.4656 12.6375 10.3969 12.525C10.3281 12.4125 10.2375 12.325 10.125 12.2625C9.45 11.925 8.76875 11.6719 8.08125 11.5031C7.39375 11.3344 6.7 11.25 6 11.25C5.3 11.25 4.60625 11.3344 3.91875 11.5031C3.23125 11.6719 2.55 11.925 1.875 12.2625C1.7625 12.325 1.67188 12.4125 1.60313 12.525C1.53438 12.6375 1.5 12.7625 1.5 12.9V13.5Z"
          fill="#414549"
        />
      </g>
      <defs>
        <clipPath id="clip0_4762_20252">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ICGroupUser: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M0.75 15V12.9C0.75 12.475 0.859375 12.0844 1.07813 11.7281C1.29688 11.3719 1.5875 11.1 1.95 10.9125C2.725 10.525 3.5125 10.2344 4.3125 10.0406C5.1125 9.84688 5.925 9.75 6.75 9.75C7.575 9.75 8.3875 9.84688 9.1875 10.0406C9.9875 10.2344 10.775 10.525 11.55 10.9125C11.9125 11.1 12.2031 11.3719 12.4219 11.7281C12.6406 12.0844 12.75 12.475 12.75 12.9V15H0.75ZM14.25 15V12.75C14.25 12.2 14.0969 11.6719 13.7906 11.1656C13.4844 10.6594 13.05 10.225 12.4875 9.8625C13.125 9.9375 13.725 10.0656 14.2875 10.2469C14.85 10.4281 15.375 10.65 15.8625 10.9125C16.3125 11.1625 16.6563 11.4406 16.8938 11.7469C17.1313 12.0531 17.25 12.3875 17.25 12.75V15H14.25ZM6.75 9C5.925 9 5.21875 8.70625 4.63125 8.11875C4.04375 7.53125 3.75 6.825 3.75 6C3.75 5.175 4.04375 4.46875 4.63125 3.88125C5.21875 3.29375 5.925 3 6.75 3C7.575 3 8.28125 3.29375 8.86875 3.88125C9.45625 4.46875 9.75 5.175 9.75 6C9.75 6.825 9.45625 7.53125 8.86875 8.11875C8.28125 8.70625 7.575 9 6.75 9ZM14.25 6C14.25 6.825 13.9563 7.53125 13.3688 8.11875C12.7813 8.70625 12.075 9 11.25 9C11.1125 9 10.9375 8.98438 10.725 8.95313C10.5125 8.92188 10.3375 8.8875 10.2 8.85C10.5375 8.45 10.7969 8.00625 10.9781 7.51875C11.1594 7.03125 11.25 6.525 11.25 6C11.25 5.475 11.1594 4.96875 10.9781 4.48125C10.7969 3.99375 10.5375 3.55 10.2 3.15C10.375 3.0875 10.55 3.04688 10.725 3.02813C10.9 3.00938 11.075 3 11.25 3C12.075 3 12.7813 3.29375 13.3688 3.88125C13.9563 4.46875 14.25 5.175 14.25 6ZM2.25 13.5H11.25V12.9C11.25 12.7625 11.2156 12.6375 11.1469 12.525C11.0781 12.4125 10.9875 12.325 10.875 12.2625C10.2 11.925 9.51875 11.6719 8.83125 11.5031C8.14375 11.3344 7.45 11.25 6.75 11.25C6.05 11.25 5.35625 11.3344 4.66875 11.5031C3.98125 11.6719 3.3 11.925 2.625 12.2625C2.5125 12.325 2.42188 12.4125 2.35313 12.525C2.28438 12.6375 2.25 12.7625 2.25 12.9V13.5ZM6.75 7.5C7.1625 7.5 7.51563 7.35313 7.80938 7.05938C8.10313 6.76563 8.25 6.4125 8.25 6C8.25 5.5875 8.10313 5.23438 7.80938 4.94063C7.51563 4.64688 7.1625 4.5 6.75 4.5C6.3375 4.5 5.98438 4.64688 5.69063 4.94063C5.39688 5.23438 5.25 5.5875 5.25 6C5.25 6.4125 5.39688 6.76563 5.69063 7.05938C5.98438 7.35313 6.3375 7.5 6.75 7.5Z" />
    </svg>
  ),
  ICMale: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M13.3327 2.66602V6.66602H11.9993V4.94935L9.34935 7.58268C9.56046 7.89379 9.72157 8.22435 9.83268 8.57435C9.94379 8.92435 9.99935 9.28824 9.99935 9.66602C9.99935 10.6882 9.64379 11.5549 8.93268 12.266C8.22157 12.9771 7.3549 13.3327 6.33268 13.3327C5.31046 13.3327 4.44379 12.9771 3.73268 12.266C3.02157 11.5549 2.66602 10.6882 2.66602 9.66602C2.66602 8.64379 3.02157 7.77713 3.73268 7.06602C4.44379 6.3549 5.31046 5.99935 6.33268 5.99935C6.69935 5.99935 7.06046 6.05213 7.41602 6.15768C7.77157 6.26324 8.09935 6.42713 8.39935 6.64935L11.0493 3.99935H9.33268V2.66602H13.3327ZM6.33268 7.33268C5.68824 7.33268 5.13824 7.56046 4.68268 8.01602C4.22713 8.47157 3.99935 9.02157 3.99935 9.66602C3.99935 10.3105 4.22713 10.8605 4.68268 11.316C5.13824 11.7716 5.68824 11.9993 6.33268 11.9993C6.97713 11.9993 7.52713 11.7716 7.98268 11.316C8.43824 10.8605 8.66602 10.3105 8.66602 9.66602C8.66602 9.02157 8.43824 8.47157 7.98268 8.01602C7.52713 7.56046 6.97713 7.33268 6.33268 7.33268Z" />
    </svg>
  ),
  ICFemale: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M7.33398 13.9993V12.666H6.00065V11.3327H7.33398V9.93268C6.45621 9.77713 5.73676 9.35768 5.17565 8.67435C4.61454 7.99102 4.33398 7.19935 4.33398 6.29935C4.33398 5.28824 4.69232 4.4299 5.40898 3.72435C6.12565 3.01879 6.98954 2.66602 8.00065 2.66602C9.01176 2.66602 9.87565 3.01879 10.5923 3.72435C11.309 4.4299 11.6673 5.28824 11.6673 6.29935C11.6673 7.19935 11.3868 7.99102 10.8257 8.67435C10.2645 9.35768 9.5451 9.77713 8.66732 9.93268V11.3327H10.0007V12.666H8.66732V13.9993H7.33398ZM8.00065 8.66602C8.6451 8.66602 9.1951 8.43824 9.65065 7.98268C10.1062 7.52713 10.334 6.97713 10.334 6.33268C10.334 5.68824 10.1062 5.13824 9.65065 4.68268C9.1951 4.22713 8.6451 3.99935 8.00065 3.99935C7.35621 3.99935 6.80621 4.22713 6.35065 4.68268C5.8951 5.13824 5.66732 5.68824 5.66732 6.33268C5.66732 6.97713 5.8951 7.52713 6.35065 7.98268C6.80621 8.43824 7.35621 8.66602 8.00065 8.66602Z" />
    </svg>
  ),
  ICCheck: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M7.1627 13.5L2.8877 9.22495L3.95645 8.1562L7.1627 11.3625L14.0439 4.4812L15.1127 5.54995L7.1627 13.5Z" />
    </svg>
  ),
  ICArrowBack: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" />
    </svg>
  ),
  ICArrowForward: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z" />
    </svg>
  ),
  ICArrowOutward: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M4.8 13.5L3.75 12.45L10.95 5.25H4.5V3.75H13.5V12.75H12V6.3L4.8 13.5Z" />
    </svg>
  ),
  ICArrowDown: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M9.16927 3.33301V13.4788L4.5026 8.81217L3.33594 9.99967L10.0026 16.6663L16.6693 9.99967L15.5026 8.81217L10.8359 13.4788V3.33301H9.16927Z" />
    </svg>
  ),
  ICArrowUp: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 14 14"
      fill="currentColor"
    >
      <path d="M5.83333 13.3333V3.1875L1.16667 7.85417L0 6.66667L6.66667 0L13.3333 6.66667L12.1667 7.85417L7.5 3.1875V13.3333H5.83333Z" />
    </svg>
  ),
  ICNavigateRight: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M10.4998 10L6.6665 6.16667L7.83317 5L12.8332 10L7.83317 15L6.6665 13.8333L10.4998 10Z" />
    </svg>
  ),
  ICBox: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        d="M5 8V19H19V8H16V16L12 14L8 16V8H5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V6.525C3 6.29167 3.0375 6.06667 3.1125 5.85C3.1875 5.63333 3.3 5.43333 3.45 5.25L4.7 3.725C4.88333 3.49167 5.1125 3.3125 5.3875 3.1875C5.6625 3.0625 5.95 3 6.25 3H17.75C18.05 3 18.3375 3.0625 18.6125 3.1875C18.8875 3.3125 19.1167 3.49167 19.3 3.725L20.55 5.25C20.7 5.43333 20.8125 5.63333 20.8875 5.85C20.9625 6.06667 21 6.29167 21 6.525V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5.4 6H18.6L17.75 5H6.25L5.4 6ZM10 8V12.75L12 11.75L14 12.75V8H10Z"
        fill="#808B90"
      />
    </svg>
  ),
  ICVisibility: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      fill="currentColor"
    >
      <path d="M6.99967 9.33398C7.72884 9.33398 8.34863 9.07878 8.85905 8.56836C9.36947 8.05794 9.62468 7.43815 9.62468 6.70898C9.62468 5.97982 9.36947 5.36003 8.85905 4.84961C8.34863 4.33919 7.72884 4.08398 6.99967 4.08398C6.27051 4.08398 5.65072 4.33919 5.1403 4.84961C4.62988 5.36003 4.37467 5.97982 4.37467 6.70898C4.37467 7.43815 4.62988 8.05794 5.1403 8.56836C5.65072 9.07878 6.27051 9.33398 6.99967 9.33398ZM6.99967 8.28398C6.56217 8.28398 6.1903 8.13086 5.88405 7.82461C5.5778 7.51836 5.42467 7.14648 5.42467 6.70898C5.42467 6.27148 5.5778 5.89961 5.88405 5.59336C6.1903 5.28711 6.56217 5.13398 6.99967 5.13398C7.43717 5.13398 7.80905 5.28711 8.1153 5.59336C8.42155 5.89961 8.57468 6.27148 8.57468 6.70898C8.57468 7.14648 8.42155 7.51836 8.1153 7.82461C7.80905 8.13086 7.43717 8.28398 6.99967 8.28398ZM6.99967 11.084C5.58023 11.084 4.28717 10.6878 3.12051 9.89544C1.95384 9.10308 1.10801 8.04093 0.583008 6.70898C1.10801 5.37704 1.95384 4.31489 3.12051 3.52253C4.28717 2.73016 5.58023 2.33398 6.99967 2.33398C8.41912 2.33398 9.71218 2.73016 10.8788 3.52253C12.0455 4.31489 12.8913 5.37704 13.4163 6.70898C12.8913 8.04093 12.0455 9.10308 10.8788 9.89544C9.71218 10.6878 8.41912 11.084 6.99967 11.084ZM6.99967 9.91732C8.09829 9.91732 9.10697 9.62808 10.0257 9.04961C10.9445 8.47114 11.6469 7.69093 12.133 6.70898C11.6469 5.72704 10.9445 4.94683 10.0257 4.36836C9.10697 3.78989 8.09829 3.50065 6.99967 3.50065C5.90106 3.50065 4.89238 3.78989 3.97363 4.36836C3.05488 4.94683 2.35245 5.72704 1.86634 6.70898C2.35245 7.69093 3.05488 8.47114 3.97363 9.04961C4.89238 9.62808 5.90106 9.91732 6.99967 9.91732Z" />
    </svg>
  ),
  ICPhone: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      fill="currentColor"
      viewBox="0 0 18 18"
    >
      <path d="M14.9625 15.75C13.4 15.75 11.8563 15.4094 10.3313 14.7281C8.80625 14.0469 7.41875 13.0813 6.16875 11.8313C4.91875 10.5813 3.95313 9.19375 3.27188 7.66875C2.59063 6.14375 2.25 4.6 2.25 3.0375C2.25 2.8125 2.325 2.625 2.475 2.475C2.625 2.325 2.8125 2.25 3.0375 2.25H6.075C6.25 2.25 6.40625 2.30937 6.54375 2.42813C6.68125 2.54688 6.7625 2.6875 6.7875 2.85L7.275 5.475C7.3 5.675 7.29375 5.84375 7.25625 5.98125C7.21875 6.11875 7.15 6.2375 7.05 6.3375L5.23125 8.175C5.48125 8.6375 5.77813 9.08438 6.12188 9.51563C6.46563 9.94688 6.84375 10.3625 7.25625 10.7625C7.64375 11.15 8.05 11.5094 8.475 11.8406C8.9 12.1719 9.35 12.475 9.825 12.75L11.5875 10.9875C11.7 10.875 11.8469 10.7906 12.0281 10.7344C12.2094 10.6781 12.3875 10.6625 12.5625 10.6875L15.15 11.2125C15.325 11.2625 15.4688 11.3531 15.5813 11.4844C15.6938 11.6156 15.75 11.7625 15.75 11.925V14.9625C15.75 15.1875 15.675 15.375 15.525 15.525C15.375 15.675 15.1875 15.75 14.9625 15.75ZM4.51875 6.75L5.75625 5.5125L5.4375 3.75H3.76875C3.83125 4.2625 3.91875 4.76875 4.03125 5.26875C4.14375 5.76875 4.30625 6.2625 4.51875 6.75ZM11.2313 13.4625C11.7188 13.675 12.2156 13.8438 12.7219 13.9688C13.2281 14.0938 13.7375 14.175 14.25 14.2125V12.5625L12.4875 12.2063L11.2313 13.4625Z" />
    </svg>
  ),
  ICMail: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64687 14.2656 1.5 13.9125 1.5 13.5V4.5C1.5 4.0875 1.64687 3.73438 1.94063 3.44063C2.23438 3.14687 2.5875 3 3 3H15C15.4125 3 15.7656 3.14687 16.0594 3.44063C16.3531 3.73438 16.5 4.0875 16.5 4.5V13.5C16.5 13.9125 16.3531 14.2656 16.0594 14.5594C15.7656 14.8531 15.4125 15 15 15H3ZM9 9.75L3 6V13.5H15V6L9 9.75ZM9 8.25L15 4.5H3L9 8.25ZM3 6V4.5V13.5V6Z" />
    </svg>
  ),
  ICLocation: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M9 9C9.4125 9 9.76563 8.85313 10.0594 8.55938C10.3531 8.26563 10.5 7.9125 10.5 7.5C10.5 7.0875 10.3531 6.73438 10.0594 6.44063C9.76563 6.14688 9.4125 6 9 6C8.5875 6 8.23438 6.14688 7.94063 6.44063C7.64688 6.73438 7.5 7.0875 7.5 7.5C7.5 7.9125 7.64688 8.26563 7.94063 8.55938C8.23438 8.85313 8.5875 9 9 9ZM9 14.5125C10.525 13.1125 11.6563 11.8406 12.3938 10.6969C13.1313 9.55313 13.5 8.5375 13.5 7.65C13.5 6.2875 13.0656 5.17188 12.1969 4.30313C11.3281 3.43438 10.2625 3 9 3C7.7375 3 6.67188 3.43438 5.80313 4.30313C4.93438 5.17188 4.5 6.2875 4.5 7.65C4.5 8.5375 4.86875 9.55313 5.60625 10.6969C6.34375 11.8406 7.475 13.1125 9 14.5125ZM9 16.5C6.9875 14.7875 5.48438 13.1969 4.49063 11.7281C3.49688 10.2594 3 8.9 3 7.65C3 5.775 3.60312 4.28125 4.80938 3.16875C6.01563 2.05625 7.4125 1.5 9 1.5C10.5875 1.5 11.9844 2.05625 13.1906 3.16875C14.3969 4.28125 15 5.775 15 7.65C15 8.9 14.5031 10.2594 13.5094 11.7281C12.5156 13.1969 11.0125 14.7875 9 16.5Z" />
    </svg>
  ),
  ICOrganization: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M1.66699 17.5V2.5H10.0003V5.83333H18.3337V17.5H1.66699ZM3.33366 15.8333H8.33366V14.1667H3.33366V15.8333ZM3.33366 12.5H8.33366V10.8333H3.33366V12.5ZM3.33366 9.16667H8.33366V7.5H3.33366V9.16667ZM3.33366 5.83333H8.33366V4.16667H3.33366V5.83333ZM10.0003 15.8333H16.667V7.5H10.0003V15.8333ZM11.667 10.8333V9.16667H15.0003V10.8333H11.667ZM11.667 14.1667V12.5H15.0003V14.1667H11.667Z" />
    </svg>
  ),
  ICPayment: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M11.6663 10.834C10.9719 10.834 10.3816 10.5909 9.89551 10.1048C9.4094 9.61871 9.16634 9.02843 9.16634 8.33398C9.16634 7.63954 9.4094 7.04926 9.89551 6.56315C10.3816 6.07704 10.9719 5.83398 11.6663 5.83398C12.3608 5.83398 12.9511 6.07704 13.4372 6.56315C13.9233 7.04926 14.1663 7.63954 14.1663 8.33398C14.1663 9.02843 13.9233 9.61871 13.4372 10.1048C12.9511 10.5909 12.3608 10.834 11.6663 10.834ZM5.83301 13.334C5.37467 13.334 4.98231 13.1708 4.65592 12.8444C4.32954 12.518 4.16634 12.1257 4.16634 11.6673V5.00065C4.16634 4.54232 4.32954 4.14996 4.65592 3.82357C4.98231 3.49718 5.37467 3.33398 5.83301 3.33398H17.4997C17.958 3.33398 18.3504 3.49718 18.6768 3.82357C19.0031 4.14996 19.1663 4.54232 19.1663 5.00065V11.6673C19.1663 12.1257 19.0031 12.518 18.6768 12.8444C18.3504 13.1708 17.958 13.334 17.4997 13.334H5.83301ZM7.49967 11.6673H15.833C15.833 11.209 15.9962 10.8166 16.3226 10.4902C16.649 10.1638 17.0413 10.0007 17.4997 10.0007V6.66732C17.0413 6.66732 16.649 6.50412 16.3226 6.17773C15.9962 5.85135 15.833 5.45898 15.833 5.00065H7.49967C7.49967 5.45898 7.33648 5.85135 7.01009 6.17773C6.6837 6.50412 6.29134 6.66732 5.83301 6.66732V10.0007C6.29134 10.0007 6.6837 10.1638 7.01009 10.4902C7.33648 10.8166 7.49967 11.209 7.49967 11.6673ZM16.6663 16.6673H2.49967C2.04134 16.6673 1.64898 16.5041 1.32259 16.1777C0.996202 15.8513 0.833008 15.459 0.833008 15.0007V5.83398H2.49967V15.0007H16.6663V16.6673Z" />
    </svg>
  ),
  ICOpenNewTab: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H8V3.33333H3.33333V12.6667H12.6667V8H14V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM6.46667 10.4667L5.53333 9.53333L11.7333 3.33333H9.33333V2H14V6.66667H12.6667V4.26667L6.46667 10.4667Z" />
    </svg>
  ),
  ICCake: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path
        d="M3 16.5C2.7875 16.5 2.60938 16.4281 2.46563 16.2844C2.32188 16.1406 2.25 15.9625 2.25 15.75V12C2.25 11.5875 2.39687 11.2344 2.69063 10.9406C2.98438 10.6469 3.3375 10.5 3.75 10.5V7.5C3.75 7.0875 3.89688 6.73438 4.19063 6.44063C4.48438 6.14688 4.8375 6 5.25 6H8.25V4.9125C8.025 4.7625 7.84375 4.58125 7.70625 4.36875C7.56875 4.15625 7.5 3.9 7.5 3.6C7.5 3.4125 7.5375 3.22813 7.6125 3.04688C7.6875 2.86563 7.8 2.7 7.95 2.55L9 1.5L10.05 2.55C10.2 2.7 10.3125 2.86563 10.3875 3.04688C10.4625 3.22813 10.5 3.4125 10.5 3.6C10.5 3.9 10.4313 4.15625 10.2938 4.36875C10.1563 4.58125 9.975 4.7625 9.75 4.9125V6H12.75C13.1625 6 13.5156 6.14688 13.8094 6.44063C14.1031 6.73438 14.25 7.0875 14.25 7.5V10.5C14.6625 10.5 15.0156 10.6469 15.3094 10.9406C15.6031 11.2344 15.75 11.5875 15.75 12V15.75C15.75 15.9625 15.6781 16.1406 15.5344 16.2844C15.3906 16.4281 15.2125 16.5 15 16.5H3ZM5.25 10.5H12.75V7.5H5.25V10.5ZM3.75 15H14.25V12H3.75V15Z"
        fill="#565E64"
      />
    </svg>
  ),
  ICStar3D: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: width,
        height: height,
        flexShrink: '0',
        aspectRatio: '24.00 / 22.93',
      }}
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M18.5496 15.7675L19.585 21.2695C19.7383 22.0846 18.89 22.7214 18.1502 22.3465L12.952 19.7123C12.659 19.5639 12.3118 19.5687 12.0231 19.7254L6.90556 22.5015C6.17782 22.8962 5.31301 22.2862 5.4407 21.4682L6.33762 15.7223C6.38835 15.3973 6.27602 15.0682 6.0372 14.842L1.80331 10.8324C1.20167 10.2626 1.51426 9.25034 2.33239 9.11898L7.48666 8.29139L8.09526 8.19358C8.42066 8.14128 8.6994 7.93201 8.84041 7.63413L11.3346 2.36543C11.6894 1.61614 12.7494 1.59905 13.128 2.3365L15.7912 7.52257C15.9412 7.81473 16.2251 8.0146 16.5508 8.05728L22.3295 8.8147C23.1503 8.92228 23.4925 9.92357 22.9091 10.5109L18.7879 14.6602C18.5623 14.8874 18.4591 15.2089 18.5103 15.525L18.5496 15.7675Z"
        fill="#FFC914"
      />
      <path
        d="M17.3302 14.1854C17.097 14.4186 16.9938 14.7517 17.0542 15.0758L17.7544 18.8299C17.9064 19.6453 17.057 20.2807 16.3178 19.9045L12.9335 18.1823C12.6396 18.0327 12.2909 18.0377 12.0013 18.1955L8.66337 20.0151C7.93524 20.412 7.06818 19.8012 7.19685 18.9819L7.78792 15.2184C7.83899 14.8932 7.72678 14.5637 7.48786 14.3373L4.72382 11.7181C4.12253 11.1484 4.43505 10.1364 5.25292 10.005L9.00306 9.40204C9.32788 9.34982 9.60624 9.14117 9.74748 8.84403L11.3744 5.42148C11.7299 4.67368 12.7882 4.65713 13.1668 5.39345L14.9043 8.77192C15.0545 9.06382 15.3383 9.26346 15.6637 9.3061L19.4391 9.80063C20.2615 9.90836 20.6028 10.9128 20.0163 11.4993L17.3302 14.1854Z"
        fill="#FFC914"
      />
      <path
        opacity="0.2"
        d="M18.6066 14.8424C18.4951 14.9548 18.446 15.1148 18.4754 15.2704C18.5265 15.5407 18.3409 15.8001 18.067 15.8262C17.789 15.8526 17.5081 15.8682 17.2193 15.8682H17.1186C12.9271 15.8682 9.34023 13.2687 7.88935 9.58106C7.81933 9.39725 7.7531 9.21343 7.69233 9.02796C7.56331 8.63417 7.83261 8.23574 8.24175 8.16998C8.47525 8.13246 8.67526 7.98229 8.77645 7.76854L11.3343 2.36543C11.689 1.61614 12.749 1.59905 13.1277 2.3365L15.7908 7.52257C15.9409 7.81473 16.2248 8.0146 16.5504 8.05728L22.3292 8.8147C23.15 8.92228 23.4921 9.92357 22.9088 10.5109L18.6066 14.8424Z"
        fill="white"
      />
    </svg>
  ),
  ICClock3D: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: width,
        height: height,
        flexShrink: '0',
        aspectRatio: '18.33/18',
      }}
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M17.6729 1.23944C17.6729 1.18048 17.6729 1.14119 17.6729 1.08223C17.6729 1.02328 17.6729 0.944681 17.6729 0.885729L15.9436 0.866071L10.0092 0.807122L6.47207 0.767819L4.13366 0.748173L2.40442 0.728516C2.38477 0.88572 2.38477 1.06257 2.38477 1.21978C2.38477 1.39663 2.38477 1.55384 2.40442 1.7307C2.46337 2.71322 2.69918 3.65644 3.09219 4.50141C3.89786 6.25031 5.33235 7.64549 7.12054 8.37256C7.4546 8.51011 7.78866 8.62802 8.12272 8.70662C8.61398 8.84417 9.1249 8.92278 9.65546 8.94243C9.77336 8.94243 9.87161 8.94242 9.98952 8.96208H10.0681C10.186 8.96208 10.3039 8.96208 10.4022 8.96208C10.9327 8.94242 11.4437 8.86383 11.9349 8.74592C12.3083 8.64767 12.662 8.52976 12.996 8.39221C14.3126 7.84199 15.4524 6.93807 16.2777 5.77869C16.8476 4.97302 17.2799 4.04945 17.5157 3.06693C17.5943 2.73287 17.6532 2.37916 17.6925 2.0451C17.6925 1.94685 17.7122 1.86825 17.7122 1.77C17.7122 1.7307 17.7122 1.67175 17.7122 1.63245C17.7122 1.55384 17.7122 1.49488 17.7122 1.41628C17.6729 1.33768 17.6729 1.29839 17.6729 1.23944ZM10.3629 7.21318C10.245 7.21318 10.1074 7.23283 9.98952 7.23283H9.96987C9.85197 7.23283 9.73406 7.23283 9.63581 7.21318C7.71006 7.07562 6.03976 6.03415 5.05724 4.50141H15.0201C13.9982 6.0538 12.2886 7.11492 10.3629 7.21318Z"
        fill="#FFE693"
      />
      <path
        d="M15.944 1.35721C15.944 2.22183 15.7475 3.04715 15.3938 3.77421C15.2759 4.02967 15.1383 4.26548 15.0008 4.50129H5.03795C4.42879 3.55806 4.09473 2.43799 4.09473 1.23931C4.09473 1.08211 4.09473 0.905251 4.11438 0.748047L6.45279 0.767693L15.9243 0.865945C15.9243 1.0428 15.944 1.2 15.944 1.35721Z"
        fill="#FFE693"
      />
      <path
        opacity="0.2"
        d="M17.6736 1.37686C17.6736 1.45547 17.6736 1.51441 17.6736 1.59302C17.6736 1.63232 17.6736 1.69127 17.6736 1.73057C17.6736 1.82882 17.6539 1.92707 17.6539 2.00567C17.6146 2.35938 17.5753 2.69344 17.4771 3.0275C16.8286 3.36156 16.1212 3.59737 15.3941 3.75457C14.726 3.91177 14.0382 3.99037 13.3308 3.97072C12.1518 3.95107 11.0317 3.71527 9.99022 3.30261C9.04699 2.9096 8.16272 2.37903 7.39635 1.71091C7.06229 1.41616 6.74788 1.10176 6.45312 0.748047L9.99022 0.78735L15.9247 0.846299L17.6539 0.865945C17.6539 0.924896 17.6539 1.0035 17.6539 1.06245C17.6539 1.10175 17.6539 1.1607 17.6539 1.21965C17.6736 1.29825 17.6736 1.33756 17.6736 1.37686Z"
        fill="white"
      />
      <path
        d="M17.6535 16.2708C17.6339 15.7992 17.5749 15.3276 17.457 14.8756C16.8085 12.0852 14.6273 9.8844 11.8566 9.19663C11.3654 9.07873 10.8544 9.00012 10.3239 8.98047C10.206 8.98047 10.1077 8.98047 9.98982 8.98047H9.91122C9.79331 8.98047 9.69506 8.98048 9.57716 9.00013C9.0466 9.01978 8.53568 9.09838 8.04442 9.23593C4.84138 10.0613 2.46367 12.8909 2.32612 16.3101C2.32612 16.4477 2.30647 16.5852 2.32612 16.7228C2.32612 16.88 2.32612 17.0568 2.34577 17.214L4.07501 17.1944L9.95052 17.1354L15.885 17.0765L17.6142 17.0568C17.6339 16.8996 17.6339 16.7424 17.6339 16.5656C17.6732 16.4477 17.6732 16.3691 17.6535 16.2708ZM4.09466 16.2708C4.13396 15.6223 4.27152 14.9739 4.50732 14.404H15.5116C15.7474 14.9935 15.885 15.6223 15.9243 16.2708H4.09466Z"
        fill="#FFE693"
      />
      <path
        d="M15.512 14.4036H4.52734C5.39197 12.242 7.49457 10.729 9.97054 10.6897C12.3679 10.67 14.4705 12.0848 15.4137 14.1481C15.4334 14.2268 15.4727 14.3054 15.512 14.4036Z"
        fill="#FFE693"
      />
      <path
        d="M15.944 16.5642C15.944 16.7214 15.944 16.8982 15.9243 17.0554L4.11438 17.1733C4.09473 17.0161 4.09473 16.8393 4.09473 16.6821C4.09473 16.5445 4.09473 16.407 4.11438 16.2891H15.944C15.9243 16.3677 15.9243 16.4659 15.944 16.5642Z"
        fill="#FFE693"
      />
      <path
        d="M19.1669 0.864614C19.1669 1.33623 18.7739 1.72924 18.3023 1.72924H1.69763C1.22602 1.72924 0.833008 1.33623 0.833008 0.864614C0.833008 0.628808 0.93126 0.412658 1.08846 0.255454C1.24567 0.09825 1.46182 0 1.69763 0H18.3023C18.7739 0 19.1669 0.393003 19.1669 0.864614Z"
        fill="#FFC914"
      />
      <path
        d="M19.1669 17.1361C19.1669 17.6077 18.7739 18.0007 18.3023 18.0007H1.69763C1.22602 18.0007 0.833008 17.6077 0.833008 17.1361C0.833008 16.9003 0.93126 16.6841 1.08846 16.5269C1.24567 16.3697 1.46182 16.2715 1.69763 16.2715H18.3023C18.7739 16.2715 19.1669 16.6645 19.1669 17.1361Z"
        fill="#FFC914"
      />
      <path
        d="M11.8765 8.25391H8.08398V10.16H11.8765V8.25391Z"
        fill="#FFE693"
      />
      <path
        d="M15.001 4.5C13.9399 6.15064 12.0731 7.25107 9.95083 7.23142C7.88753 7.21177 6.07968 6.13099 5.01855 4.5H15.001Z"
        fill="#E6A637"
      />
      <path
        d="M16.2392 4.5V5.75764C15.4139 6.91702 14.2742 7.82094 12.9576 8.37115H7.08207C5.29387 7.62443 3.85938 6.24889 3.05371 4.5H5.01876C6.00129 6.03274 7.67158 7.07421 9.59733 7.21177C9.71524 7.21177 9.83314 7.23142 9.93139 7.23142H9.95104C10.0689 7.23142 10.2065 7.23142 10.3244 7.21177C12.2698 7.09386 13.9597 6.05239 14.9619 4.5H16.2392Z"
        fill="#FFE693"
      />
      <path
        d="M10.3629 6.60352H9.61621V14.6013H10.3629V6.60352Z"
        fill="#E6A637"
      />
      <path
        d="M15.9243 16.2711H4.09473C4.13403 15.603 4.27158 14.9742 4.50739 14.4043H15.5117C15.7475 14.9938 15.885 15.6226 15.9243 16.2711Z"
        fill="#E6A637"
      />
      <path
        opacity="0.3"
        d="M19.167 17.1352C19.167 17.6068 18.774 17.9998 18.3024 17.9998H9.99023V0H18.3024C18.774 0 19.167 0.393003 19.167 0.864614C19.167 1.33623 18.774 1.72924 18.3024 1.72924H17.6539C17.6539 1.82749 17.6343 1.92574 17.6343 2.00434C17.595 2.35805 17.5557 2.69211 17.4574 3.02617C17.2216 4.02834 16.809 4.93226 16.2195 5.73793C15.3941 6.89731 14.2544 7.80124 12.9378 8.35146C12.5841 8.48901 12.2304 8.60691 11.8767 8.70516V9.15712C14.6474 9.84489 16.809 12.0457 17.4771 14.8361C17.5753 15.2881 17.6539 15.7597 17.6736 16.2313H18.3221C18.774 16.2706 19.167 16.6636 19.167 17.1352Z"
        fill="#FBFBFB"
      />
    </svg>
  ),
  ICThunder3D: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: width,
        height: height,
        flexShrink: '0',
        aspectRatio: '16.41/24',
      }}
      viewBox="0 0 17 24"
      fill="none"
    >
      <path
        d="M16.8701 6.77994L13.7259 11.9877L6.43015 24L8.41989 12.8966H0.460938L1.88568 0H9.57443L7.41273 6.82907L16.8701 6.77994Z"
        fill="#FFC914"
      />
      <path
        opacity="0.2"
        d="M16.8704 6.77994L13.7261 11.9877C7.87972 11.6192 3.28613 7.56602 3.28613 2.60389C3.28613 1.69498 3.43352 0.83521 3.72829 0H9.59925L7.43756 6.85363L16.8704 6.77994Z"
        fill="white"
      />
    </svg>
  ),
  ICCalendar: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M3.33333 14.6673C2.96667 14.6673 2.65278 14.5368 2.39167 14.2757C2.13056 14.0145 2 13.7007 2 13.334V4.00065C2 3.63398 2.13056 3.3201 2.39167 3.05898C2.65278 2.79787 2.96667 2.66732 3.33333 2.66732H4V1.33398H5.33333V2.66732H10.6667V1.33398H12V2.66732H12.6667C13.0333 2.66732 13.3472 2.79787 13.6083 3.05898C13.8694 3.3201 14 3.63398 14 4.00065V13.334C14 13.7007 13.8694 14.0145 13.6083 14.2757C13.3472 14.5368 13.0333 14.6673 12.6667 14.6673H3.33333ZM3.33333 13.334H12.6667V6.66732H3.33333V13.334ZM3.33333 5.33398H12.6667V4.00065H3.33333V5.33398ZM8 9.33398C7.81111 9.33398 7.65278 9.2701 7.525 9.14232C7.39722 9.01454 7.33333 8.85621 7.33333 8.66732C7.33333 8.47843 7.39722 8.3201 7.525 8.19232C7.65278 8.06454 7.81111 8.00065 8 8.00065C8.18889 8.00065 8.34722 8.06454 8.475 8.19232C8.60278 8.3201 8.66667 8.47843 8.66667 8.66732C8.66667 8.85621 8.60278 9.01454 8.475 9.14232C8.34722 9.2701 8.18889 9.33398 8 9.33398ZM5.33333 9.33398C5.14444 9.33398 4.98611 9.2701 4.85833 9.14232C4.73056 9.01454 4.66667 8.85621 4.66667 8.66732C4.66667 8.47843 4.73056 8.3201 4.85833 8.19232C4.98611 8.06454 5.14444 8.00065 5.33333 8.00065C5.52222 8.00065 5.68056 8.06454 5.80833 8.19232C5.93611 8.3201 6 8.47843 6 8.66732C6 8.85621 5.93611 9.01454 5.80833 9.14232C5.68056 9.2701 5.52222 9.33398 5.33333 9.33398ZM10.6667 9.33398C10.4778 9.33398 10.3194 9.2701 10.1917 9.14232C10.0639 9.01454 10 8.85621 10 8.66732C10 8.47843 10.0639 8.3201 10.1917 8.19232C10.3194 8.06454 10.4778 8.00065 10.6667 8.00065C10.8556 8.00065 11.0139 8.06454 11.1417 8.19232C11.2694 8.3201 11.3333 8.47843 11.3333 8.66732C11.3333 8.85621 11.2694 9.01454 11.1417 9.14232C11.0139 9.2701 10.8556 9.33398 10.6667 9.33398ZM8 12.0007C7.81111 12.0007 7.65278 11.9368 7.525 11.809C7.39722 11.6812 7.33333 11.5229 7.33333 11.334C7.33333 11.1451 7.39722 10.9868 7.525 10.859C7.65278 10.7312 7.81111 10.6673 8 10.6673C8.18889 10.6673 8.34722 10.7312 8.475 10.859C8.60278 10.9868 8.66667 11.1451 8.66667 11.334C8.66667 11.5229 8.60278 11.6812 8.475 11.809C8.34722 11.9368 8.18889 12.0007 8 12.0007ZM5.33333 12.0007C5.14444 12.0007 4.98611 11.9368 4.85833 11.809C4.73056 11.6812 4.66667 11.5229 4.66667 11.334C4.66667 11.1451 4.73056 10.9868 4.85833 10.859C4.98611 10.7312 5.14444 10.6673 5.33333 10.6673C5.52222 10.6673 5.68056 10.7312 5.80833 10.859C5.93611 10.9868 6 11.1451 6 11.334C6 11.5229 5.93611 11.6812 5.80833 11.809C5.68056 11.9368 5.52222 12.0007 5.33333 12.0007ZM10.6667 12.0007C10.4778 12.0007 10.3194 11.9368 10.1917 11.809C10.0639 11.6812 10 11.5229 10 11.334C10 11.1451 10.0639 10.9868 10.1917 10.859C10.3194 10.7312 10.4778 10.6673 10.6667 10.6673C10.8556 10.6673 11.0139 10.7312 11.1417 10.859C11.2694 10.9868 11.3333 11.1451 11.3333 11.334C11.3333 11.5229 11.2694 11.6812 11.1417 11.809C11.0139 11.9368 10.8556 12.0007 10.6667 12.0007Z" />
    </svg>
  ),
  ICAssignment: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M15.8333 2.50065H12.35C12 1.53398 11.0833 0.833984 10 0.833984C8.91667 0.833984 8 1.53398 7.65 2.50065H4.16667C3.25 2.50065 2.5 3.25065 2.5 4.16732V15.834C2.5 16.7507 3.25 17.5007 4.16667 17.5007H15.8333C16.75 17.5007 17.5 16.7507 17.5 15.834V4.16732C17.5 3.25065 16.75 2.50065 15.8333 2.50065ZM10 2.29232C10.1833 2.29232 10.3417 2.37565 10.4583 2.50065C10.5583 2.60898 10.625 2.75898 10.625 2.91732C10.625 3.25898 10.3417 3.54232 10 3.54232C9.65833 3.54232 9.375 3.25898 9.375 2.91732C9.375 2.75898 9.44167 2.60898 9.54167 2.50065C9.65833 2.37565 9.81667 2.29232 10 2.29232ZM15.8333 15.834H4.16667V4.16732H15.8333V15.834ZM10 5.00065C8.625 5.00065 7.5 6.12565 7.5 7.50065C7.5 8.87565 8.625 10.0007 10 10.0007C11.375 10.0007 12.5 8.87565 12.5 7.50065C12.5 6.12565 11.375 5.00065 10 5.00065ZM10 8.33398C9.54167 8.33398 9.16667 7.95898 9.16667 7.50065C9.16667 7.04232 9.54167 6.66732 10 6.66732C10.4583 6.66732 10.8333 7.04232 10.8333 7.50065C10.8333 7.95898 10.4583 8.33398 10 8.33398ZM5 13.7256V15.0007H15V13.7256C15 11.6423 11.6917 10.7423 10 10.7423C8.30833 10.7423 5 11.634 5 13.7256ZM6.925 13.334C7.5 12.8673 8.90833 12.4007 10 12.4007C11.0917 12.4007 12.5083 12.8673 13.075 13.334H6.925Z" />
    </svg>
  ),
  ICAssignmentList: ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      className={className}
      fill="currentColor"
      viewBox="0 0 18 18"
    >
      <path d="M3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39687 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39687 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H6.9C7.0625 1.8 7.33438 1.4375 7.71563 1.1625C8.09688 0.8875 8.525 0.75 9 0.75C9.475 0.75 9.90313 0.8875 10.2844 1.1625C10.6656 1.4375 10.9375 1.8 11.1 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM3.75 14.25H14.25V3.75H3.75V14.25ZM5.25 12.75H10.5V11.25H5.25V12.75ZM5.25 9.75H12.75V8.25H5.25V9.75ZM5.25 6.75H12.75V5.25H5.25V6.75ZM9 3.1875C9.1625 3.1875 9.29688 3.13438 9.40313 3.02813C9.50938 2.92188 9.5625 2.7875 9.5625 2.625C9.5625 2.4625 9.50938 2.32813 9.40313 2.22188C9.29688 2.11563 9.1625 2.0625 9 2.0625C8.8375 2.0625 8.70313 2.11563 8.59688 2.22188C8.49063 2.32813 8.4375 2.4625 8.4375 2.625C8.4375 2.7875 8.49063 2.92188 8.59688 3.02813C8.70313 3.13438 8.8375 3.1875 9 3.1875Z" />
    </svg>
  ),
  ICInfo: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M7.33301 11.334H8.66634V7.33398H7.33301V11.334ZM7.99967 6.00065C8.18856 6.00065 8.3469 5.93676 8.47467 5.80898C8.60245 5.68121 8.66634 5.52287 8.66634 5.33398C8.66634 5.1451 8.60245 4.98676 8.47467 4.85898C8.3469 4.73121 8.18856 4.66732 7.99967 4.66732C7.81079 4.66732 7.65245 4.73121 7.52467 4.85898C7.3969 4.98676 7.33301 5.1451 7.33301 5.33398C7.33301 5.52287 7.3969 5.68121 7.52467 5.80898C7.65245 5.93676 7.81079 6.00065 7.99967 6.00065ZM7.99967 14.6673C7.07745 14.6673 6.21079 14.4923 5.39967 14.1423C4.58856 13.7923 3.88301 13.3173 3.28301 12.7173C2.68301 12.1173 2.20801 11.4118 1.85801 10.6007C1.50801 9.78954 1.33301 8.92287 1.33301 8.00065C1.33301 7.07843 1.50801 6.21176 1.85801 5.40065C2.20801 4.58954 2.68301 3.88398 3.28301 3.28398C3.88301 2.68398 4.58856 2.20898 5.39967 1.85898C6.21079 1.50898 7.07745 1.33398 7.99967 1.33398C8.9219 1.33398 9.78856 1.50898 10.5997 1.85898C11.4108 2.20898 12.1163 2.68398 12.7163 3.28398C13.3163 3.88398 13.7913 4.58954 14.1413 5.40065C14.4913 6.21176 14.6663 7.07843 14.6663 8.00065C14.6663 8.92287 14.4913 9.78954 14.1413 10.6007C13.7913 11.4118 13.3163 12.1173 12.7163 12.7173C12.1163 13.3173 11.4108 13.7923 10.5997 14.1423C9.78856 14.4923 8.9219 14.6673 7.99967 14.6673ZM7.99967 13.334C9.48856 13.334 10.7497 12.8173 11.783 11.784C12.8163 10.7507 13.333 9.48954 13.333 8.00065C13.333 6.51176 12.8163 5.25065 11.783 4.21732C10.7497 3.18398 9.48856 2.66732 7.99967 2.66732C6.51079 2.66732 5.24967 3.18398 4.21634 4.21732C3.18301 5.25065 2.66634 6.51176 2.66634 8.00065C2.66634 9.48954 3.18301 10.7507 4.21634 11.784C5.24967 12.8173 6.51079 13.334 7.99967 13.334Z" />
    </svg>
  ),
  ICPriority: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        d="M5 22V3H21L19 8L21 13H7V22H5ZM7 11H18.05L16.85 8L18.05 5H7V11Z"
        fill="#808B90"
      />
    </svg>
  ),
  ICPriorityFull: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M5 22V3H21L19 8L21 13H7V22H5Z" fill="#E5654E" />
    </svg>
  ),
  ICPriceCheck: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M6.5 14.9746V13.9746H4V11.9746H9V9.97461H5C4.71667 9.97461 4.47917 9.87878 4.2875 9.68711C4.09583 9.49544 4 9.25794 4 8.97461V4.97461C4 4.69128 4.09583 4.45378 4.2875 4.26211C4.47917 4.07044 4.71667 3.97461 5 3.97461H6.5V2.97461H8.5V3.97461H11V5.97461H6V7.97461H10C10.2833 7.97461 10.5208 8.07044 10.7125 8.26211C10.9042 8.45378 11 8.69128 11 8.97461V12.9746C11 13.2579 10.9042 13.4954 10.7125 13.6871C10.5208 13.8788 10.2833 13.9746 10 13.9746H8.5V14.9746H6.5ZM13.95 20.9746L9.7 16.7246L11.1 15.3246L13.95 18.1746L19.6 12.5246L21 13.9246L13.95 20.9746Z" />
    </svg>
  ),
  ICChecklist: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        d="M2.66536 14C2.2987 14 1.98481 13.8694 1.7237 13.6083C1.46259 13.3472 1.33203 13.0333 1.33203 12.6667V3.33333C1.33203 2.96667 1.46259 2.65278 1.7237 2.39167C1.98481 2.13056 2.2987 2 2.66536 2H13.332C13.6987 2 14.0126 2.13056 14.2737 2.39167C14.5348 2.65278 14.6654 2.96667 14.6654 3.33333V12.6667C14.6654 13.0333 14.5348 13.3472 14.2737 13.6083C14.0126 13.8694 13.6987 14 13.332 14H2.66536ZM2.66536 12.6667H13.332V3.33333H2.66536V12.6667ZM3.33203 11.3333H6.66536V10H3.33203V11.3333ZM9.6987 10L12.9987 6.7L12.0487 5.75L9.6987 8.11667L8.7487 7.16667L7.81536 8.11667L9.6987 10ZM3.33203 8.66667H6.66536V7.33333H3.33203V8.66667ZM3.33203 6H6.66536V4.66667H3.33203V6Z"
        fill="#414549"
      />
    </svg>
  ),
  ICFile: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        d="M5.33073 12.0002H10.6641V10.6668H5.33073V12.0002ZM5.33073 9.3335H10.6641V8.00016H5.33073V9.3335ZM3.9974 14.6668C3.63073 14.6668 3.31684 14.5363 3.05573 14.2752C2.79462 14.0141 2.66406 13.7002 2.66406 13.3335V2.66683C2.66406 2.30016 2.79462 1.98627 3.05573 1.72516C3.31684 1.46405 3.63073 1.3335 3.9974 1.3335H9.33073L13.3307 5.3335V13.3335C13.3307 13.7002 13.2002 14.0141 12.9391 14.2752C12.678 14.5363 12.3641 14.6668 11.9974 14.6668H3.9974ZM8.66406 6.00016V2.66683H3.9974V13.3335H11.9974V6.00016H8.66406Z"
        fill="#414549"
      />
    </svg>
  ),
  ICCheckError: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        d="M8.00065 11.3333C8.18954 11.3333 8.34787 11.2694 8.47565 11.1416C8.60343 11.0138 8.66732 10.8555 8.66732 10.6666C8.66732 10.4777 8.60343 10.3194 8.47565 10.1916C8.34787 10.0638 8.18954 9.99992 8.00065 9.99992C7.81176 9.99992 7.65343 10.0638 7.52565 10.1916C7.39787 10.3194 7.33398 10.4777 7.33398 10.6666C7.33398 10.8555 7.39787 11.0138 7.52565 11.1416C7.65343 11.2694 7.81176 11.3333 8.00065 11.3333ZM7.33398 8.66659H8.66732V4.66659H7.33398V8.66659ZM8.00065 14.6666C7.07843 14.6666 6.21176 14.4916 5.40065 14.1416C4.58954 13.7916 3.88398 13.3166 3.28398 12.7166C2.68398 12.1166 2.20898 11.411 1.85898 10.5999C1.50898 9.78881 1.33398 8.92214 1.33398 7.99992C1.33398 7.0777 1.50898 6.21103 1.85898 5.39992C2.20898 4.58881 2.68398 3.88325 3.28398 3.28325C3.88398 2.68325 4.58954 2.20825 5.40065 1.85825C6.21176 1.50825 7.07843 1.33325 8.00065 1.33325C8.92287 1.33325 9.78954 1.50825 10.6007 1.85825C11.4118 2.20825 12.1173 2.68325 12.7173 3.28325C13.3173 3.88325 13.7923 4.58881 14.1423 5.39992C14.4923 6.21103 14.6673 7.0777 14.6673 7.99992C14.6673 8.92214 14.4923 9.78881 14.1423 10.5999C13.7923 11.411 13.3173 12.1166 12.7173 12.7166C12.1173 13.3166 11.4118 13.7916 10.6007 14.1416C9.78954 14.4916 8.92287 14.6666 8.00065 14.6666ZM8.00065 13.3333C9.48954 13.3333 10.7507 12.8166 11.784 11.7833C12.8173 10.7499 13.334 9.48881 13.334 7.99992C13.334 6.51103 12.8173 5.24992 11.784 4.21659C10.7507 3.18325 9.48954 2.66659 8.00065 2.66659C6.51176 2.66659 5.25065 3.18325 4.21732 4.21659C3.18398 5.24992 2.66732 6.51103 2.66732 7.99992C2.66732 9.48881 3.18398 10.7499 4.21732 11.7833C5.25065 12.8166 6.51176 13.3333 8.00065 13.3333Z"
        fill="#E5654E"
      />
    </svg>
  ),
  ICCheckNull: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        d="M8.83464 13.8333L14.7096 7.95829L13.543 6.79163L8.83464 11.5L6.45964 9.12496L5.29297 10.2916L8.83464 13.8333ZM10.0013 18.3333C8.84853 18.3333 7.76519 18.1145 6.7513 17.677C5.73741 17.2395 4.85547 16.6458 4.10547 15.8958C3.35547 15.1458 2.76172 14.2638 2.32422 13.25C1.88672 12.2361 1.66797 11.1527 1.66797 9.99996C1.66797 8.84718 1.88672 7.76385 2.32422 6.74996C2.76172 5.73607 3.35547 4.85413 4.10547 4.10413C4.85547 3.35413 5.73741 2.76038 6.7513 2.32288C7.76519 1.88538 8.84853 1.66663 10.0013 1.66663C11.1541 1.66663 12.2374 1.88538 13.2513 2.32288C14.2652 2.76038 15.1471 3.35413 15.8971 4.10413C16.6471 4.85413 17.2409 5.73607 17.6784 6.74996C18.1159 7.76385 18.3346 8.84718 18.3346 9.99996C18.3346 11.1527 18.1159 12.2361 17.6784 13.25C17.2409 14.2638 16.6471 15.1458 15.8971 15.8958C15.1471 16.6458 14.2652 17.2395 13.2513 17.677C12.2374 18.1145 11.1541 18.3333 10.0013 18.3333ZM10.0013 16.6666C11.8624 16.6666 13.4388 16.0208 14.7305 14.7291C16.0221 13.4375 16.668 11.8611 16.668 9.99996C16.668 8.13885 16.0221 6.56246 14.7305 5.27079C13.4388 3.97913 11.8624 3.33329 10.0013 3.33329C8.14019 3.33329 6.5638 3.97913 5.27214 5.27079C3.98047 6.56246 3.33464 8.13885 3.33464 9.99996C3.33464 11.8611 3.98047 13.4375 5.27214 14.7291C6.5638 16.0208 8.14019 16.6666 10.0013 16.6666Z"
        fill="#3ABB2C"
      />
    </svg>
  ),
  ICRequestQuote: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 25 24"
      fill="currentColor"
    >
      <path d="M11.667 19H13.667V18H14.667C14.9503 18 15.1878 17.9042 15.3795 17.7125C15.5712 17.5208 15.667 17.2833 15.667 17V14C15.667 13.7167 15.5712 13.4792 15.3795 13.2875C15.1878 13.0958 14.9503 13 14.667 13H11.667V12H15.667V10H13.667V9H11.667V10H10.667C10.3837 10 10.1462 10.0958 9.95449 10.2875C9.76283 10.4792 9.66699 10.7167 9.66699 11V14C9.66699 14.2833 9.76283 14.5208 9.95449 14.7125C10.1462 14.9042 10.3837 15 10.667 15H13.667V16H9.66699V18H11.667V19ZM6.66699 22C6.11699 22 5.64616 21.8042 5.25449 21.4125C4.86283 21.0208 4.66699 20.55 4.66699 20V4C4.66699 3.45 4.86283 2.97917 5.25449 2.5875C5.64616 2.19583 6.11699 2 6.66699 2H14.667L20.667 8V20C20.667 20.55 20.4712 21.0208 20.0795 21.4125C19.6878 21.8042 19.217 22 18.667 22H6.66699ZM13.667 8V4H6.66699V20H18.667V8H13.667Z" />
    </svg>
  ),
  ICManufactoring: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M3.97461 21V18H7.07461L4.52461 9.65002C4.07461 9.40002 3.70378 9.03336 3.41211 8.55002C3.12044 8.06669 2.97461 7.55002 2.97461 7.00002C2.97461 6.16669 3.26628 5.45836 3.84961 4.87502C4.43294 4.29169 5.14128 4.00002 5.97461 4.00002C6.62461 4.00002 7.20378 4.18752 7.71211 4.56252C8.22044 4.93752 8.57461 5.41669 8.77461 6.00002H11.9746V5.00002C11.9746 4.71669 12.0704 4.47919 12.2621 4.28752C12.4538 4.09586 12.6913 4.00002 12.9746 4.00002C13.1246 4.00002 13.2704 4.03336 13.4121 4.10002C13.5538 4.16669 13.6746 4.26669 13.7746 4.40002L15.4746 2.80002C15.6246 2.65002 15.8038 2.55419 16.0121 2.51252C16.2204 2.47086 16.4246 2.50002 16.6246 2.60002L20.5246 4.40002C20.7246 4.50002 20.8621 4.64586 20.9371 4.83752C21.0121 5.02919 21.0079 5.21669 20.9246 5.40002C20.8246 5.60002 20.6788 5.72919 20.4871 5.78752C20.2954 5.84586 20.1079 5.83336 19.9246 5.75002L16.3246 4.10002L13.9746 6.30002V7.70002L16.3246 9.85002L19.9246 8.20002C20.1079 8.11669 20.2996 8.10836 20.4996 8.17502C20.6996 8.24169 20.8413 8.36669 20.9246 8.55002C21.0246 8.75002 21.0329 8.94169 20.9496 9.12502C20.8663 9.30836 20.7246 9.45002 20.5246 9.55002L16.6246 11.4C16.4246 11.5 16.2204 11.5292 16.0121 11.4875C15.8038 11.4459 15.6246 11.35 15.4746 11.2L13.7746 9.60002C13.6746 9.70002 13.5538 9.79169 13.4121 9.87502C13.2704 9.95836 13.1246 10 12.9746 10C12.6913 10 12.4538 9.90419 12.2621 9.71252C12.0704 9.52086 11.9746 9.28336 11.9746 9.00002V8.00002H8.77461C8.72461 8.13336 8.67044 8.25836 8.61211 8.37502C8.55378 8.49169 8.47461 8.61669 8.37461 8.75002L13.3746 18H16.9746V21H3.97461ZM5.97461 8.00002C6.25794 8.00002 6.49544 7.90419 6.68711 7.71252C6.87878 7.52086 6.97461 7.28336 6.97461 7.00002C6.97461 6.71669 6.87878 6.47919 6.68711 6.28752C6.49544 6.09586 6.25794 6.00002 5.97461 6.00002C5.69128 6.00002 5.45378 6.09586 5.26211 6.28752C5.07044 6.47919 4.97461 6.71669 4.97461 7.00002C4.97461 7.28336 5.07044 7.52086 5.26211 7.71252C5.45378 7.90419 5.69128 8.00002 5.97461 8.00002ZM9.12461 18H11.0746L6.77461 10H6.67461L9.12461 18Z" />
    </svg>
  ),
  ICFilter: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M7.33371 13.3327C7.14482 13.3327 6.98649 13.2688 6.85871 13.141C6.73094 13.0132 6.66705 12.8549 6.66705 12.666V8.66602L2.80038 3.73268C2.63371 3.51046 2.60871 3.27713 2.72538 3.03268C2.84205 2.78824 3.04482 2.66602 3.33371 2.66602H12.667C12.9559 2.66602 13.1587 2.78824 13.2754 3.03268C13.392 3.27713 13.367 3.51046 13.2004 3.73268L9.33371 8.66602V12.666C9.33371 12.8549 9.26982 13.0132 9.14205 13.141C9.01427 13.2688 8.85593 13.3327 8.66705 13.3327H7.33371ZM8.00038 8.19935L11.3004 3.99935H4.70038L8.00038 8.19935Z" />
    </svg>
  ),
  ICViewStream: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M15.8333 14.166V10.8327H4.16667V14.166H15.8333ZM15.8333 9.16602V5.83268H4.16667V9.16602H15.8333ZM4.16667 15.8327C3.70833 15.8327 3.31597 15.6695 2.98958 15.3431C2.66319 15.0167 2.5 14.6243 2.5 14.166V5.83268C2.5 5.37435 2.66319 4.98199 2.98958 4.6556C3.31597 4.32921 3.70833 4.16602 4.16667 4.16602H15.8333C16.2917 4.16602 16.684 4.32921 17.0104 4.6556C17.3368 4.98199 17.5 5.37435 17.5 5.83268V14.166C17.5 14.6243 17.3368 15.0167 17.0104 15.3431C16.684 15.6695 16.2917 15.8327 15.8333 15.8327H4.16667Z" />
    </svg>
  ),
  ICViewInAR: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M14.666 25.9667L7.99935 22.1334C7.57713 21.889 7.24935 21.5667 7.01602 21.1667C6.78268 20.7667 6.66602 20.3223 6.66602 19.8334V12.1667C6.66602 11.6779 6.78268 11.2334 7.01602 10.8334C7.24935 10.4334 7.57713 10.1112 7.99935 9.86675L14.666 6.03341C15.0882 5.78897 15.5327 5.66675 15.9993 5.66675C16.466 5.66675 16.9105 5.78897 17.3327 6.03341L23.9993 9.86675C24.4216 10.1112 24.7493 10.4334 24.9827 10.8334C25.216 11.2334 25.3327 11.6779 25.3327 12.1667V19.8334C25.3327 20.3223 25.216 20.7667 24.9827 21.1667C24.7493 21.5667 24.4216 21.889 23.9993 22.1334L17.3327 25.9667C16.9105 26.2112 16.466 26.3334 15.9993 26.3334C15.5327 26.3334 15.0882 26.2112 14.666 25.9667ZM14.666 22.9001V16.7667L9.33268 13.6667V19.8334L14.666 22.9001ZM17.3327 22.9001L22.666 19.8334V13.6667L17.3327 16.7667V22.9001ZM2.66602 9.33342V5.33341C2.66602 4.60008 2.92713 3.9723 3.44935 3.45008C3.97157 2.92786 4.59935 2.66675 5.33268 2.66675H9.33268V5.33341H5.33268V9.33342H2.66602ZM9.33268 29.3334H5.33268C4.59935 29.3334 3.97157 29.0723 3.44935 28.5501C2.92713 28.0279 2.66602 27.4001 2.66602 26.6667V22.6667H5.33268V26.6667H9.33268V29.3334ZM22.666 29.3334V26.6667H26.666V22.6667H29.3327V26.6667C29.3327 27.4001 29.0716 28.0279 28.5494 28.5501C28.0271 29.0723 27.3994 29.3334 26.666 29.3334H22.666ZM26.666 9.33342V5.33341H22.666V2.66675H26.666C27.3994 2.66675 28.0271 2.92786 28.5494 3.45008C29.0716 3.9723 29.3327 4.60008 29.3327 5.33341V9.33342H26.666ZM15.9993 14.4667L21.266 11.3667L15.9993 8.33342L10.7327 11.3667L15.9993 14.4667Z" />
    </svg>
  ),
  ICList: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M5.33333 11.3333C5.52222 11.3333 5.68056 11.2694 5.80833 11.1417C5.93611 11.0139 6 10.8556 6 10.6667C6 10.4778 5.93611 10.3194 5.80833 10.1917C5.68056 10.0639 5.52222 10 5.33333 10C5.14444 10 4.98611 10.0639 4.85833 10.1917C4.73056 10.3194 4.66667 10.4778 4.66667 10.6667C4.66667 10.8556 4.73056 11.0139 4.85833 11.1417C4.98611 11.2694 5.14444 11.3333 5.33333 11.3333ZM5.33333 8.66667C5.52222 8.66667 5.68056 8.60278 5.80833 8.475C5.93611 8.34722 6 8.18889 6 8C6 7.81111 5.93611 7.65278 5.80833 7.525C5.68056 7.39722 5.52222 7.33333 5.33333 7.33333C5.14444 7.33333 4.98611 7.39722 4.85833 7.525C4.73056 7.65278 4.66667 7.81111 4.66667 8C4.66667 8.18889 4.73056 8.34722 4.85833 8.475C4.98611 8.60278 5.14444 8.66667 5.33333 8.66667ZM5.33333 6C5.52222 6 5.68056 5.93611 5.80833 5.80833C5.93611 5.68056 6 5.52222 6 5.33333C6 5.14444 5.93611 4.98611 5.80833 4.85833C5.68056 4.73056 5.52222 4.66667 5.33333 4.66667C5.14444 4.66667 4.98611 4.73056 4.85833 4.85833C4.73056 4.98611 4.66667 5.14444 4.66667 5.33333C4.66667 5.52222 4.73056 5.68056 4.85833 5.80833C4.98611 5.93611 5.14444 6 5.33333 6ZM7.33333 11.3333H11.3333V10H7.33333V11.3333ZM7.33333 8.66667H11.3333V7.33333H7.33333V8.66667ZM7.33333 6H11.3333V4.66667H7.33333V6ZM3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM3.33333 12.6667H12.6667V3.33333H3.33333V12.6667Z" />
    </svg>
  ),
  ICTexture: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M4.4 21C4.08333 20.9333 3.7875 20.7625 3.5125 20.4875C3.2375 20.2125 3.06667 19.9167 3 19.6L19.6 3C19.95 3.08333 20.25 3.25417 20.5 3.5125C20.75 3.77083 20.925 4.06667 21.025 4.4L4.4 21ZM3 14.7V11.9L11.9 3H14.7L3 14.7ZM3 7V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H7L3 7ZM17 21L21 17V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H17ZM9.3 21L21 9.3V12.1L12.1 21H9.3Z" />
    </svg>
  ),
  ICWarehouse: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M4 19H6V11H18V19H20V8.35L12 5.15L4 8.35V19ZM2 21V7L12 3L22 7V21H16V13H8V21H2ZM9 21V19H11V21H9ZM11 18V16H13V18H11ZM13 21V19H15V21H13Z" />
    </svg>
  ),
  ICDashboard: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 9V3H21V9H13ZM3 13V3H11V13H3ZM13 21V11H21V21H13ZM3 21V15H11V21H3ZM5 11H9V5H5V11ZM15 19H19V13H15V19ZM15 7H19V5H15V7ZM5 19H9V17H5V19Z"
        fill="#414549"
      />
    </svg>
  ),
  ICStack: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 14L1 8L12 2L23 8L12 14ZM12 18L1.575 12.325L3.675 11.175L12 15.725L20.325 11.175L22.425 12.325L12 18ZM12 22L1.575 16.325L3.675 15.175L12 19.725L20.325 15.175L22.425 16.325L12 22ZM12 11.725L18.825 8L12 4.275L5.175 8L12 11.725Z" />
    </svg>
  ),
  ICSurface: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M2 17L4 7H20L22 17H2ZM4.59374 15H19.5L18.5 9H5.5L4.59374 15Z" />
    </svg>
  ),
  ICPinDrop: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M10 13.7291C11.375 12.618 12.4132 11.5486 13.1146 10.5208C13.816 9.49302 14.1667 8.52774 14.1667 7.62496C14.1667 6.37496 13.7778 5.34718 13 4.54163C12.2222 3.73607 11.2222 3.33329 10 3.33329C8.77777 3.33329 7.77778 3.73607 7 4.54163C6.22222 5.34718 5.83333 6.37496 5.83333 7.62496C5.83333 8.52774 6.18403 9.49302 6.88541 10.5208C7.5868 11.5486 8.625 12.618 10 13.7291ZM10 15.8333C8.04166 14.3888 6.57986 12.9861 5.61458 11.625C4.6493 10.2638 4.16666 8.93052 4.16666 7.62496C4.16666 5.88885 4.70833 4.46177 5.79166 3.34371C6.875 2.22565 8.27777 1.66663 10 1.66663C11.7222 1.66663 13.125 2.22565 14.2083 3.34371C15.2917 4.46177 15.8333 5.88885 15.8333 7.62496C15.8333 8.93052 15.3507 10.2638 14.3854 11.625C13.4201 12.9861 11.9583 14.3888 10 15.8333ZM10 9.16663C10.4583 9.16663 10.8507 9.00343 11.1771 8.67704C11.5035 8.35065 11.6667 7.95829 11.6667 7.49996C11.6667 7.04163 11.5035 6.64927 11.1771 6.32288C10.8507 5.99649 10.4583 5.83329 10 5.83329C9.54166 5.83329 9.1493 5.99649 8.82291 6.32288C8.49652 6.64927 8.33333 7.04163 8.33333 7.49996C8.33333 7.95829 8.49652 8.35065 8.82291 8.67704C9.1493 9.00343 9.54166 9.16663 10 9.16663ZM4.16666 18.3333V16.6666H15.8333V18.3333H4.16666Z" />
    </svg>
  ),
  ICAutomationFunction: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M8 12V10H6V12H8ZM10.7 12C10.8833 11.6167 11.0958 11.2583 11.3375 10.925C11.5792 10.5917 11.85 10.2833 12.15 10H10V12H10.7ZM10.1 16C10.0667 15.8333 10.0458 15.6708 10.0375 15.5125C10.0292 15.3542 10.025 15.1833 10.025 15C10.025 14.8167 10.0292 14.6458 10.0375 14.4875C10.0458 14.3292 10.0667 14.1667 10.1 14H6V16H10.1ZM12.125 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V10.15C21.7167 9.85 21.4083 9.57917 21.075 9.3375C20.7417 9.09583 20.3833 8.88333 20 8.7V6H4V18H10.7C10.8833 18.3833 11.0917 18.7417 11.325 19.075C11.5583 19.4083 11.825 19.7167 12.125 20ZM18 20H16L15.7 18.5C15.5 18.4167 15.3125 18.3292 15.1375 18.2375C14.9625 18.1458 14.7833 18.0333 14.6 17.9L13.15 18.35L12.15 16.65L13.3 15.65C13.2667 15.4333 13.25 15.2167 13.25 15C13.25 14.7833 13.2667 14.5667 13.3 14.35L12.15 13.35L13.15 11.65L14.6 12.1C14.7833 11.9667 14.9625 11.8542 15.1375 11.7625C15.3125 11.6708 15.5 11.5833 15.7 11.5L16 10H18L18.3 11.5C18.5 11.5833 18.6917 11.6792 18.875 11.7875C19.0583 11.8958 19.2333 12.0167 19.4 12.15L20.85 11.65L21.85 13.4L20.7 14.4C20.7333 14.6167 20.75 14.825 20.75 15.025C20.75 15.225 20.7333 15.4333 20.7 15.65L21.85 16.65L20.85 18.35L19.4 17.9C19.2167 18.0333 19.0375 18.1458 18.8625 18.2375C18.6875 18.3292 18.5 18.4167 18.3 18.5L18 20ZM17 17C17.55 17 18.0208 16.8042 18.4125 16.4125C18.8042 16.0208 19 15.55 19 15C19 14.45 18.8042 13.9792 18.4125 13.5875C18.0208 13.1958 17.55 13 17 13C16.45 13 15.9792 13.1958 15.5875 13.5875C15.1958 13.9792 15 14.45 15 15C15 15.55 15.1958 16.0208 15.5875 16.4125C15.9792 16.8042 16.45 17 17 17Z" />
    </svg>
  ),
  ICLeftPanelClose: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M16.5 16V8L12.5 12L16.5 16ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM8 19V5H5V19H8ZM10 19H19V5H10V19Z" />
    </svg>
  ),
  ICLeftPanelOpen: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12.5 8V16L16.5 12L12.5 8ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM8 19V5H5V19H8ZM10 19H19V5H10V19Z" />
    </svg>
  ),
  ICPrint: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M12 6V3.75H6V6H4.5V2.25H13.5V6H12ZM13.5 9.375C13.7125 9.375 13.8906 9.30313 14.0344 9.15938C14.1781 9.01563 14.25 8.8375 14.25 8.625C14.25 8.4125 14.1781 8.23438 14.0344 8.09063C13.8906 7.94688 13.7125 7.875 13.5 7.875C13.2875 7.875 13.1094 7.94688 12.9656 8.09063C12.8219 8.23438 12.75 8.4125 12.75 8.625C12.75 8.8375 12.8219 9.01563 12.9656 9.15938C13.1094 9.30313 13.2875 9.375 13.5 9.375ZM12 14.25V11.25H6V14.25H12ZM13.5 15.75H4.5V12.75H1.5V8.25C1.5 7.6125 1.71875 7.07812 2.15625 6.64688C2.59375 6.21563 3.125 6 3.75 6H14.25C14.8875 6 15.4219 6.21563 15.8531 6.64688C16.2844 7.07812 16.5 7.6125 16.5 8.25V12.75H13.5V15.75ZM15 11.25V8.25C15 8.0375 14.9281 7.85938 14.7844 7.71563C14.6406 7.57188 14.4625 7.5 14.25 7.5H3.75C3.5375 7.5 3.35938 7.57188 3.21563 7.71563C3.07188 7.85938 3 8.0375 3 8.25V11.25H4.5V9.75H13.5V11.25H15Z" />
    </svg>
  ),
  ICReceipt: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M4.5 16.5C3.875 16.5 3.34375 16.2813 2.90625 15.8438C2.46875 15.4063 2.25 14.875 2.25 14.25V12H4.5V1.5L5.625 2.625L6.75 1.5L7.875 2.625L9 1.5L10.125 2.625L11.25 1.5L12.375 2.625L13.5 1.5L14.625 2.625L15.75 1.5V14.25C15.75 14.875 15.5313 15.4063 15.0938 15.8438C14.6563 16.2813 14.125 16.5 13.5 16.5H4.5ZM13.5 15C13.7125 15 13.8906 14.9281 14.0344 14.7844C14.1781 14.6406 14.25 14.4625 14.25 14.25V3.75H6V12H12.75V14.25C12.75 14.4625 12.8219 14.6406 12.9656 14.7844C13.1094 14.9281 13.2875 15 13.5 15ZM6.75 6.75V5.25H11.25V6.75H6.75ZM6.75 9V7.5H11.25V9H6.75ZM12.75 6.75C12.5375 6.75 12.3594 6.67813 12.2156 6.53438C12.0719 6.39062 12 6.2125 12 6C12 5.7875 12.0719 5.60938 12.2156 5.46563C12.3594 5.32188 12.5375 5.25 12.75 5.25C12.9625 5.25 13.1406 5.32188 13.2844 5.46563C13.4281 5.60938 13.5 5.7875 13.5 6C13.5 6.2125 13.4281 6.39062 13.2844 6.53438C13.1406 6.67813 12.9625 6.75 12.75 6.75ZM12.75 9C12.5375 9 12.3594 8.92813 12.2156 8.78438C12.0719 8.64063 12 8.4625 12 8.25C12 8.0375 12.0719 7.85938 12.2156 7.71563C12.3594 7.57188 12.5375 7.5 12.75 7.5C12.9625 7.5 13.1406 7.57188 13.2844 7.71563C13.4281 7.85938 13.5 8.0375 13.5 8.25C13.5 8.4625 13.4281 8.64063 13.2844 8.78438C13.1406 8.92813 12.9625 9 12.75 9ZM4.5 15H11.25V13.5H3.75V14.25C3.75 14.4625 3.82188 14.6406 3.96563 14.7844C4.10938 14.9281 4.2875 15 4.5 15Z" />
    </svg>
  ),
  ICDoorKnob: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M9 15V5V19V15ZM7 16H9V19H15V5H9V14H7V5C7 4.45 7.19583 3.97917 7.5875 3.5875C7.97917 3.19583 8.45 3 9 3H15C15.55 3 16.0208 3.19583 16.4125 3.5875C16.8042 3.97917 17 4.45 17 5V19C17 19.55 16.8042 20.0208 16.4125 20.4125C16.0208 20.8042 15.55 21 15 21H9C8.45 21 7.97917 20.8042 7.5875 20.4125C7.19583 20.0208 7 19.55 7 19V16ZM12 10C12.2833 10 12.5208 9.90417 12.7125 9.7125C12.9042 9.52083 13 9.28333 13 9C13 8.71667 12.9042 8.47917 12.7125 8.2875C12.5208 8.09583 12.2833 8 12 8C11.7167 8 11.4792 8.09583 11.2875 8.2875C11.0958 8.47917 11 8.71667 11 9C11 9.28333 11.0958 9.52083 11.2875 9.7125C11.4792 9.90417 11.7167 10 12 10ZM20 9C19.7167 9 19.4792 8.90417 19.2875 8.7125C19.0958 8.52083 19 8.28333 19 8V4C19 3.71667 19.0958 3.47917 19.2875 3.2875C19.4792 3.09583 19.7167 3 20 3C20.2833 3 20.5208 3.09583 20.7125 3.2875C20.9042 3.47917 21 3.71667 21 4V8C21 8.28333 20.9042 8.52083 20.7125 8.7125C20.5208 8.90417 20.2833 9 20 9ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14H12C12.2833 14 12.5208 14.0958 12.7125 14.2875C12.9042 14.4792 13 14.7167 13 15C13 15.2833 12.9042 15.5208 12.7125 15.7125C12.5208 15.9042 12.2833 16 12 16H5Z" />
    </svg>
  ),
  ICFridge: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 14 14"
      fill="currentColor"
    >
      <path d="M4.66536 4.6665V2.9165H5.83203V4.6665H4.66536ZM4.66536 9.9165V6.99984H5.83203V9.9165H4.66536ZM3.4987 12.8332C3.17786 12.8332 2.90331 12.719 2.67503 12.4908C2.44675 12.2625 2.33242 11.9877 2.33203 11.6665V2.33317C2.33203 2.01234 2.44636 1.73778 2.67503 1.5095C2.9037 1.28123 3.17825 1.16689 3.4987 1.1665H10.4987C10.8195 1.1665 11.0943 1.28084 11.3229 1.5095C11.5516 1.73817 11.6658 2.01273 11.6654 2.33317V11.6665C11.6654 11.9873 11.5512 12.2621 11.3229 12.4908C11.0947 12.7194 10.8199 12.8336 10.4987 12.8332H3.4987ZM3.4987 11.6665H10.4987V6.4165H3.4987V11.6665ZM3.4987 5.24984H10.4987V2.33317H3.4987V5.24984Z" />
    </svg>
  ),
  ICLock: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M4.5 16.5C4.0875 16.5 3.73438 16.3531 3.44063 16.0594C3.14687 15.7656 3 15.4125 3 15V7.5C3 7.0875 3.14687 6.73438 3.44063 6.44063C3.73438 6.14688 4.0875 6 4.5 6H5.25V4.5C5.25 3.4625 5.61563 2.57813 6.34688 1.84688C7.07812 1.11563 7.9625 0.75 9 0.75C10.0375 0.75 10.9219 1.11563 11.6531 1.84688C12.3844 2.57813 12.75 3.4625 12.75 4.5V6H13.5C13.9125 6 14.2656 6.14688 14.5594 6.44063C14.8531 6.73438 15 7.0875 15 7.5V15C15 15.4125 14.8531 15.7656 14.5594 16.0594C14.2656 16.3531 13.9125 16.5 13.5 16.5H4.5ZM4.5 15H13.5V7.5H4.5V15ZM9 12.75C9.4125 12.75 9.76563 12.6031 10.0594 12.3094C10.3531 12.0156 10.5 11.6625 10.5 11.25C10.5 10.8375 10.3531 10.4844 10.0594 10.1906C9.76563 9.89688 9.4125 9.75 9 9.75C8.5875 9.75 8.23438 9.89688 7.94063 10.1906C7.64688 10.4844 7.5 10.8375 7.5 11.25C7.5 11.6625 7.64688 12.0156 7.94063 12.3094C8.23438 12.6031 8.5875 12.75 9 12.75ZM6.75 6H11.25V4.5C11.25 3.875 11.0312 3.34375 10.5938 2.90625C10.1563 2.46875 9.625 2.25 9 2.25C8.375 2.25 7.84375 2.46875 7.40625 2.90625C6.96875 3.34375 6.75 3.875 6.75 4.5V6Z" />
    </svg>
  ),
  ICLockOpen: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M3.99984 5.33366H9.99984V4.00033C9.99984 3.44477 9.80539 2.97255 9.4165 2.58366C9.02761 2.19477 8.55539 2.00033 7.99984 2.00033C7.44428 2.00033 6.97206 2.19477 6.58317 2.58366C6.19428 2.97255 5.99984 3.44477 5.99984 4.00033H4.6665C4.6665 3.0781 4.9915 2.29199 5.6415 1.64199C6.2915 0.991992 7.07761 0.666992 7.99984 0.666992C8.92206 0.666992 9.70817 0.991992 10.3582 1.64199C11.0082 2.29199 11.3332 3.0781 11.3332 4.00033V5.33366H11.9998C12.3665 5.33366 12.6804 5.46421 12.9415 5.72533C13.2026 5.98644 13.3332 6.30033 13.3332 6.66699V13.3337C13.3332 13.7003 13.2026 14.0142 12.9415 14.2753C12.6804 14.5364 12.3665 14.667 11.9998 14.667H3.99984C3.63317 14.667 3.31928 14.5364 3.05817 14.2753C2.79706 14.0142 2.6665 13.7003 2.6665 13.3337V6.66699C2.6665 6.30033 2.79706 5.98644 3.05817 5.72533C3.31928 5.46421 3.63317 5.33366 3.99984 5.33366ZM3.99984 13.3337H11.9998V6.66699H3.99984V13.3337ZM7.99984 11.3337C8.3665 11.3337 8.68039 11.2031 8.9415 10.942C9.20261 10.6809 9.33317 10.367 9.33317 10.0003C9.33317 9.63366 9.20261 9.31977 8.9415 9.05866C8.68039 8.79755 8.3665 8.66699 7.99984 8.66699C7.63317 8.66699 7.31928 8.79755 7.05817 9.05866C6.79706 9.31977 6.6665 9.63366 6.6665 10.0003C6.6665 10.367 6.79706 10.6809 7.05817 10.942C7.31928 11.2031 7.63317 11.3337 7.99984 11.3337Z" />
    </svg>
  ),
  ICDuplicate: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ alignSelf: 'stretch', flex: '1 0 0' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M15.8307 15.8335H6.66406C6.20573 15.8335 5.81337 15.6703 5.48698 15.3439C5.16059 15.0175 4.9974 14.6252 4.9974 14.1668V2.50016C4.9974 2.04183 5.16059 1.64947 5.48698 1.32308C5.81337 0.996691 6.20573 0.833496 6.66406 0.833496H12.4974L17.4974 5.8335V14.1668C17.4974 14.6252 17.3342 15.0175 17.0078 15.3439C16.6814 15.6703 16.2891 15.8335 15.8307 15.8335ZM11.6641 6.66683V2.50016H6.66406V14.1668H15.8307V6.66683H11.6641ZM3.33073 19.1668C2.8724 19.1668 2.48003 19.0036 2.15365 18.6772C1.82726 18.3509 1.66406 17.9585 1.66406 17.5002V5.8335H3.33073V17.5002H12.4974V19.1668H3.33073Z" />
    </svg>
  ),
  ICDownLoadDesign: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 11 11"
      fill="currentColor"
    >
      <path d="M5.33333 8L2 4.66667L2.93333 3.7L4.66667 5.43333V0H6V5.43333L7.73333 3.7L8.66667 4.66667L5.33333 8ZM1.33333 10.6667C0.966667 10.6667 0.652778 10.5361 0.391667 10.275C0.130556 10.0139 0 9.7 0 9.33333V7.33333H1.33333V9.33333H9.33333V7.33333H10.6667V9.33333C10.6667 9.7 10.5361 10.0139 10.275 10.275C10.0139 10.5361 9.7 10.6667 9.33333 10.6667H1.33333Z" />
    </svg>
  ),
  ICSendSomething: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M13 22V18L17 17L13 16V12L23 17L13 22ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V15.2C3.8 15.2 4.5 14.9458 5.1 14.4375C5.7 13.9292 6 13.2833 6 12.5C6 11.7167 5.7 11.0708 5.1 10.5625C4.5 10.0542 3.8 9.8 3 9.8V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H9C9 3.3 9.24167 2.70833 9.725 2.225C10.2083 1.74167 10.8 1.5 11.5 1.5C12.2 1.5 12.7917 1.74167 13.275 2.225C13.7583 2.70833 14 3.3 14 4H18C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6V13.25L18 12.25V6H12V4C12 3.86667 11.95 3.75 11.85 3.65C11.75 3.55 11.6333 3.5 11.5 3.5C11.3667 3.5 11.25 3.55 11.15 3.65C11.05 3.75 11 3.86667 11 4V6H5V8.2C5.9 8.53333 6.625 9.09167 7.175 9.875C7.725 10.6583 8 11.5333 8 12.5C8 13.45 7.725 14.3167 7.175 15.1C6.625 15.8833 5.9 16.45 5 16.8V19H7.125C7.40833 18.25 7.89167 17.5958 8.575 17.0375C9.25833 16.4792 10.0667 16.15 11 16.05V18.05C10.3333 18.1833 9.8 18.4958 9.4 18.9875C9 19.4792 8.8 20.15 8.8 21H5Z" />
    </svg>
  ),
  ICWidth: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M5.83333 13.3332L2.5 9.99984L5.83333 6.6665L7.02083 7.83317L5.6875 9.1665H14.3125L13 7.83317L14.1667 6.6665L17.5 9.99984L14.1667 13.3332L13 12.1665L14.3125 10.8332H5.6875L7 12.1665L5.83333 13.3332Z" />
    </svg>
  ),
  ICImagePlaceholder: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 152 152"
      fill="none"
    >
      <g clipPath="url(#clip0_393_64227)">
        <path
          d="M152 152H0C0 129.071 0 106.142 0 83.2125C0 55.4725 0 27.7401 0 0.00012207C50.6692 0.00012207 101.331 0.00012207 152 0.00012207V152Z"
          fill="#F6F6F6"
        />
        <mask
          id="mask0_393_64227"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="152"
          height="153"
        >
          <path
            d="M152 152H0C0 129.071 0 106.142 0 83.2125C0 55.4725 0 27.7401 0 0.00012207C50.6692 0.00012207 101.331 0.00012207 152 0.00012207V152Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_393_64227)">
          <path
            d="M170.468 113.529C164.851 97.9794 161.226 87.9625 152 83.7673C132.316 74.8145 115.763 105.374 89.1782 100.951C61.575 96.353 58.269 59.8654 33.6374 59.2954C12.6082 58.8014 -2.51584 84.9909 -4.28664 88.0613C-16.135 108.581 -16.0818 135.835 -4.33224 155.078C13.4518 184.194 52.417 185.509 93.7077 186.998C128.037 188.237 161.819 189.453 174.777 167.747C184.467 151.491 175.643 127.847 170.468 113.529Z"
            fill="#D6D6D6"
          />
        </g>
        <path
          d="M113.05 56.2402C122.074 56.2402 129.39 48.9245 129.39 39.9002C129.39 30.8758 122.074 23.5602 113.05 23.5602C104.026 23.5602 96.71 30.8758 96.71 39.9002C96.71 48.9245 104.026 56.2402 113.05 56.2402Z"
          fill="#D6D6D6"
        />
      </g>
      <defs>
        <clipPath id="clip0_393_64227">
          <path
            d="M0 4.00012C0 1.79099 1.79086 0.00012207 4 0.00012207H148C150.209 0.00012207 152 1.79098 152 4.00012V148C152 150.209 150.209 152 148 152H4C1.79086 152 0 150.209 0 148V4.00012Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  ICInput: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64687 14.2656 1.5 13.9125 1.5 13.5V11.25H3V13.5H15V4.5H3V6.75H1.5V4.5C1.5 4.0875 1.64687 3.73438 1.94063 3.44063C2.23438 3.14687 2.5875 3 3 3H15C15.4125 3 15.7656 3.14687 16.0594 3.44063C16.3531 3.73438 16.5 4.0875 16.5 4.5V13.5C16.5 13.9125 16.3531 14.2656 16.0594 14.5594C15.7656 14.8531 15.4125 15 15 15H3ZM8.625 12.375L7.575 11.2875L9.13125 9.75H1.5V8.25H9.13125L7.575 6.7125L8.625 5.625L12 9L8.625 12.375Z" />
    </svg>
  ),
  ICDelivery: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M5.83329 16.6663C5.13885 16.6663 4.54857 16.4233 4.06246 15.9372C3.57635 15.4511 3.33329 14.8608 3.33329 14.1663H1.24996L1.62496 12.4997H3.97913C4.21524 12.2358 4.49301 12.0309 4.81246 11.8851C5.1319 11.7393 5.47218 11.6663 5.83329 11.6663C6.1944 11.6663 6.53468 11.7393 6.85413 11.8851C7.17357 12.0309 7.45135 12.2358 7.68746 12.4997H11.1666L12.9166 4.99967H3.79163L3.87496 4.64551C3.95829 4.25662 4.14927 3.94065 4.44788 3.69759C4.74649 3.45454 5.09718 3.33301 5.49996 3.33301H15L14.2291 6.66634H16.6666L19.1666 9.99967L18.3333 14.1663H16.6666C16.6666 14.8608 16.4236 15.4511 15.9375 15.9372C15.4513 16.4233 14.8611 16.6663 14.1666 16.6663C13.4722 16.6663 12.8819 16.4233 12.3958 15.9372C11.9097 15.4511 11.6666 14.8608 11.6666 14.1663H8.33329C8.33329 14.8608 8.09024 15.4511 7.60413 15.9372C7.11802 16.4233 6.52774 16.6663 5.83329 16.6663ZM13.2708 10.833H17.2916L17.375 10.3955L15.8333 8.33301H13.8541L13.2708 10.833ZM12.875 5.14551L12.9166 4.99967L11.1666 12.4997L11.2083 12.3538L11.9166 9.31217L12.875 5.14551ZM0.416626 11.1038L0.833293 9.43717H5.41663L4.99996 11.1038H0.416626ZM2.08329 8.06217L2.49996 6.39551H7.91663L7.49996 8.06217H2.08329ZM5.83329 14.9997C6.0694 14.9997 6.26732 14.9198 6.42704 14.7601C6.58676 14.6004 6.66663 14.4025 6.66663 14.1663C6.66663 13.9302 6.58676 13.7323 6.42704 13.5726C6.26732 13.4129 6.0694 13.333 5.83329 13.333C5.59718 13.333 5.39926 13.4129 5.23954 13.5726C5.07982 13.7323 4.99996 13.9302 4.99996 14.1663C4.99996 14.4025 5.07982 14.6004 5.23954 14.7601C5.39926 14.9198 5.59718 14.9997 5.83329 14.9997ZM14.1666 14.9997C14.4027 14.9997 14.6007 14.9198 14.7604 14.7601C14.9201 14.6004 15 14.4025 15 14.1663C15 13.9302 14.9201 13.7323 14.7604 13.5726C14.6007 13.4129 14.4027 13.333 14.1666 13.333C13.9305 13.333 13.7326 13.4129 13.5729 13.5726C13.4132 13.7323 13.3333 13.9302 13.3333 14.1663C13.3333 14.4025 13.4132 14.6004 13.5729 14.7601C13.7326 14.9198 13.9305 14.9997 14.1666 14.9997Z" />
    </svg>
  ),
  ICSuccess: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M7.95 12.45L13.2375 7.1625L12.1875 6.1125L7.95 10.35L5.8125 8.2125L4.7625 9.2625L7.95 12.45ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69688 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69688 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69688 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69688 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9 15C10.675 15 12.0938 14.4188 13.2563 13.2563C14.4188 12.0938 15 10.675 15 9C15 7.325 14.4188 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0938 4.74375 13.2563C5.90625 14.4188 7.325 15 9 15Z" />
    </svg>
  ),
  ICArrow2: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="8"
      viewBox="0 0 35 8"
      fill="none"
    >
      <path
        d="M34.3536 4.35355C34.5488 4.15829 34.5488 3.84171 34.3536 3.64645L31.1716 0.464466C30.9763 0.269204 30.6597 0.269204 30.4645 0.464466C30.2692 0.659728 30.2692 0.976311 30.4645 1.17157L33.2929 4L30.4645 6.82843C30.2692 7.02369 30.2692 7.34027 30.4645 7.53553C30.6597 7.7308 30.9763 7.7308 31.1716 7.53553L34.3536 4.35355ZM0 4.5H34V3.5H0V4.5Z"
        fill="#808B90"
      />
    </svg>
  ),
  ICWarning: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M1.33325 27.9998L15.9999 2.6665L30.6666 27.9998H1.33325ZM5.93325 25.3332H26.0666L15.9999 7.99984L5.93325 25.3332ZM15.9999 23.9998C16.3777 23.9998 16.6944 23.8721 16.9499 23.6165C17.2055 23.3609 17.3333 23.0443 17.3333 22.6665C17.3333 22.2887 17.2055 21.9721 16.9499 21.7165C16.6944 21.4609 16.3777 21.3332 15.9999 21.3332C15.6221 21.3332 15.3055 21.4609 15.0499 21.7165C14.7944 21.9721 14.6666 22.2887 14.6666 22.6665C14.6666 23.0443 14.7944 23.3609 15.0499 23.6165C15.3055 23.8721 15.6221 23.9998 15.9999 23.9998ZM14.6666 19.9998H17.3333V13.3332H14.6666V19.9998Z" />
    </svg>
  ),
  ICInProgress: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3C13 3.28333 12.9042 3.52083 12.7125 3.7125C12.5208 3.90417 12.2833 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 11.7167 20.0958 11.4792 20.2875 11.2875C20.4792 11.0958 20.7167 11 21 11C21.2833 11 21.5208 11.0958 21.7125 11.2875C21.9042 11.4792 22 11.7167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22Z" />
    </svg>
  ),
  ICLoading: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch', width, height }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#ic-loading-clip)">
        <g transform="matrix(0.012 1.43099e-10 -1.43099e-10 0.012 12 12)">
          <foreignObject
            x="-1083.33"
            y="-1083.33"
            width="2166.67"
            height="2166.67"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                background:
                  'conic-gradient(from 90deg, rgba(43, 46, 49, 0) 0deg, rgba(43, 46, 49, 1) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
      </g>
      <defs>
        <clipPath id="ic-loading-clip">
          <path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 20.64C16.7717 20.64 20.64 16.7717 20.64 12C20.64 7.22826 16.7717 3.36 12 3.36C7.22826 3.36 3.36 7.22826 3.36 12C3.36 16.7717 7.22826 20.64 12 20.64Z" />
        </clipPath>
      </defs>
    </svg>
  ),
  ICSwitchAccess: ({ width, height }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
        width: width,
        height: height,
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M1 20V4H11V8H9V6H3V18H9V16H11V20H1ZM13 20V16H15V18H17V20H13ZM19 20V18H21V16H23V20H19ZM13 8V4H17V6H15V8H13ZM21 8V6H19V4H23V8H21ZM17 16L15.6 14.6L17.175 13H6V11H17.175L15.6 9.4L17 8L21 12L17 16Z" />
    </svg>
  ),
  ICMenu: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z" />
    </svg>
  ),
  ICCart: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V8C4 7.45 4.19583 6.97917 4.5875 6.5875C4.97917 6.19583 5.45 6 6 6H8C8 4.9 8.39167 3.95833 9.175 3.175C9.95833 2.39167 10.9 2 12 2C13.1 2 14.0417 2.39167 14.825 3.175C15.6083 3.95833 16 4.9 16 6H18C18.55 6 19.0208 6.19583 19.4125 6.5875C19.8042 6.97917 20 7.45 20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V8H16V10C16 10.2833 15.9042 10.5208 15.7125 10.7125C15.5208 10.9042 15.2833 11 15 11C14.7167 11 14.4792 10.9042 14.2875 10.7125C14.0958 10.5208 14 10.2833 14 10V8H10V10C10 10.2833 9.90417 10.5208 9.7125 10.7125C9.52083 10.9042 9.28333 11 9 11C8.71667 11 8.47917 10.9042 8.2875 10.7125C8.09583 10.5208 8 10.2833 8 10V8H6V20ZM10 6H14C14 5.45 13.8042 4.97917 13.4125 4.5875C13.0208 4.19583 12.55 4 12 4C11.45 4 10.9792 4.19583 10.5875 4.5875C10.1958 4.97917 10 5.45 10 6Z" />
    </svg>
  ),
  ICFavorite: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 20.9999L10.55 19.6999C8.86667 18.1832 7.475 16.8749 6.375 15.7749C5.275 14.6749 4.4 13.6874 3.75 12.8124C3.1 11.9374 2.64583 11.1332 2.3875 10.3999C2.12917 9.66657 2 8.91657 2 8.1499C2 6.58324 2.525 5.2749 3.575 4.2249C4.625 3.1749 5.93333 2.6499 7.5 2.6499C8.36667 2.6499 9.19167 2.83324 9.975 3.1999C10.7583 3.56657 11.4333 4.08324 12 4.7499C12.5667 4.08324 13.2417 3.56657 14.025 3.1999C14.8083 2.83324 15.6333 2.6499 16.5 2.6499C18.0667 2.6499 19.375 3.1749 20.425 4.2249C21.475 5.2749 22 6.58324 22 8.1499C22 8.91657 21.8708 9.66657 21.6125 10.3999C21.3542 11.1332 20.9 11.9374 20.25 12.8124C19.6 13.6874 18.725 14.6749 17.625 15.7749C16.525 16.8749 15.1333 18.1832 13.45 19.6999L12 20.9999ZM12 18.2999C13.6 16.8666 14.9167 15.6374 15.95 14.6124C16.9833 13.5874 17.8 12.6957 18.4 11.9374C19 11.1791 19.4167 10.5041 19.65 9.9124C19.8833 9.32074 20 8.73324 20 8.1499C20 7.1499 19.6667 6.31657 19 5.6499C18.3333 4.98324 17.5 4.6499 16.5 4.6499C15.7167 4.6499 14.9917 4.87074 14.325 5.3124C13.6583 5.75407 13.2 6.31657 12.95 6.9999H11.05C10.8 6.31657 10.3417 5.75407 9.675 5.3124C9.00833 4.87074 8.28333 4.6499 7.5 4.6499C6.5 4.6499 5.66667 4.98324 5 5.6499C4.33333 6.31657 4 7.1499 4 8.1499C4 8.73324 4.11667 9.32074 4.35 9.9124C4.58333 10.5041 5 11.1791 5.6 11.9374C6.2 12.6957 7.01667 13.5874 8.05 14.6124C9.08333 15.6374 10.4 16.8666 12 18.2999Z" />
    </svg>
  ),
  ICSpecial: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10 4L19.2649 7.0883C20.5849 7.52832 21.245 7.74832 21.6225 8.2721C22 8.79587 22 9.49159 22 10.883V17L10 14V4Z"
        fill={color2}
      />
      <path
        d="M10 4L4.21115 6.89443C3.13531 7.43234 2.5974 7.7013 2.2987 8.18461C2 8.66791 2 9.26932 2 10.4721V17L10 14V4Z"
        fill={color3}
      />
      <path
        d="M2 17L10 14L22 17L16.5046 20.1402C15.7631 20.564 15.3923 20.7758 14.9802 20.8215C14.5681 20.8671 14.16 20.7415 13.3437 20.4904L2 17Z"
        fill={color1}
      />
    </svg>
  ),
  ICSpecial2: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 19C6 18.4477 6.44772 18 7 18H9C9.55228 18 10 18.4477 10 19V21C10 21.5523 9.55228 22 9 22H7C6.44772 22 6 21.5523 6 21V19Z"
        fill={color1}
      />
      <path
        d="M14 19C14 18.4477 14.4477 18 15 18H17C17.5523 18 18 18.4477 18 19V21C18 21.5523 17.5523 22 17 22H15C14.4477 22 14 21.5523 14 21V19Z"
        fill={color1}
      />
      <path
        d="M19 2H5C4.44772 2 4 2.44772 4 3V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V3C20 2.44772 19.5523 2 19 2Z"
        fill={color2}
      />
      <path
        d="M17 11H7C6.44772 11 6 11.4477 6 12V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V12C18 11.4477 17.5523 11 17 11Z"
        fill={color3}
      />
      <path
        d="M17 4H7C6.44772 4 6 4.44772 6 5V9C6 9.55229 6.44772 10 7 10H17C17.5523 10 18 9.55229 18 9V5C18 4.44772 17.5523 4 17 4Z"
        fill={color3}
      />
      <path
        d="M13 14H11C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14Z"
        fill={color1}
      />
      <path
        d="M13 6H11C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8H13C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6Z"
        fill={color3}
      />
    </svg>
  ),
  ICSpecial3: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 3.58054H5C4.44772 3.58054 4 3.99937 4 4.51602V19.4837C4 20.0003 4.44772 20.4192 5 20.4192H19C19.5523 20.4192 20 20.0003 20 19.4837V4.51602C20 3.99937 19.5523 3.58054 19 3.58054Z"
        fill={color3}
      />
      <path
        d="M15.9233 2.72254L4.9233 3.5141C4.40231 3.55159 4 3.958 4 4.44682V19.5529C4 20.0417 4.40231 20.4481 4.9233 20.4856L15.9233 21.2772C16.5041 21.319 17 20.8894 17 20.3444V3.65526C17 3.11033 16.5041 2.68074 15.9233 2.72254Z"
        fill={color2}
      />
      <path
        d="M15 12.9353V11.0644C15 10.5477 14.5523 10.1289 14 10.1289C13.4477 10.1289 13 10.5477 13 11.0644V12.9353C13 13.452 13.4477 13.8708 14 13.8708C14.5523 13.8708 15 13.452 15 12.9353Z"
        fill={color1}
      />
    </svg>
  ),
  ICSpecial4: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.75 2.55C6.75 1.9701 7.2201 1.5 7.8 1.5H14.1C14.6799 1.5 15.15 1.9701 15.15 2.55V21.45C15.15 22.0299 14.6799 22.5 14.1 22.5H7.8C7.2201 22.5 6.75 22.0299 6.75 21.45V2.55Z"
        fill={color2}
      />
      <path
        d="M13.05 17.25C13.05 18.4098 12.1098 19.35 10.95 19.35C9.7902 19.35 8.85 18.4098 8.85 17.25C8.85 16.0902 9.7902 15.15 10.95 15.15C12.1098 15.15 13.05 16.0902 13.05 17.25Z"
        fill={color3}
      />
      <path
        d="M16.2 16.2H10.95C10.3701 16.2 9.9 16.6701 9.9 17.25C9.9 17.8299 10.3701 18.3 10.95 18.3H16.2C16.7799 18.3 17.25 17.8299 17.25 17.25C17.25 16.6701 16.7799 16.2 16.2 16.2Z"
        fill={color1}
      />
      <path
        d="M8.85 5.7C8.85 5.1201 9.3201 4.65 9.9 4.65H12C12.5799 4.65 13.05 5.1201 13.05 5.7V10.95C13.05 11.5299 12.5799 12 12 12H9.9C9.3201 12 8.85 11.5299 8.85 10.95V5.7Z"
        fill={color3}
      />
    </svg>
  ),
  ICSpecial5: ({ color2 = '#E5E7E8', color3 = '#AAB2B6' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.43233 15.8463C2.54515 15.06 1.60156 14.6668 1.60156 14.0002C1.60156 13.3335 2.54515 12.9403 4.43233 12.154L11.2323 9.32068C11.6118 9.16256 11.8016 9.0835 12.0016 9.0835C12.2016 9.0835 12.3913 9.16256 12.7708 9.32068L19.5708 12.154C21.458 12.9403 22.4016 13.3335 22.4016 14.0002C22.4016 14.6668 21.458 15.06 19.5708 15.8463L12.7708 18.6797C12.3913 18.8378 12.2016 18.9168 12.0016 18.9168C11.8016 18.9168 11.6118 18.8378 11.2323 18.6797L4.43233 15.8463Z"
        fill={color3}
      />
      <path
        d="M4.43233 11.8463C2.54515 11.06 1.60156 10.6668 1.60156 10.0002C1.60156 9.3335 2.54515 8.94033 4.43233 8.15401L11.2323 5.32068C11.6118 5.16256 11.8016 5.0835 12.0016 5.0835C12.2016 5.0835 12.3913 5.16256 12.7708 5.32068L19.5708 8.15401C21.458 8.94033 22.4016 9.3335 22.4016 10.0002C22.4016 10.6668 21.458 11.06 19.5708 11.8463L12.7708 14.6797C12.3913 14.8378 12.2016 14.9168 12.0016 14.9168C11.8016 14.9168 11.6118 14.8378 11.2323 14.6797L4.43233 11.8463Z"
        fill={color2}
      />
    </svg>
  ),
  ICSpecial6: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 14C21.5523 14 22 14.4477 22 15V21C22 21.5523 21.5523 22 21 22H6C3.79086 22 2 20.2091 2 18C2 15.7909 3.79086 14 6 14H21Z"
        fill={color2}
      />
      <path
        d="M20 15C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 20.5523 15 20V16C15 15.4477 15.4477 15 16 15H20Z"
        fill={color2}
      />
      <path
        d="M14.3506 3.73668C14.7241 3.32982 15.3567 3.30276 15.7635 3.67624L20.1836 7.73367C20.5905 8.10715 20.6175 8.73974 20.2441 9.14659L9.59841 20.7438C8.10451 22.3712 5.57416 22.4794 3.94673 20.9855C2.3193 19.4916 2.21105 16.9613 3.70496 15.3338L14.3506 3.73668Z"
        fill={color3}
      />
      <path
        d="M2 3C2 2.44772 2.44772 2 3 2H9C9.55229 2 10 2.44772 10 3V18C10 20.2091 8.20914 22 6 22C3.79086 22 2 20.2091 2 18L2 3Z"
        fill={color2}
      />
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4V8C9 8.55228 8.55228 9 8 9H4C3.44772 9 3 8.55228 3 8V4Z"
        fill={color3}
      />
      <path
        d="M3 11C3 10.4477 3.44772 10 4 10H8C8.55228 10 9 10.4477 9 11C9 11.5523 8.55228 12 8 12H4C3.44772 12 3 11.5523 3 11Z"
        fill={color3}
      />
      <path
        d="M8 18C8 19.1046 7.10457 20 6 20C4.89543 20 4 19.1046 4 18C4 16.8954 4.89543 16 6 16C7.10457 16 8 16.8954 8 18Z"
        fill={color1}
      />
    </svg>
  ),
  ICSpecial7: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
    >
      <path d="M7.05857 0H9.05857V4H7.05857V0Z" fill="#818589" />
      <path
        d="M4.14734 16.4675C4.29368 16.2334 4.60215 16.1621 4.83633 16.3085C5.07051 16.4548 5.14172 16.7633 4.99539 16.9975L3.93555 18.6936C3.78922 18.9277 3.48075 18.999 3.24657 18.8526C3.01239 18.7063 2.94117 18.3978 3.0875 18.1636L4.14734 16.4675Z"
        fill={color2}
      />
      <path
        d="M7.54145 17.5805C7.54145 17.3044 7.76531 17.0805 8.04145 17.0805C8.3176 17.0805 8.54145 17.3044 8.54145 17.5805V19.5805C8.54145 19.8566 8.3176 20.0805 8.04145 20.0805C7.76531 20.0805 7.54145 19.8566 7.54145 19.5805V17.5805Z"
        fill={color2}
      />
      <path
        d="M11.2116 16.9843C11.0653 16.7501 11.1365 16.4416 11.3707 16.2953C11.6048 16.1489 11.9133 16.2202 12.0596 16.4543L13.1195 18.1504C13.2658 18.3846 13.1946 18.6931 12.9604 18.8394C12.7262 18.9858 12.4178 18.9145 12.2714 18.6804L11.2116 16.9843Z"
        fill={color2}
      />
      <path
        d="M13.5299 14.8855C13.3247 14.7007 13.3081 14.3845 13.4929 14.1793C13.6777 13.9741 13.9938 13.9575 14.199 14.1423L15.6853 15.4806C15.8905 15.6654 15.9071 15.9815 15.7223 16.1867C15.5376 16.3919 15.2214 16.4085 15.0162 16.2237L13.5299 14.8855Z"
        fill={color2}
      />
      <path
        d="M1.88131 14.1423C2.08652 13.9575 2.40267 13.9741 2.58744 14.1793C2.77222 14.3845 2.75565 14.7007 2.55044 14.8854L1.06415 16.2237C0.858934 16.4085 0.542785 16.3919 0.35801 16.1867C0.173235 15.9815 0.189803 15.6653 0.395017 15.4806L1.88131 14.1423Z"
        fill={color2}
      />
      <path
        d="M5.05857 5C5.05857 4.44772 5.50629 4 6.05857 4H10.0586C10.6109 4 11.0586 4.44772 11.0586 5V6H5.05857V5Z"
        fill={color1}
      />
      <path
        d="M3.75946 6.41876C3.94717 6.15597 4.25024 6 4.57319 6H11.544C11.8669 6 12.17 6.15597 12.3577 6.41876L15.9291 11.4188C16.4019 12.0806 15.9288 13 15.1154 13H1.00176C0.188391 13 -0.284734 12.0806 0.188029 11.4188L3.75946 6.41876Z"
        fill={color2}
      />
      <path
        d="M12.0586 13C11.1464 14.2143 9.69431 15 8.05857 15C6.42283 15 4.97079 14.2143 4.05857 13H12.0586Z"
        fill={color3}
      />
    </svg>
  ),
  ICKitchenIsland: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 8H3C2.44772 8 2 8.44772 2 9V10C2 10.5523 2.44772 11 3 11H21C21.5523 11 22 10.5523 22 10V9C22 8.44772 21.5523 8 21 8Z"
        fill={color3}
      />
      <path
        d="M21 11H3L3 19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V11Z"
        fill={color2}
      />
      <path
        d="M12 5C12 4.44772 12.4477 4 13 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H13C12.4477 8 12 7.55228 12 7V5Z"
        fill={color1}
      />
      <path
        d="M7 4C7.55228 4 8 4.44772 8 5C8 5.55228 7.55228 6 7 6H6V8H4V4H7Z"
        fill={color1}
      />
    </svg>
  ),
  ICKitchenSurface: ({
    color1 = '#818589',
    color2 = '#E5E7E8',
    color3 = '#AAB2B6',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.2192 7H4.78077C4.3219 7 3.92192 7.3123 3.81062 7.75746L2.31062 13.7575C2.15284 14.3886 2.6302 15 3.28077 15H20.7192C21.3698 15 21.8471 14.3886 21.6894 13.7575L20.1894 7.75746C20.0781 7.3123 19.6781 7 19.2192 7Z"
        fill={color2}
      />
      <path
        d="M18.256 8.5C18.6976 8.5 19.0869 8.78967 19.2138 9.21265L20.1138 12.2127C20.3063 12.8543 19.8258 13.5 19.156 13.5H14.2198C13.5887 13.5 13.1155 12.9227 13.2392 12.3039L13.8392 9.30388C13.9327 8.83646 14.3431 8.5 14.8198 8.5H18.256Z"
        fill={color1}
      />
      <path
        d="M21 15H2.99999V16C2.99999 16.5523 3.44771 17 3.99999 17H20C20.5523 17 21 16.5523 21 16V15Z"
        fill={color3}
      />
      <path
        d="M7.99999 11C7.99999 11.5523 7.32842 12 6.49999 12C5.67156 12 4.99999 11.5523 4.99999 11C4.99999 10.4477 5.67156 10 6.49999 10C7.32842 10 7.99999 10.4477 7.99999 11Z"
        fill={color1}
      />
      <path
        d="M12 11C12 11.5523 11.3284 12 10.5 12C9.67156 12 8.99999 11.5523 8.99999 11C8.99999 10.4477 9.67156 10 10.5 10C11.3284 10 12 10.4477 12 11Z"
        fill={color1}
      />
    </svg>
  ),
  ICWall: ({ color1 = '#818589', color2 = '#E5E7E8', color3 = '#AAB2B6' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3Z"
        fill={color2}
      />
      <path
        d="M7 10V6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6V10C5 10.5523 5.44772 11 6 11C6.55228 11 7 10.5523 7 10Z"
        fill={color3}
      />
      <path
        d="M15 18V14C15 13.4477 14.5523 13 14 13C13.4477 13 13 13.4477 13 14V18C13 18.5523 13.4477 19 14 19C14.5523 19 15 18.5523 15 18Z"
        fill={color3}
      />
      <path
        d="M6 15H10C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13H6C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15Z"
        fill={color1}
      />
      <path
        d="M14 7H18C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5L14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7Z"
        fill={color3}
      />
      <path
        d="M11 10V6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6V10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10Z"
        fill={color3}
      />
      <path
        d="M19 18V14C19 13.4477 18.5523 13 18 13C17.4477 13 17 13.4477 17 14V18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18Z"
        fill={color3}
      />
      <path
        d="M6 19H10C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17H6C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19Z"
        fill={color1}
      />
      <path
        d="M14 11H18C18.5523 11 19 10.5523 19 10C19 9.44772 18.5523 9 18 9H14C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11Z"
        fill={color3}
      />
    </svg>
  ),
  ICProcurement: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M0.833252 15.0003L1.24992 13.3337H5.83325L5.41658 15.0003H0.833252ZM2.49992 11.667L2.91659 10.0003H8.33325L7.91658 11.667H2.49992ZM15.4791 16.667L15.8958 13.3337L16.4999 8.33366L16.7083 6.68783L15.4791 16.667ZM4.99992 18.3337C4.54158 18.3337 4.14922 18.1705 3.82284 17.8441C3.49645 17.5177 3.33325 17.1253 3.33325 16.667H15.4791L16.7083 6.68783H14.4166L14.1874 8.45866C14.1596 8.69477 14.0555 8.8788 13.8749 9.01074C13.6944 9.14269 13.486 9.19477 13.2499 9.16699C13.0138 9.13922 12.8298 9.03852 12.6978 8.86491C12.5659 8.6913 12.5138 8.48644 12.5416 8.25033L12.7291 6.68783H9.41658L9.18742 8.43783C9.15964 8.67394 9.05547 8.86144 8.87492 9.00033C8.69436 9.13922 8.48603 9.19477 8.24992 9.16699C8.01381 9.13922 7.82631 9.03505 7.68742 8.85449C7.54853 8.67394 7.49297 8.4656 7.52075 8.22949L7.70825 6.68783H4.58325C4.63881 6.2156 4.81936 5.8163 5.12492 5.48991C5.43047 5.16352 5.80547 5.00033 6.24992 5.00033H7.91658C8.0277 3.95866 8.38533 3.14269 8.9895 2.55241C9.59367 1.96213 10.4166 1.66699 11.4583 1.66699C12.3471 1.66699 13.0867 1.99685 13.677 2.65658C14.2673 3.3163 14.5555 4.09755 14.5416 5.00033H16.6666C17.1666 5.01421 17.5833 5.20866 17.9166 5.58366C18.2499 5.95866 18.3819 6.39616 18.3124 6.89616L17.0624 16.8962C17.0069 17.3128 16.8228 17.6566 16.5103 17.9274C16.1978 18.1982 15.8333 18.3337 15.4166 18.3337H4.99992ZM9.58325 5.00033H12.8958C12.9096 4.54199 12.7534 4.14963 12.427 3.82324C12.1006 3.49685 11.7083 3.33366 11.2499 3.33366C10.7638 3.33366 10.3784 3.48296 10.0937 3.78158C9.80895 4.08019 9.63881 4.48644 9.58325 5.00033Z" />
    </svg>
  ),
  IC360: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M7.49984 16.6663L6.33317 15.4997L7.7915 13.9997C6.01373 13.7636 4.54845 13.2775 3.39567 12.5413C2.24289 11.8052 1.6665 10.958 1.6665 9.99967C1.6665 8.8469 2.46859 7.86426 4.07275 7.05176C5.67692 6.23926 7.65262 5.83301 9.99984 5.83301C12.3471 5.83301 14.3228 6.23926 15.9269 7.05176C17.5311 7.86426 18.3332 8.8469 18.3332 9.99967C18.3332 10.8608 17.8714 11.6316 16.9478 12.3122C16.0241 12.9927 14.8193 13.4997 13.3332 13.833V12.1247C14.4026 11.8469 15.2255 11.5031 15.8019 11.0934C16.3783 10.6837 16.6665 10.3191 16.6665 9.99967C16.6665 9.55523 16.0728 9.02745 14.8853 8.41634C13.6978 7.80523 12.0693 7.49967 9.99984 7.49967C7.93039 7.49967 6.30192 7.80523 5.11442 8.41634C3.92692 9.02745 3.33317 9.55523 3.33317 9.99967C3.33317 10.333 3.68734 10.7323 4.39567 11.1976C5.104 11.6629 6.11095 12.0136 7.4165 12.2497L6.33317 11.1663L7.49984 9.99967L10.8332 13.333L7.49984 16.6663Z" />
    </svg>
  ),
  ICDataCheck: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 17"
      fill="currentColor"
    >
      <path d="M12.3 7.25L15.825 3.7L15.125 3L12.3 5.825L10.875 4.4L10.175 5.125L12.3 7.25ZM0 17V15H12V17H0ZM13 10C11.6167 10 10.4375 9.5125 9.4625 8.5375C8.4875 7.5625 8 6.38333 8 5C8 3.61667 8.4875 2.4375 9.4625 1.4625C10.4375 0.4875 11.6167 0 13 0C14.3833 0 15.5625 0.4875 16.5375 1.4625C17.5125 2.4375 18 3.61667 18 5C18 6.38333 17.5125 7.5625 16.5375 8.5375C15.5625 9.5125 14.3833 10 13 10ZM0 9V7H6.3C6.41667 7.36667 6.55 7.71667 6.7 8.05C6.85 8.38333 7.03333 8.7 7.25 9H0ZM0 13V11H9.4C9.78333 11.2333 10.1917 11.4292 10.625 11.5875C11.0583 11.7458 11.5167 11.8583 12 11.925V13H0Z" />
    </svg>
  ),
  ICHeight: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M9.99984 17.5L6.6665 14.1667L7.83317 13L9.1665 14.3125V5.6875L7.83317 7L6.6665 5.83333L9.99984 2.5L13.3332 5.83333L12.1665 7.02083L10.8332 5.6875V14.3125L12.1665 13L13.3332 14.1667L9.99984 17.5Z" />
    </svg>
  ),
  ICRotateLeft: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M9.16797 18.3333C8.47352 18.2639 7.80686 18.0938 7.16797 17.8229C6.52908 17.5521 5.91797 17.1944 5.33464 16.75L6.5013 15.5417C6.90408 15.8333 7.33116 16.0694 7.78255 16.25C8.23394 16.4306 8.69575 16.5556 9.16797 16.625V18.3333ZM10.8346 18.3333V16.625C12.2791 16.4167 13.4735 15.7674 14.418 14.6771C15.3624 13.5868 15.8346 12.3194 15.8346 10.875C15.8346 9.25 15.2687 7.87153 14.1367 6.73958C13.0048 5.60764 11.6263 5.04167 10.0013 5.04167H9.83464L11.168 6.375L10.0013 7.54167L6.66797 4.20833L10.0013 0.875L11.168 2.08333L9.8763 3.375H10.0013C11.043 3.375 12.0187 3.57292 12.9284 3.96875C13.8381 4.36458 14.6298 4.89931 15.3034 5.57292C15.977 6.24653 16.5117 7.03819 16.9076 7.94792C17.3034 8.85764 17.5013 9.83333 17.5013 10.875C17.5013 12.7778 16.8694 14.434 15.6055 15.8438C14.3416 17.2535 12.7513 18.0833 10.8346 18.3333ZM4.1263 15.5417C3.68186 14.9583 3.32422 14.3472 3.05339 13.7083C2.78255 13.0694 2.61241 12.4028 2.54297 11.7083H4.2513C4.32075 12.1806 4.44575 12.6424 4.6263 13.0938C4.80686 13.5451 5.04297 13.9722 5.33464 14.375L4.1263 15.5417ZM2.54297 10.0417C2.6263 9.33333 2.79991 8.65278 3.0638 8C3.32769 7.34722 3.68186 6.75 4.1263 6.20833L5.33464 7.375C5.04297 7.77778 4.80686 8.20486 4.6263 8.65625C4.44575 9.10764 4.32075 9.56944 4.2513 10.0417H2.54297Z" />
    </svg>
  ),
  ICArrowRange: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M7 17L2 12L7 7L8.4 8.4L5.825 11H18.175L15.6 8.4L17 7L22 12L17 17L15.6 15.6L18.175 13H5.825L8.4 15.6L7 17Z" />
    </svg>
  ),
  ICLockLocation: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M14.667 10.833C15.5834 10.8331 16.4167 11.1665 17 11.833C17.5833 12.4997 18 13.3333 18 14.25C18 15.2499 17.6669 16.1667 16.917 17C16.2503 17.75 15.5003 18.5003 14.667 19.167C13.8337 18.5004 13.0836 17.7499 12.417 17C11.7503 16.25 11.333 15.3333 11.333 14.25C11.333 13.3333 11.6663 12.4997 12.333 11.833C12.9997 11.1663 13.7503 10.833 14.667 10.833ZM10 0.833008C11.1667 0.833008 12.167 1.24969 12.917 2.08301C13.667 2.91634 14.167 3.83333 14.167 5V6.66699H15C15.5 6.66699 15.8337 6.83366 16.167 7.16699C16.5 7.50014 16.6669 7.83335 16.667 8.33301V9.41699C16.4171 9.3337 16.1669 9.25007 15.917 9.25C15.5837 9.16667 15.3333 9.16699 15 9.16699V8.33301H5V16.667H9.41699C9.50036 17.0001 9.6667 17.2501 9.75 17.5C9.83332 17.75 10.0003 17.9997 10.167 18.333H5C4.58333 18.333 4.16634 18.1663 3.83301 17.833C3.49998 17.4998 3.33309 17.0834 3.33301 16.667V8.33301C3.33308 7.83335 3.49996 7.50014 3.83301 7.16699C4.16634 6.83366 4.58333 6.66699 5 6.66699H5.83301V5C5.83301 3.83334 6.24969 2.83301 7.08301 2.08301C7.91634 1.33301 8.83333 0.833008 10 0.833008ZM14.667 13.167C14.417 13.167 14.1667 13.2503 14 13.417C13.8335 13.5836 13.7501 13.8332 13.75 14.083C13.75 14.333 13.8333 14.5833 14 14.75C14.1667 14.9167 14.417 15 14.667 15C14.9168 14.9999 15.1664 14.9165 15.333 14.75C15.4997 14.5833 15.583 14.333 15.583 14.083C15.5829 13.8332 15.4996 13.6668 15.333 13.417C15.1664 13.2504 14.9169 13.1671 14.667 13.167ZM10 2.5C9.33333 2.5 8.75 2.75 8.25 3.25C7.75 3.75 7.5 4.33333 7.5 5V6.66699H12.5V5C12.5 4.33333 12.25 3.75 11.75 3.25C11.25 2.75 10.6667 2.5 10 2.5Z" />
    </svg>
  ),
  ICBrush: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M4.99984 17.4998C4.37484 17.4998 3.75678 17.347 3.14567 17.0414C2.53456 16.7359 2.0415 16.3331 1.6665 15.8331C2.02762 15.8331 2.39567 15.6907 2.77067 15.406C3.14567 15.1213 3.33317 14.7081 3.33317 14.1664C3.33317 13.472 3.57623 12.8817 4.06234 12.3956C4.54845 11.9095 5.13873 11.6664 5.83317 11.6664C6.52762 11.6664 7.11789 11.9095 7.604 12.3956C8.09012 12.8817 8.33317 13.472 8.33317 14.1664C8.33317 15.0831 8.00678 15.8678 7.354 16.5206C6.70123 17.1734 5.9165 17.4998 4.99984 17.4998ZM4.99984 15.8331C5.45817 15.8331 5.85053 15.6699 6.17692 15.3435C6.50331 15.0171 6.6665 14.6248 6.6665 14.1664C6.6665 13.9303 6.58664 13.7324 6.42692 13.5727C6.2672 13.413 6.06928 13.3331 5.83317 13.3331C5.59706 13.3331 5.39914 13.413 5.23942 13.5727C5.0797 13.7324 4.99984 13.9303 4.99984 14.1664C4.99984 14.4859 4.96164 14.7775 4.88525 15.0414C4.80887 15.3053 4.70817 15.5553 4.58317 15.7914C4.65262 15.8192 4.72206 15.8331 4.7915 15.8331H4.99984ZM9.7915 12.4998L7.49984 10.2081L14.9582 2.74977C15.1109 2.59699 15.3019 2.51713 15.5311 2.51018C15.7603 2.50324 15.9582 2.5831 16.1248 2.74977L17.2498 3.87477C17.4165 4.04143 17.4998 4.23588 17.4998 4.4581C17.4998 4.68032 17.4165 4.87477 17.2498 5.04143L9.7915 12.4998Z" />
    </svg>
  ),
  ICRuler: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M3.33317 15C2.87484 15 2.48248 14.8368 2.15609 14.5104C1.8297 14.184 1.6665 13.7917 1.6665 13.3333V6.66667C1.6665 6.20833 1.8297 5.81597 2.15609 5.48958C2.48248 5.16319 2.87484 5 3.33317 5H16.6665C17.1248 5 17.5172 5.16319 17.8436 5.48958C18.17 5.81597 18.3332 6.20833 18.3332 6.66667V13.3333C18.3332 13.7917 18.17 14.184 17.8436 14.5104C17.5172 14.8368 17.1248 15 16.6665 15H3.33317ZM3.33317 13.3333H16.6665V6.66667H14.1665V10H12.4998V6.66667H10.8332V10H9.1665V6.66667H7.49984V10H5.83317V6.66667H3.33317V13.3333Z" />
    </svg>
  ),
  ICPalette: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 17 17"
      fill="currentColor"
    >
      <path d="M8.33333 16.6667C7.19445 16.6667 6.11806 16.4479 5.10417 16.0104C4.09028 15.5729 3.20486 14.9757 2.44792 14.2188C1.69097 13.4618 1.09375 12.5764 0.65625 11.5625C0.21875 10.5486 0 9.47222 0 8.33333C0 7.18056 0.225694 6.09722 0.677083 5.08333C1.12847 4.06945 1.73958 3.1875 2.51042 2.4375C3.28125 1.6875 4.18056 1.09375 5.20833 0.65625C6.23611 0.21875 7.33333 0 8.5 0C9.61111 0 10.6597 0.190972 11.6458 0.572917C12.6319 0.954861 13.4965 1.48264 14.2396 2.15625C14.9826 2.82986 15.5729 3.62847 16.0104 4.55208C16.4479 5.4757 16.6667 6.47222 16.6667 7.54167C16.6667 9.13889 16.1806 10.3646 15.2083 11.2188C14.2361 12.0729 13.0556 12.5 11.6667 12.5H10.125C10 12.5 9.9132 12.5347 9.86458 12.6042C9.81597 12.6736 9.79167 12.75 9.79167 12.8333C9.79167 13 9.89583 13.2396 10.1042 13.5521C10.3125 13.8646 10.4167 14.2222 10.4167 14.625C10.4167 15.3194 10.2257 15.8333 9.84375 16.1667C9.46181 16.5 8.95833 16.6667 8.33333 16.6667ZM3.75 9.16667C4.11111 9.16667 4.40972 9.04861 4.64583 8.8125C4.88195 8.57639 5 8.27778 5 7.91667C5 7.55556 4.88195 7.25695 4.64583 7.02083C4.40972 6.78472 4.11111 6.66667 3.75 6.66667C3.38889 6.66667 3.09028 6.78472 2.85417 7.02083C2.61806 7.25695 2.5 7.55556 2.5 7.91667C2.5 8.27778 2.61806 8.57639 2.85417 8.8125C3.09028 9.04861 3.38889 9.16667 3.75 9.16667ZM6.25 5.83333C6.61111 5.83333 6.90972 5.71528 7.14583 5.47917C7.38195 5.24306 7.5 4.94445 7.5 4.58333C7.5 4.22222 7.38195 3.92361 7.14583 3.6875C6.90972 3.45139 6.61111 3.33333 6.25 3.33333C5.88889 3.33333 5.59028 3.45139 5.35417 3.6875C5.11806 3.92361 5 4.22222 5 4.58333C5 4.94445 5.11806 5.24306 5.35417 5.47917C5.59028 5.71528 5.88889 5.83333 6.25 5.83333ZM10.4167 5.83333C10.7778 5.83333 11.0764 5.71528 11.3125 5.47917C11.5486 5.24306 11.6667 4.94445 11.6667 4.58333C11.6667 4.22222 11.5486 3.92361 11.3125 3.6875C11.0764 3.45139 10.7778 3.33333 10.4167 3.33333C10.0556 3.33333 9.75695 3.45139 9.52083 3.6875C9.28472 3.92361 9.16667 4.22222 9.16667 4.58333C9.16667 4.94445 9.28472 5.24306 9.52083 5.47917C9.75695 5.71528 10.0556 5.83333 10.4167 5.83333ZM12.9167 9.16667C13.2778 9.16667 13.5764 9.04861 13.8125 8.8125C14.0486 8.57639 14.1667 8.27778 14.1667 7.91667C14.1667 7.55556 14.0486 7.25695 13.8125 7.02083C13.5764 6.78472 13.2778 6.66667 12.9167 6.66667C12.5556 6.66667 12.2569 6.78472 12.0208 7.02083C11.7847 7.25695 11.6667 7.55556 11.6667 7.91667C11.6667 8.27778 11.7847 8.57639 12.0208 8.8125C12.2569 9.04861 12.5556 9.16667 12.9167 9.16667ZM8.33333 15C8.45833 15 8.55903 14.9653 8.63542 14.8958C8.71181 14.8264 8.75 14.7361 8.75 14.625C8.75 14.4306 8.64583 14.2014 8.4375 13.9375C8.22917 13.6736 8.125 13.2778 8.125 12.75C8.125 12.1667 8.32639 11.7014 8.72917 11.3542C9.13195 11.0069 9.625 10.8333 10.2083 10.8333H11.6667C12.5833 10.8333 13.3681 10.566 14.0208 10.0313C14.6736 9.49653 15 8.66667 15 7.54167C15 5.86111 14.3576 4.46181 13.0729 3.34375C11.7882 2.22569 10.2639 1.66667 8.5 1.66667C6.61111 1.66667 5 2.3125 3.66667 3.60417C2.33333 4.89583 1.66667 6.47222 1.66667 8.33333C1.66667 10.1806 2.31597 11.7535 3.61458 13.0521C4.9132 14.3507 6.48611 15 8.33333 15Z" />
    </svg>
  ),
  ICSearch: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M13.0667 14L8.86667 9.8C8.53333 10.0667 8.15 10.2778 7.71667 10.4333C7.28333 10.5889 6.82222 10.6667 6.33333 10.6667C5.12222 10.6667 4.09722 10.2472 3.25833 9.40833C2.41944 8.56944 2 7.54444 2 6.33333C2 5.12222 2.41944 4.09722 3.25833 3.25833C4.09722 2.41944 5.12222 2 6.33333 2C7.54444 2 8.56944 2.41944 9.40833 3.25833C10.2472 4.09722 10.6667 5.12222 10.6667 6.33333C10.6667 6.82222 10.5889 7.28333 10.4333 7.71667C10.2778 8.15 10.0667 8.53333 9.8 8.86667L14 13.0667L13.0667 14ZM6.33333 9.33333C7.16667 9.33333 7.875 9.04167 8.45833 8.45833C9.04167 7.875 9.33333 7.16667 9.33333 6.33333C9.33333 5.5 9.04167 4.79167 8.45833 4.20833C7.875 3.625 7.16667 3.33333 6.33333 3.33333C5.5 3.33333 4.79167 3.625 4.20833 4.20833C3.625 4.79167 3.33333 5.5 3.33333 6.33333C3.33333 7.16667 3.625 7.875 4.20833 8.45833C4.79167 9.04167 5.5 9.33333 6.33333 9.33333Z" />
    </svg>
  ),
  ICSetting2: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 21 20"
      fill="currentColor"
    >
      <path d="M15.2917 16.875C14.4167 16.875 13.6771 16.5729 13.073 15.9688C12.4688 15.3646 12.1667 14.625 12.1667 13.75C12.1667 12.875 12.4688 12.1354 13.073 11.5312C13.6771 10.9271 14.4167 10.625 15.2917 10.625C16.1667 10.625 16.9063 10.9271 17.5105 11.5312C18.1146 12.1354 18.4167 12.875 18.4167 13.75C18.4167 14.625 18.1146 15.3646 17.5105 15.9688C16.9063 16.5729 16.1667 16.875 15.2917 16.875ZM15.2917 15.2083C15.6945 15.2083 16.0382 15.066 16.323 14.7812C16.6077 14.4965 16.75 14.1528 16.75 13.75C16.75 13.3472 16.6077 13.0035 16.323 12.7188C16.0382 12.434 15.6945 12.2917 15.2917 12.2917C14.8889 12.2917 14.5452 12.434 14.2605 12.7188C13.9757 13.0035 13.8334 13.3472 13.8334 13.75C13.8334 14.1528 13.9757 14.4965 14.2605 14.7812C14.5452 15.066 14.8889 15.2083 15.2917 15.2083ZM3.83337 14.5833V12.9167H10.5V14.5833H3.83337ZM5.70837 9.375C4.83337 9.375 4.09379 9.07292 3.48962 8.46875C2.88546 7.86458 2.58337 7.125 2.58337 6.25C2.58337 5.375 2.88546 4.63542 3.48962 4.03125C4.09379 3.42708 4.83337 3.125 5.70837 3.125C6.58337 3.125 7.32296 3.42708 7.92712 4.03125C8.53129 4.63542 8.83337 5.375 8.83337 6.25C8.83337 7.125 8.53129 7.86458 7.92712 8.46875C7.32296 9.07292 6.58337 9.375 5.70837 9.375ZM5.70837 7.70833C6.11115 7.70833 6.4549 7.56597 6.73962 7.28125C7.02435 6.99653 7.16671 6.65278 7.16671 6.25C7.16671 5.84722 7.02435 5.50347 6.73962 5.21875C6.4549 4.93403 6.11115 4.79167 5.70837 4.79167C5.3056 4.79167 4.96185 4.93403 4.67712 5.21875C4.3924 5.50347 4.25004 5.84722 4.25004 6.25C4.25004 6.65278 4.3924 6.99653 4.67712 7.28125C4.96185 7.56597 5.3056 7.70833 5.70837 7.70833ZM10.5 7.08333V5.41667H17.1667V7.08333H10.5Z" />
    </svg>
  ),
  ICDoorSplash: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M15.8332 13.458L14.1665 11.7913V4.99967H12.4998V10.1247L10.8332 8.45801V4.16634H6.5415L4.87484 2.49967H12.4998V3.33301H15.8332V13.458ZM16.4998 18.833L12.4998 14.833V17.4997H2.49984V15.833H4.1665V6.49967L1.1665 3.49967L2.33317 2.33301L17.6665 17.6663L16.4998 18.833ZM5.83317 15.833H10.8332V13.1663L5.83317 8.16634V15.833Z" />
    </svg>
  ),
  ICCameraCenter: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V12.5H4.16667V15.8333H7.5V17.5H4.16667ZM12.5 17.5V15.8333H15.8333V12.5H17.5V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H12.5ZM2.5 7.5V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H7.5V4.16667H4.16667V7.5H2.5ZM15.8333 7.5V4.16667H12.5V2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V7.5H15.8333ZM10 14.1667C8.84722 14.1667 7.86458 13.7604 7.05208 12.9479C6.23958 12.1354 5.83333 11.1528 5.83333 10C5.83333 8.84722 6.23958 7.86458 7.05208 7.05208C7.86458 6.23958 8.84722 5.83333 10 5.83333C11.1528 5.83333 12.1354 6.23958 12.9479 7.05208C13.7604 7.86458 14.1667 8.84722 14.1667 10C14.1667 11.1528 13.7604 12.1354 12.9479 12.9479C12.1354 13.7604 11.1528 14.1667 10 14.1667ZM10 12.5C10.6944 12.5 11.2847 12.2569 11.7708 11.7708C12.2569 11.2847 12.5 10.6944 12.5 10C12.5 9.30556 12.2569 8.71528 11.7708 8.22917C11.2847 7.74306 10.6944 7.5 10 7.5C9.30556 7.5 8.71528 7.74306 8.22917 8.22917C7.74306 8.71528 7.5 9.30556 7.5 10C7.5 10.6944 7.74306 11.2847 8.22917 11.7708C8.71528 12.2569 9.30556 12.5 10 12.5Z" />
    </svg>
  ),
  ICMeasure: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M4.1665 16.6667V9.58333C4.1665 7.61111 4.854 5.9375 6.229 4.5625C7.604 3.1875 9.27762 2.5 11.2498 2.5C13.2221 2.5 14.8957 3.1875 16.2707 4.5625C17.6457 5.9375 18.3332 7.61111 18.3332 9.58333C18.3332 11.5556 17.6457 13.2292 16.2707 14.6042C14.8957 15.9792 13.2221 16.6667 11.2498 16.6667H4.1665ZM5.83317 15H11.2498C12.7498 15 14.0276 14.4722 15.0832 13.4167C16.1387 12.3611 16.6665 11.0833 16.6665 9.58333C16.6665 8.08333 16.1387 6.80556 15.0832 5.75C14.0276 4.69444 12.7498 4.16667 11.2498 4.16667C9.74984 4.16667 8.47206 4.69444 7.4165 5.75C6.36095 6.80556 5.83317 8.08333 5.83317 9.58333V15ZM11.2498 12.5C12.0554 12.5 12.7429 12.2153 13.3123 11.6458C13.8818 11.0764 14.1665 10.3889 14.1665 9.58333C14.1665 8.77778 13.8818 8.09028 13.3123 7.52083C12.7429 6.95139 12.0554 6.66667 11.2498 6.66667C10.4443 6.66667 9.75678 6.95139 9.18734 7.52083C8.61789 8.09028 8.33317 8.77778 8.33317 9.58333C8.33317 10.3889 8.61789 11.0764 9.18734 11.6458C9.75678 12.2153 10.4443 12.5 11.2498 12.5ZM11.2498 10.8333C10.9026 10.8333 10.6075 10.7118 10.3644 10.4687C10.1214 10.2257 9.99984 9.93055 9.99984 9.58333C9.99984 9.23611 10.1214 8.94097 10.3644 8.69792C10.6075 8.45486 10.9026 8.33333 11.2498 8.33333C11.5971 8.33333 11.8922 8.45486 12.1353 8.69792C12.3783 8.94097 12.4998 9.23611 12.4998 9.58333C12.4998 9.93055 12.3783 10.2257 12.1353 10.4687C11.8922 10.7118 11.5971 10.8333 11.2498 10.8333ZM1.6665 16.6667V12.5H3.33317V16.6667H1.6665Z" />
    </svg>
  ),
  ICDesign: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M7.33073 9.12533L9.1224 7.31283L7.95573 6.12533L7.03906 7.04199L5.8724 5.87533L6.76823 4.95866L5.83073 4.02116L4.01823 5.83366L7.33073 9.12533ZM14.1641 15.9795L15.9766 14.167L15.0391 13.2295L14.1224 14.1253L12.9557 12.9587L13.8516 12.042L12.6641 10.8753L10.8724 12.667L14.1641 15.9795ZM6.03906 17.5003H2.4974V13.9587L6.14323 10.3128L1.66406 5.83366L5.83073 1.66699L10.3307 6.16699L13.4766 3.00033C13.6432 2.83366 13.8307 2.70866 14.0391 2.62533C14.2474 2.54199 14.4627 2.50033 14.6849 2.50033C14.9071 2.50033 15.1224 2.54199 15.3307 2.62533C15.5391 2.70866 15.7266 2.83366 15.8932 3.00033L16.9974 4.12533C17.1641 4.29199 17.2891 4.47949 17.3724 4.68783C17.4557 4.89616 17.4974 5.11144 17.4974 5.33366C17.4974 5.55588 17.4557 5.76769 17.3724 5.96908C17.2891 6.17046 17.1641 6.35449 16.9974 6.52116L13.8516 9.68783L18.3307 14.167L14.1641 18.3337L9.6849 13.8545L6.03906 17.5003ZM4.16406 15.8337H5.33073L13.4974 7.68783L12.3099 6.50033L4.16406 14.667V15.8337ZM12.9141 7.10449L12.3099 6.50033L13.4974 7.68783L12.9141 7.10449Z" />
    </svg>
  ),
  ICPersonCustomize: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 48 48"
      fill="currentColor"
    >
      <path d="M19.05 23.95C17.6833 22.5833 17 20.9333 17 19C17 17.0667 17.6833 15.4167 19.05 14.05C20.4167 12.6833 22.0667 12 24 12C25.9333 12 27.5833 12.6833 28.95 14.05C30.3167 15.4167 31 17.0667 31 19C31 20.9333 30.3167 22.5833 28.95 23.95C27.5833 25.3167 25.9333 26 24 26C22.0667 26 20.4167 25.3167 19.05 23.95ZM26.125 21.125C26.7083 20.5417 27 19.8333 27 19C27 18.1667 26.7083 17.4583 26.125 16.875C25.5417 16.2917 24.8333 16 24 16C23.1667 16 22.4583 16.2917 21.875 16.875C21.2917 17.4583 21 18.1667 21 19C21 19.8333 21.2917 20.5417 21.875 21.125C22.4583 21.7083 23.1667 22 24 22C24.8333 22 25.5417 21.7083 26.125 21.125ZM24 45L6 34V14L24 3L42 14V34L24 45ZM24 40.35L31.35 35.8C30.2167 35.2 29.025 34.75 27.775 34.45C26.525 34.15 25.2667 34 24 34C22.7333 34 21.475 34.15 20.225 34.45C18.975 34.75 17.7833 35.2 16.65 35.8L24 40.35ZM12.8 33.45C14.4667 32.3167 16.25 31.4583 18.15 30.875C20.05 30.2917 22 30 24 30C26 30 27.95 30.2917 29.85 30.875C31.75 31.4583 33.5333 32.3167 35.2 33.45L38 31.8V16.25L24 7.7L10 16.25V31.8L12.8 33.45Z" />
    </svg>
  ),
  ICTool: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M6 19H12V18H6V19ZM6.75 10H11.25C11.45 10 11.625 9.925 11.775 9.775C11.925 9.625 12 9.45 12 9.25C12 9.05 11.925 8.875 11.775 8.725C11.625 8.575 11.45 8.5 11.25 8.5H6.75C6.55 8.5 6.375 8.575 6.225 8.725C6.075 8.875 6 9.05 6 9.25C6 9.45 6.075 9.625 6.225 9.775C6.375 9.925 6.55 10 6.75 10ZM6.75 7.5H11.25C11.45 7.5 11.625 7.425 11.775 7.275C11.925 7.125 12 6.95 12 6.75C12 6.55 11.925 6.375 11.775 6.225C11.625 6.075 11.45 6 11.25 6H6.75C6.55 6 6.375 6.075 6.225 6.225C6.075 6.375 6 6.55 6 6.75C6 6.95 6.075 7.125 6.225 7.275C6.375 7.425 6.55 7.5 6.75 7.5ZM16 11V9H18V7H16V5H18C18.55 5 19.021 5.196 19.413 5.588C19.805 5.98 20.0007 6.45067 20 7H22C22.2833 7 22.521 7.096 22.713 7.288C22.905 7.48 23.0007 7.71733 23 8C22.9993 8.28267 22.9033 8.52033 22.712 8.713C22.5207 8.90567 22.2833 9.00133 22 9H20C20 9.55 19.8043 10.021 19.413 10.413C19.0217 10.805 18.5507 11.0007 18 11H16ZM12 16H10V11H14V5H6C5.45 5 4.97933 5.196 4.588 5.588C4.19667 5.98 4.00067 6.45067 4 7V9C4 9.55 4.196 10.021 4.588 10.413C4.98 10.805 5.45067 11.0007 6 11H8V16H6V13C4.9 13 3.95833 12.6083 3.175 11.825C2.39167 11.0417 2 10.1 2 9V7C2 5.9 2.39167 4.95833 3.175 4.175C3.95833 3.39167 4.9 3 6 3H14C14.55 3 15.021 3.196 15.413 3.588C15.805 3.98 16.0007 4.45067 16 5V11C16 11.55 15.8043 12.021 15.413 12.413C15.0217 12.805 14.5507 13.0007 14 13H12V16ZM5.5 21C5.08333 21 4.72933 20.8543 4.438 20.563C4.14667 20.2717 4.00067 19.9173 4 19.5V17.5C4 17.0833 4.146 16.7293 4.438 16.438C4.73 16.1467 5.084 16.0007 5.5 16H12.5C12.9167 16 13.271 16.146 13.563 16.438C13.855 16.73 14.0007 17.084 14 17.5V19.5C14 19.9167 13.8543 20.271 13.563 20.563C13.2717 20.855 12.9173 21.0007 12.5 21H5.5Z" />
    </svg>
  ),
  ICEngineering: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M1.05078 21.001V18.201C1.05078 17.651 1.19245 17.1343 1.47578 16.651C1.75911 16.1676 2.15078 15.801 2.65078 15.551C3.50078 15.1176 4.45911 14.751 5.52578 14.451C6.59245 14.151 7.76745 14.001 9.05078 14.001C10.3341 14.001 11.5091 14.151 12.5758 14.451C13.6424 14.751 14.6008 15.1176 15.4508 15.551C15.9508 15.801 16.3424 16.1676 16.6258 16.651C16.9091 17.1343 17.0508 17.651 17.0508 18.201V21.001H1.05078ZM3.05078 19.001H15.0508V18.201C15.0508 18.0176 15.0049 17.851 14.9133 17.701C14.8216 17.551 14.7008 17.4343 14.5508 17.351C13.9508 17.051 13.1799 16.751 12.2383 16.451C11.2966 16.151 10.2341 16.001 9.05078 16.001C7.86745 16.001 6.80495 16.151 5.86328 16.451C4.92161 16.751 4.15078 17.051 3.55078 17.351C3.40078 17.4343 3.27995 17.551 3.18828 17.701C3.09661 17.851 3.05078 18.0176 3.05078 18.201V19.001ZM9.05078 13.001C7.95078 13.001 7.00911 12.6093 6.22578 11.826C5.44245 11.0426 5.05078 10.101 5.05078 9.00098H4.80078C4.65078 9.00098 4.52995 8.95514 4.43828 8.86348C4.34661 8.77181 4.30078 8.65098 4.30078 8.50098C4.30078 8.35098 4.34661 8.23014 4.43828 8.13848C4.52995 8.04681 4.65078 8.00098 4.80078 8.00098H5.05078C5.05078 7.25098 5.23411 6.57598 5.60078 5.97598C5.96745 5.37598 6.45078 4.90098 7.05078 4.55098V5.50098C7.05078 5.65098 7.09661 5.77181 7.18828 5.86348C7.27995 5.95514 7.40078 6.00098 7.55078 6.00098C7.70078 6.00098 7.82161 5.95514 7.91328 5.86348C8.00495 5.77181 8.05078 5.65098 8.05078 5.50098V4.15098C8.20078 4.10098 8.35911 4.06348 8.52578 4.03848C8.69245 4.01348 8.86745 4.00098 9.05078 4.00098C9.23411 4.00098 9.40911 4.01348 9.57578 4.03848C9.74245 4.06348 9.90078 4.10098 10.0508 4.15098V5.50098C10.0508 5.65098 10.0966 5.77181 10.1883 5.86348C10.2799 5.95514 10.4008 6.00098 10.5508 6.00098C10.7008 6.00098 10.8216 5.95514 10.9133 5.86348C11.0049 5.77181 11.0508 5.65098 11.0508 5.50098V4.55098C11.6508 4.90098 12.1341 5.37598 12.5008 5.97598C12.8674 6.57598 13.0508 7.25098 13.0508 8.00098H13.3008C13.4508 8.00098 13.5716 8.04681 13.6633 8.13848C13.7549 8.23014 13.8008 8.35098 13.8008 8.50098C13.8008 8.65098 13.7549 8.77181 13.6633 8.86348C13.5716 8.95514 13.4508 9.00098 13.3008 9.00098H13.0508C13.0508 10.101 12.6591 11.0426 11.8758 11.826C11.0924 12.6093 10.1508 13.001 9.05078 13.001ZM9.05078 11.001C9.60078 11.001 10.0716 10.8051 10.4633 10.4135C10.8549 10.0218 11.0508 9.55098 11.0508 9.00098H7.05078C7.05078 9.55098 7.24661 10.0218 7.63828 10.4135C8.02995 10.8051 8.50078 11.001 9.05078 11.001ZM16.5508 15.001L16.4008 14.251C16.3008 14.2176 16.2049 14.1801 16.1133 14.1385C16.0216 14.0968 15.9341 14.0343 15.8508 13.951L15.1508 14.201L14.6508 13.301L15.2008 12.801V12.201L14.6508 11.701L15.1508 10.801L15.8508 11.051C15.9174 10.9843 16.0008 10.926 16.1008 10.876C16.2008 10.826 16.3008 10.7843 16.4008 10.751L16.5508 10.001H17.5508L17.7008 10.751C17.8008 10.7843 17.9008 10.826 18.0008 10.876C18.1008 10.926 18.1841 10.9843 18.2508 11.051L18.9508 10.801L19.4508 11.701L18.9008 12.201V12.801L19.4508 13.301L18.9508 14.201L18.2508 13.951C18.1674 14.0343 18.0799 14.0968 17.9883 14.1385C17.8966 14.1801 17.8008 14.2176 17.7008 14.251L17.5508 15.001H16.5508ZM17.0508 13.251C17.2508 13.251 17.4258 13.176 17.5758 13.026C17.7258 12.876 17.8008 12.701 17.8008 12.501C17.8008 12.301 17.7258 12.126 17.5758 11.976C17.4258 11.826 17.2508 11.751 17.0508 11.751C16.8508 11.751 16.6758 11.826 16.5258 11.976C16.3758 12.126 16.3008 12.301 16.3008 12.501C16.3008 12.701 16.3758 12.876 16.5258 13.026C16.6758 13.176 16.8508 13.251 17.0508 13.251ZM18.8508 10.001L18.6508 8.95098C18.5008 8.90098 18.3633 8.83848 18.2383 8.76348C18.1133 8.68848 18.0008 8.60098 17.9008 8.50098L16.8508 8.85098L16.1508 7.65098L17.0008 6.90098C16.9674 6.81764 16.9508 6.75098 16.9508 6.70098V6.30098C16.9508 6.25098 16.9674 6.18431 17.0008 6.10098L16.1508 5.35098L16.8508 4.15098L17.9008 4.50098C18.0008 4.40098 18.1133 4.31348 18.2383 4.23848C18.3633 4.16348 18.5008 4.10098 18.6508 4.05098L18.8508 3.00098H20.2508L20.4508 4.05098C20.6008 4.10098 20.7383 4.16348 20.8633 4.23848C20.9883 4.31348 21.1008 4.40098 21.2008 4.50098L22.2508 4.15098L22.9508 5.35098L22.1008 6.10098C22.1341 6.18431 22.1508 6.25098 22.1508 6.30098V6.70098C22.1508 6.75098 22.1341 6.81764 22.1008 6.90098L22.9508 7.65098L22.2508 8.85098L21.2008 8.50098C21.1008 8.60098 20.9883 8.68848 20.8633 8.76348C20.7383 8.83848 20.6008 8.90098 20.4508 8.95098L20.2508 10.001H18.8508ZM19.5508 7.75098C19.9008 7.75098 20.1966 7.63014 20.4383 7.38848C20.6799 7.14681 20.8008 6.85098 20.8008 6.50098C20.8008 6.15098 20.6799 5.85514 20.4383 5.61348C20.1966 5.37181 19.9008 5.25098 19.5508 5.25098C19.2008 5.25098 18.9049 5.37181 18.6633 5.61348C18.4216 5.85514 18.3008 6.15098 18.3008 6.50098C18.3008 6.85098 18.4216 7.14681 18.6633 7.38848C18.9049 7.63014 19.2008 7.75098 19.5508 7.75098Z" />
    </svg>
  ),
  ICUndo: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M5.8335 15.833V14.1663H11.7502C12.6252 14.1663 13.3856 13.8886 14.0314 13.333C14.6772 12.7775 15.0002 12.083 15.0002 11.2497C15.0002 10.4163 14.6772 9.7219 14.0314 9.16634C13.3856 8.61079 12.6252 8.33301 11.7502 8.33301H6.50016L8.66683 10.4997L7.50016 11.6663L3.3335 7.49967L7.50016 3.33301L8.66683 4.49967L6.50016 6.66634H11.7502C13.0974 6.66634 14.2536 7.10384 15.2189 7.97884C16.1842 8.85384 16.6668 9.94412 16.6668 11.2497C16.6668 12.5552 16.1842 13.6455 15.2189 14.5205C14.2536 15.3955 13.0974 15.833 11.7502 15.833H5.8335Z" />
    </svg>
  ),
  ICRedo: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M8.25016 15.833C6.90294 15.833 5.74669 15.3955 4.78141 14.5205C3.81613 13.6455 3.3335 12.5552 3.3335 11.2497C3.3335 9.94412 3.81613 8.85384 4.78141 7.97884C5.74669 7.10384 6.90294 6.66634 8.25016 6.66634H13.5002L11.3335 4.49967L12.5002 3.33301L16.6668 7.49967L12.5002 11.6663L11.3335 10.4997L13.5002 8.33301H8.25016C7.37516 8.33301 6.61475 8.61079 5.96891 9.16634C5.32308 9.7219 5.00016 10.4163 5.00016 11.2497C5.00016 12.083 5.32308 12.7775 5.96891 13.333C6.61475 13.8886 7.37516 14.1663 8.25016 14.1663H14.1668V15.833H8.25016Z" />
    </svg>
  ),
  ICInfoFill: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 17"
      fill="currentColor"
    >
      <path d="M7.33331 11.6274H8.66665V7.62744H7.33331V11.6274ZM7.99998 6.29411C8.18887 6.29411 8.3472 6.23022 8.47498 6.10244C8.60276 5.97466 8.66665 5.81633 8.66665 5.62744C8.66665 5.43855 8.60276 5.28022 8.47498 5.15244C8.3472 5.02466 8.18887 4.96077 7.99998 4.96077C7.81109 4.96077 7.65276 5.02466 7.52498 5.15244C7.3972 5.28022 7.33331 5.43855 7.33331 5.62744C7.33331 5.81633 7.3972 5.97466 7.52498 6.10244C7.65276 6.23022 7.81109 6.29411 7.99998 6.29411ZM7.99998 14.9608C7.07776 14.9608 6.21109 14.7858 5.39998 14.4358C4.58887 14.0858 3.88331 13.6108 3.28331 13.0108C2.68331 12.4108 2.20831 11.7052 1.85831 10.8941C1.50831 10.083 1.33331 9.21633 1.33331 8.29411C1.33331 7.37189 1.50831 6.50522 1.85831 5.69411C2.20831 4.883 2.68331 4.17744 3.28331 3.57744C3.88331 2.97744 4.58887 2.50244 5.39998 2.15244C6.21109 1.80244 7.07776 1.62744 7.99998 1.62744C8.9222 1.62744 9.78887 1.80244 10.6 2.15244C11.4111 2.50244 12.1166 2.97744 12.7166 3.57744C13.3166 4.17744 13.7916 4.883 14.1416 5.69411C14.4916 6.50522 14.6666 7.37189 14.6666 8.29411C14.6666 9.21633 14.4916 10.083 14.1416 10.8941C13.7916 11.7052 13.3166 12.4108 12.7166 13.0108C12.1166 13.6108 11.4111 14.0858 10.6 14.4358C9.78887 14.7858 8.9222 14.9608 7.99998 14.9608Z" />
    </svg>
  ),
  ICCheckFill: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.06659 11.0673L11.7666 6.36732L10.8333 5.43398L7.06659 9.20065L5.16658 7.30065L4.23325 8.23398L7.06659 11.0673ZM7.99992 14.6673C7.0777 14.6673 6.21103 14.4923 5.39992 14.1423C4.58881 13.7923 3.88325 13.3173 3.28325 12.7173C2.68325 12.1173 2.20825 11.4118 1.85825 10.6007C1.50825 9.78954 1.33325 8.92287 1.33325 8.00065C1.33325 7.07843 1.50825 6.21176 1.85825 5.40065C2.20825 4.58954 2.68325 3.88398 3.28325 3.28398C3.88325 2.68398 4.58881 2.20898 5.39992 1.85898C6.21103 1.50898 7.0777 1.33398 7.99992 1.33398C8.92214 1.33398 9.78881 1.50898 10.5999 1.85898C11.411 2.20898 12.1166 2.68398 12.7166 3.28398C13.3166 3.88398 13.7916 4.58954 14.1416 5.40065C14.4916 6.21176 14.6666 7.07843 14.6666 8.00065C14.6666 8.92287 14.4916 9.78954 14.1416 10.6007C13.7916 11.4118 13.3166 12.1173 12.7166 12.7173C12.1166 13.3173 11.411 13.7923 10.5999 14.1423C9.78881 14.4923 8.92214 14.6673 7.99992 14.6673Z"
        fill="#49AC3E"
      />
    </svg>
  ),
  ICDot: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle
        cx="8"
        cy="8"
        r="7"
        fill="#E3EFFB"
        stroke="#258FD2"
        strokeWidth="2"
      />
    </svg>
  ),
  ICTune: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M14.7943 16.875C13.9193 16.875 13.1797 16.5729 12.5755 15.9688C11.9714 15.3646 11.6693 14.625 11.6693 13.75C11.6693 12.875 11.9714 12.1354 12.5755 11.5312C13.1797 10.9271 13.9193 10.625 14.7943 10.625C15.6693 10.625 16.4089 10.9271 17.013 11.5312C17.6172 12.1354 17.9193 12.875 17.9193 13.75C17.9193 14.625 17.6172 15.3646 17.013 15.9688C16.4089 16.5729 15.6693 16.875 14.7943 16.875ZM14.7943 15.2083C15.197 15.2083 15.5408 15.066 15.8255 14.7812C16.1102 14.4965 16.2526 14.1528 16.2526 13.75C16.2526 13.3472 16.1102 13.0035 15.8255 12.7188C15.5408 12.434 15.197 12.2917 14.7943 12.2917C14.3915 12.2917 14.0477 12.434 13.763 12.7188C13.4783 13.0035 13.3359 13.3472 13.3359 13.75C13.3359 14.1528 13.4783 14.4965 13.763 14.7812C14.0477 15.066 14.3915 15.2083 14.7943 15.2083ZM3.33594 14.5833V12.9167H10.0026V14.5833H3.33594ZM5.21094 9.375C4.33594 9.375 3.59635 9.07292 2.99219 8.46875C2.38802 7.86458 2.08594 7.125 2.08594 6.25C2.08594 5.375 2.38802 4.63542 2.99219 4.03125C3.59635 3.42708 4.33594 3.125 5.21094 3.125C6.08594 3.125 6.82552 3.42708 7.42969 4.03125C8.03385 4.63542 8.33594 5.375 8.33594 6.25C8.33594 7.125 8.03385 7.86458 7.42969 8.46875C6.82552 9.07292 6.08594 9.375 5.21094 9.375ZM5.21094 7.70833C5.61372 7.70833 5.95746 7.56597 6.24219 7.28125C6.52691 6.99653 6.66927 6.65278 6.66927 6.25C6.66927 5.84722 6.52691 5.50347 6.24219 5.21875C5.95746 4.93403 5.61372 4.79167 5.21094 4.79167C4.80816 4.79167 4.46441 4.93403 4.17969 5.21875C3.89497 5.50347 3.7526 5.84722 3.7526 6.25C3.7526 6.65278 3.89497 6.99653 4.17969 7.28125C4.46441 7.56597 4.80816 7.70833 5.21094 7.70833ZM10.0026 7.08333V5.41667H16.6693V7.08333H10.0026Z" />
    </svg>
  ),
  ICTuneColor: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 21V15H13V17H21V19H13V21H11ZM3 19V17H9V19H3ZM7 15V13H3V11H7V9H9V15H7ZM11 13V11H21V13H11ZM15 9V3H17V5H21V7H17V9H15ZM3 7V5H13V7H3Z"
        fill="url(#paint0_linear_5114_29412)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5114_29412"
          x1="3.18243"
          y1="3.18563"
          x2="20.8243"
          y2="4.07015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E06161" />
          <stop offset="0.326923" stopColor="#EBAF4D" />
          <stop offset="0.528846" stopColor="#DDD155" />
          <stop offset="0.764423" stopColor="#5FE077" />
          <stop offset="0.985577" stopColor="#649FD7" />
        </linearGradient>
      </defs>
    </svg>
  ),
  ICRestart: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M7.33317 13.967C5.98873 13.8003 4.87484 13.2142 3.9915 12.2087C3.10817 11.2031 2.6665 10.0225 2.6665 8.66699C2.6665 7.93366 2.81095 7.23088 3.09984 6.55866C3.38873 5.88644 3.79984 5.30033 4.33317 4.80033L5.28317 5.75033C4.86095 6.1281 4.5415 6.56699 4.32484 7.06699C4.10817 7.56699 3.99984 8.10033 3.99984 8.66699C3.99984 9.64477 4.31095 10.5087 4.93317 11.2587C5.55539 12.0087 6.35539 12.467 7.33317 12.6337V13.967ZM8.6665 13.967V12.6337C9.63317 12.4559 10.4304 11.9948 11.0582 11.2503C11.6859 10.5059 11.9998 9.64477 11.9998 8.66699C11.9998 7.55588 11.6109 6.61144 10.8332 5.83366C10.0554 5.05588 9.11095 4.66699 7.99984 4.66699H7.94984L8.68317 5.40033L7.74984 6.33366L5.4165 4.00033L7.74984 1.66699L8.68317 2.60033L7.94984 3.33366H7.99984C9.48873 3.33366 10.7498 3.85033 11.7832 4.88366C12.8165 5.91699 13.3332 7.1781 13.3332 8.66699C13.3332 10.0114 12.8915 11.1864 12.0082 12.192C11.1248 13.1975 10.0109 13.7892 8.6665 13.967Z" />
    </svg>
  ),
  ICCountertops: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M3 15.001V9.00098H1.5V7.50098H4.5C4.0875 7.50098 3.73438 7.3541 3.44063 7.06035C3.14688 6.7666 3 6.41348 3 6.00098V3.00098H7.5V6.00098C7.5 6.41348 7.35313 6.7666 7.05938 7.06035C6.76562 7.3541 6.4125 7.50098 6 7.50098H12V5.25098C12 5.03848 11.9281 4.86035 11.7844 4.7166C11.6406 4.57285 11.4625 4.50098 11.25 4.50098C11.0375 4.50098 10.8594 4.57285 10.7156 4.7166C10.5719 4.86035 10.5 5.03848 10.5 5.25098H9C9 4.62598 9.21875 4.09473 9.65625 3.65723C10.0938 3.21973 10.625 3.00098 11.25 3.00098C11.875 3.00098 12.4062 3.21973 12.8438 3.65723C13.2813 4.09473 13.5 4.62598 13.5 5.25098V7.50098H16.5V9.00098H15V15.001H3ZM4.5 6.00098H6V4.50098H4.5V6.00098ZM4.5 13.501H8.25V9.00098H4.5V13.501ZM9.75 13.501H13.5V9.00098H9.75V13.501Z" />
    </svg>
  ),
  ICWardrope: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M6.75 9.75098C6.5375 9.75098 6.35938 9.6791 6.21563 9.53535C6.07188 9.3916 6 9.21348 6 9.00098C6 8.78848 6.07188 8.61035 6.21563 8.4666C6.35938 8.32285 6.5375 8.25098 6.75 8.25098C6.9625 8.25098 7.14062 8.32285 7.28438 8.4666C7.42813 8.61035 7.5 8.78848 7.5 9.00098C7.5 9.21348 7.42813 9.3916 7.28438 9.53535C7.14062 9.6791 6.9625 9.75098 6.75 9.75098ZM11.25 9.75098C11.0375 9.75098 10.8594 9.6791 10.7156 9.53535C10.5719 9.3916 10.5 9.21348 10.5 9.00098C10.5 8.78848 10.5719 8.61035 10.7156 8.4666C10.8594 8.32285 11.0375 8.25098 11.25 8.25098C11.4625 8.25098 11.6406 8.32285 11.7844 8.4666C11.9281 8.61035 12 8.78848 12 9.00098C12 9.21348 11.9281 9.3916 11.7844 9.53535C11.6406 9.6791 11.4625 9.75098 11.25 9.75098ZM2.25 15.751V14.251H3V3.75098C3 3.33848 3.14688 2.98535 3.44063 2.6916C3.73438 2.39785 4.0875 2.25098 4.5 2.25098H13.5C13.9125 2.25098 14.2656 2.39785 14.5594 2.6916C14.8531 2.98535 15 3.33848 15 3.75098V14.251H15.75V15.751H2.25ZM4.5 14.251H8.25V3.75098H4.5V14.251ZM9.75 14.251H13.5V3.75098H9.75V14.251Z" />
    </svg>
  ),
  ICDresses: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 18"
      fill="currentColor"
    >
      <path d="M0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V18H14V16H2V18H0ZM2 8H7V2H2V8ZM9 4H14V2H9V4ZM9 8H14V6H9V8ZM6 13H10V11H6V13ZM2 10V14H14V10H2Z" />
    </svg>
  ),
  ICShortcut: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 19"
      fill="currentColor"
    >
      <path d="M8.125 14H12.125V12H8.125V14ZM8.125 10H15.125V8H8.125V10ZM5.125 6H15.125V4H5.125V6ZM4.75 19C3.43333 19 2.3125 18.5375 1.3875 17.6125C0.4625 16.6875 0 15.5667 0 14.25C0 13.3 0.245833 12.45 0.7375 11.7C1.22917 10.95 1.875 10.3833 2.675 10H0.125V8H6.125V14H4.125V11.575C3.50833 11.7083 3 12.025 2.6 12.525C2.2 13.025 2 13.6 2 14.25C2 15.0167 2.27083 15.6667 2.8125 16.2C3.35417 16.7333 4 17 4.75 17V19ZM8.125 18V16H17.125V2H3.125V6H1.125V2C1.125 1.45 1.32083 0.979167 1.7125 0.5875C2.10417 0.195833 2.575 0 3.125 0H17.125C17.675 0 18.1458 0.195833 18.5375 0.5875C18.9292 0.979167 19.125 1.45 19.125 2V16C19.125 16.55 18.9292 17.0208 18.5375 17.4125C18.1458 17.8042 17.675 18 17.125 18H8.125Z" />
    </svg>
  ),
  ICBed: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M1.5 14.251V9.75098C1.5 9.41348 1.56875 9.10723 1.70625 8.83223C1.84375 8.55723 2.025 8.31348 2.25 8.10098V6.00098C2.25 5.37598 2.46875 4.84473 2.90625 4.40723C3.34375 3.96973 3.875 3.75098 4.5 3.75098H7.5C7.7875 3.75098 8.05625 3.8041 8.30625 3.91035C8.55625 4.0166 8.7875 4.16348 9 4.35098C9.2125 4.16348 9.44375 4.0166 9.69375 3.91035C9.94375 3.8041 10.2125 3.75098 10.5 3.75098H13.5C14.125 3.75098 14.6563 3.96973 15.0938 4.40723C15.5313 4.84473 15.75 5.37598 15.75 6.00098V8.10098C15.975 8.31348 16.1563 8.55723 16.2938 8.83223C16.4313 9.10723 16.5 9.41348 16.5 9.75098V14.251H15V12.751H3V14.251H1.5ZM9.75 7.50098H14.25V6.00098C14.25 5.78848 14.1781 5.61035 14.0344 5.4666C13.8906 5.32285 13.7125 5.25098 13.5 5.25098H10.5C10.2875 5.25098 10.1094 5.32285 9.96563 5.4666C9.82188 5.61035 9.75 5.78848 9.75 6.00098V7.50098ZM3.75 7.50098H8.25V6.00098C8.25 5.78848 8.17813 5.61035 8.03438 5.4666C7.89063 5.32285 7.7125 5.25098 7.5 5.25098H4.5C4.2875 5.25098 4.10938 5.32285 3.96563 5.4666C3.82188 5.61035 3.75 5.78848 3.75 6.00098V7.50098ZM3 11.251H15V9.75098C15 9.53848 14.9281 9.36035 14.7844 9.2166C14.6406 9.07285 14.4625 9.00098 14.25 9.00098H3.75C3.5375 9.00098 3.35938 9.07285 3.21563 9.2166C3.07188 9.36035 3 9.53848 3 9.75098V11.251Z" />
    </svg>
  ),
  ICBedRoom: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M4.16602 14.166H5.41602V12.916H14.5827V14.166H15.8327V10.9577C15.8327 10.666 15.7771 10.3917 15.666 10.1348C15.5549 9.87782 15.4021 9.65213 15.2077 9.45768V7.49935C15.2077 7.04102 15.0445 6.64865 14.7181 6.32227C14.3917 5.99588 13.9993 5.83268 13.541 5.83268H10.8327C10.6799 5.83268 10.5341 5.85352 10.3952 5.89518C10.2563 5.93685 10.1243 5.99935 9.99935 6.08268C9.87435 5.99935 9.7424 5.93685 9.60352 5.89518C9.46463 5.85352 9.31879 5.83268 9.16602 5.83268H6.45768C5.99935 5.83268 5.60699 5.99588 5.2806 6.32227C4.95421 6.64865 4.79102 7.04102 4.79102 7.49935V9.45768C4.59657 9.65213 4.44379 9.87782 4.33268 10.1348C4.22157 10.3917 4.16602 10.666 4.16602 10.9577V14.166ZM5.41602 11.666V10.8327C5.41602 10.5966 5.49588 10.3987 5.6556 10.2389C5.81532 10.0792 6.01324 9.99935 6.24935 9.99935H13.7493C13.9855 9.99935 14.1834 10.0792 14.3431 10.2389C14.5028 10.3987 14.5827 10.5966 14.5827 10.8327V11.666H5.41602ZM6.04102 8.74935V7.08268H9.37435V8.74935H6.04102ZM10.6243 8.74935V7.08268H13.9577V8.74935H10.6243ZM3.33268 18.3327C2.87435 18.3327 2.48199 18.1695 2.1556 17.8431C1.82921 17.5167 1.66602 17.1243 1.66602 16.666V3.33268C1.66602 2.87435 1.82921 2.48199 2.1556 2.1556C2.48199 1.82921 2.87435 1.66602 3.33268 1.66602H16.666C17.1243 1.66602 17.5167 1.82921 17.8431 2.1556C18.1695 2.48199 18.3327 2.87435 18.3327 3.33268V16.666C18.3327 17.1243 18.1695 17.5167 17.8431 17.8431C17.5167 18.1695 17.1243 18.3327 16.666 18.3327H3.33268ZM3.33268 16.666H16.666V3.33268H3.33268V16.666Z" />
    </svg>
  ),
  ICMakeup: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M12 17.251C11.7875 17.251 11.6094 17.1791 11.4656 17.0354C11.3219 16.8916 11.25 16.7135 11.25 16.501C11.25 16.2885 11.3219 16.1104 11.4656 15.9666C11.6094 15.8229 11.7875 15.751 12 15.751H14.25V15.001H12C11.7875 15.001 11.6094 14.9291 11.4656 14.7854C11.3219 14.6416 11.25 14.4635 11.25 14.251C11.25 14.0385 11.3219 13.8604 11.4656 13.7166C11.6094 13.5729 11.7875 13.501 12 13.501H14.25V12.751H12C11.7875 12.751 11.6094 12.6791 11.4656 12.5354C11.3219 12.3916 11.25 12.2135 11.25 12.001C11.25 11.7885 11.3219 11.6104 11.4656 11.4666C11.6094 11.3229 11.7875 11.251 12 11.251H14.25V10.501H12C11.7875 10.501 11.6094 10.4291 11.4656 10.2854C11.3219 10.1416 11.25 9.96348 11.25 9.75098C11.25 9.53848 11.3219 9.36035 11.4656 9.2166C11.6094 9.07285 11.7875 9.00098 12 9.00098H14.25V8.25098H12C11.7875 8.25098 11.6094 8.1791 11.4656 8.03535C11.3219 7.8916 11.25 7.71348 11.25 7.50098C11.25 7.28848 11.3219 7.11035 11.4656 6.9666C11.6094 6.82285 11.7875 6.75098 12 6.75098H14.25V6.00098H12C11.7875 6.00098 11.6094 5.9291 11.4656 5.78535C11.3219 5.6416 11.25 5.46348 11.25 5.25098C11.25 5.03848 11.3219 4.86035 11.4656 4.7166C11.6094 4.57285 11.7875 4.50098 12 4.50098H15C15.4125 4.50098 15.7656 4.64785 16.0594 4.9416C16.3531 5.23535 16.5 5.58848 16.5 6.00098V15.751C16.5 16.1635 16.3531 16.5166 16.0594 16.8104C15.7656 17.1041 15.4125 17.251 15 17.251H12ZM6 11.251C6.825 11.251 7.53125 10.8447 8.11875 10.0322C8.70625 9.21973 9 8.25098 9 7.12598C9 6.00098 8.70625 5.03223 8.11875 4.21973C7.53125 3.40723 6.825 3.00098 6 3.00098C5.175 3.00098 4.46875 3.40723 3.88125 4.21973C3.29375 5.03223 3 6.00098 3 7.12598C3 8.25098 3.29375 9.21973 3.88125 10.0322C4.46875 10.8447 5.175 11.251 6 11.251ZM6 17.251C5.4 17.251 4.90625 17.0291 4.51875 16.5854C4.13125 16.1416 3.98125 15.6197 4.06875 15.0197L4.36875 12.376C3.51875 11.9635 2.82813 11.2854 2.29688 10.3416C1.76562 9.39785 1.5 8.32598 1.5 7.12598C1.5 5.56348 1.9375 4.23535 2.8125 3.1416C3.6875 2.04785 4.75 1.50098 6 1.50098C7.25 1.50098 8.3125 2.04785 9.1875 3.1416C10.0625 4.23535 10.5 5.56348 10.5 7.12598C10.5 8.32598 10.2344 9.39785 9.70312 10.3416C9.17188 11.2854 8.48125 11.9635 7.63125 12.376L7.93125 15.0197C8.01875 15.6197 7.86875 16.1416 7.48125 16.5854C7.09375 17.0291 6.6 17.251 6 17.251Z" />
    </svg>
  ),
  ICDesk: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M1.5 13.501V4.50098H16.5V13.501H15V12.001H12V13.501H10.5V6.00098H3V13.501H1.5ZM12 7.50098H15V6.00098H12V7.50098ZM12 10.501H15V9.00098H12V10.501Z" />
    </svg>
  ),
  ICDownload: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M9.9987 13.3333L5.83203 9.16658L6.9987 7.95825L9.16536 10.1249V3.33325H10.832V10.1249L12.9987 7.95825L14.1654 9.16658L9.9987 13.3333ZM4.9987 16.6666C4.54036 16.6666 4.148 16.5034 3.82161 16.177C3.49523 15.8506 3.33203 15.4583 3.33203 14.9999V12.4999H4.9987V14.9999H14.9987V12.4999H16.6654V14.9999C16.6654 15.4583 16.5022 15.8506 16.1758 16.177C15.8494 16.5034 15.457 16.6666 14.9987 16.6666H4.9987Z" />
    </svg>
  ),
  ICSelectAll: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 14 14"
      fill="currentColor"
    >
      <path d="M4.08333 9.91667V4.08333H9.91667V9.91667H4.08333ZM5.25 8.75H8.75V5.25H5.25V8.75ZM2.91667 11.0833V12.25C2.59583 12.25 2.32118 12.1358 2.09271 11.9073C1.86424 11.6788 1.75 11.4042 1.75 11.0833H2.91667ZM1.75 9.91667V8.75H2.91667V9.91667H1.75ZM1.75 7.58333V6.41667H2.91667V7.58333H1.75ZM1.75 5.25V4.08333H2.91667V5.25H1.75ZM2.91667 2.91667H1.75C1.75 2.59583 1.86424 2.32118 2.09271 2.09271C2.32118 1.86424 2.59583 1.75 2.91667 1.75V2.91667ZM4.08333 12.25V11.0833H5.25V12.25H4.08333ZM4.08333 2.91667V1.75H5.25V2.91667H4.08333ZM6.41667 12.25V11.0833H7.58333V12.25H6.41667ZM6.41667 2.91667V1.75H7.58333V2.91667H6.41667ZM8.75 12.25V11.0833H9.91667V12.25H8.75ZM8.75 2.91667V1.75H9.91667V2.91667H8.75ZM11.0833 12.25V11.0833H12.25C12.25 11.4042 12.1358 11.6788 11.9073 11.9073C11.6788 12.1358 11.4042 12.25 11.0833 12.25ZM11.0833 9.91667V8.75H12.25V9.91667H11.0833ZM11.0833 7.58333V6.41667H12.25V7.58333H11.0833ZM11.0833 5.25V4.08333H12.25V5.25H11.0833ZM11.0833 2.91667V1.75C11.4042 1.75 11.6788 1.86424 11.9073 2.09271C12.1358 2.32118 12.25 2.59583 12.25 2.91667H11.0833Z" />
    </svg>
  ),
  ICAlignVerticalSpaceAround: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M1.5 3V1.5H16.5V3H1.5ZM1.5 16.5V15H16.5V16.5H1.5ZM5.25 6.75V4.5H12.75V6.75H5.25ZM5.25 13.5V11.25H12.75V13.5H5.25Z" />
    </svg>
  ),
  ICAlignVerticalCenter: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M1.5 9.75V8.25H16.5V9.75H1.5ZM5.25 7.5V5.25H12.75V7.5H5.25ZM5.25 12.75V10.5H12.75V12.75H5.25Z" />
    </svg>
  ),
  ICLayout1: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M2.25 10.875V7.125H15.75V10.875H9H2.25Z" />
    </svg>
  ),
  ICLayout2: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M2.25 10.875V7.125H8.25V10.875H2.25Z" />
      <path d="M9.75 10.875V7.125H15.75V10.875H9.75Z" />
    </svg>
  ),
  ICLayout3: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M2.25 10.875V7.125H8.25V10.875H2.25Z" />
      <path d="M9.75 10.875V7.125H15.75V10.875H9.75Z" />
    </svg>
  ),
  ICLayout12: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M2.25 8.25V4.5H15.75V8.25H9H2.25Z" />
      <path d="M2.25 13.5V9.75H15.75V13.5H2.25Z" />
    </svg>
  ),
  ICLayout22: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M2.25 8.25V4.5H8.25V8.25H2.25Z" />
      <path d="M9.75 8.25V4.5H15.75V8.25H9.75Z" />
      <path d="M2.25 13.5V9.75H8.25V13.5H2.25Z" />
      <path d="M9.75 13.5V9.75H15.75V13.5H9.75Z" />
    </svg>
  ),
  ICLayout32: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M1.5 9V4H6.11538V9H1.5Z" />
      <path d="M6.69231 9V4H11.3077V9H6.69231Z" />
      <path d="M11.8846 9V4H16.5V9H11.8846Z" />
      <path d="M1.5 15V10H6.11538V15H1.5Z" />
      <path d="M6.69231 15V10H11.3077V15H6.69231Z" />
      <path d="M11.8846 15V10H16.5V15H11.8846Z" />
    </svg>
  ),
  ICLayout13: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M2.25 5.625V1.875H15.75V5.625H9H2.25Z" />
      <path d="M2.25 10.875V7.125H15.75V10.875H2.25Z" />
      <path d="M2.25 12.375V16.125H15.75V12.375H2.25Z" />
    </svg>
  ),
  ICLayout23: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M2.25 5.625V1.875H15.75V5.625H9H2.25Z" />
      <path d="M2.25 10.875V7.125H15.75V10.875H2.25Z" />
      <path d="M2.25 12.375V16.125H15.75V12.375H2.25Z" />
    </svg>
  ),
  ICLayout33: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M1.5 6.5V1.5H6.11538V6.5H1.5Z" />
      <path d="M6.69231 6.5V1.5H11.3077V6.5H6.69231Z" />
      <path d="M11.8846 6.5V1.5H16.5V6.5H11.8846Z" />
      <path d="M1.5 12V7H6.11538V12H1.5Z" />
      <path d="M6.69231 12V7H11.3077V12H6.69231Z" />
      <path d="M11.8846 12V7H16.5V12H11.8846Z" />
      <path d="M1.5 17.5V12.5H6.11538V17.5H1.5Z" />
      <path d="M6.69231 17.5V12.5H11.3077V17.5H6.69231Z" />
      <path d="M11.8846 17.5V12.5H16.5V17.5H11.8846Z" />
    </svg>
  ),
  ICAlignLeft: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M7 18.3327V1.66602H9V18.3327H7ZM11 14.166V5.83268H14V14.166H11Z" />
    </svg>
  ),
  ICAlignTop: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M1.66675 9V7H18.3334V9H1.66675ZM5.83342 14V11H14.1667V14H5.83342Z" />
    </svg>
  ),
  ICAlignRight: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M12 18.3327V1.66602H14V18.3327H12ZM7 14.166V5.83268H10V14.166H7Z" />
    </svg>
  ),
  ICAlignBottom: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M1.66675 14V12H18.3334V14H1.66675ZM5.83342 10V7H14.1667V10H5.83342Z" />
    </svg>
  ),
  ICAlignForward: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 19 18"
      fill="currentColor"
    >
      <path d="M12.6313 9.75H3.5V8.25H12.6313L8.43125 4.05L9.5 3L15.5 9L9.5 15L8.43125 13.95L12.6313 9.75Z" />
    </svg>
  ),
  ICFillSpace: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M4 28V25.3333H28V28H4ZM14.6667 22.6667V14.4333L12.5333 16.5333L10.6667 14.6667L16 9.33333L21.3333 14.6667L19.4667 16.5333L17.3333 14.4333V22.6667H14.6667ZM4 6.66667V4H28V6.66667H4Z" />
    </svg>
  ),
  ICBank: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox={`0 0 24 24`}
      fill="currentColor"
    >
      <path d="M7.15375 20.6537L2.5 15.9999L7.15375 11.3462L8.223 12.3999L5.373 15.2499H20.5V16.7499H5.373L8.223 19.5999L7.15375 20.6537ZM16.8462 12.6537L15.777 11.5999L18.627 8.74994H3.5V7.24994H18.627L15.777 4.39994L16.8462 3.34619L21.5 7.99994L16.8462 12.6537Z" />
    </svg>
  ),
  ICCreditCard: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox={`0 0 24 24`}
      fill="currentColor"
    >
      <path d="M21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775ZM4 8.404H20V6.30775C20 6.23075 19.9679 6.16025 19.9038 6.09625C19.8398 6.03208 19.7693 6 19.6923 6H4.30775C4.23075 6 4.16025 6.03208 4.09625 6.09625C4.03208 6.16025 4 6.23075 4 6.30775V8.404ZM4 11.596V17.6923C4 17.7692 4.03208 17.8398 4.09625 17.9038C4.16025 17.9679 4.23075 18 4.30775 18H19.6923C19.7693 18 19.8398 17.9679 19.9038 17.9038C19.9679 17.8398 20 17.7692 20 17.6923V11.596H4Z" />
    </svg>
  ),
  ICCreditCardClock: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox={`0 0 24 24`}
      fill="currentColor"
    >
      <path d="M4 18V10.1538V10.5557V6V18ZM4 8.404H20V6.30775C20 6.23075 19.9679 6.16025 19.9038 6.09625C19.8398 6.03208 19.7693 6 19.6923 6H4.30775C4.23075 6 4.16025 6.03208 4.09625 6.09625C4.03208 6.16025 4 6.23075 4 6.30775V8.404ZM11.4827 19.5H4.30775C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V11.2595C20.9385 10.8942 20.3366 10.6186 19.6943 10.4328C19.0519 10.2467 18.3929 10.1538 17.7172 10.1538C16.9904 10.1538 16.2857 10.2791 15.603 10.5298C14.9203 10.7804 14.304 11.1358 13.754 11.596H4V17.6923C4 17.7692 4.03208 17.8398 4.09625 17.9038C4.16025 17.9679 4.23075 18 4.30775 18H11.0558C11.0994 18.2667 11.1552 18.5234 11.223 18.7703C11.291 19.0169 11.3776 19.2602 11.4827 19.5ZM19.5403 19.3173L20.1635 18.6943L18.2788 16.8095V14.0385H17.3943V17.1713L19.5403 19.3173ZM17.852 21.6443C16.5482 21.6443 15.4423 21.1946 14.5345 20.2952C13.6268 19.3959 13.173 18.2943 13.173 16.9905C13.173 15.6867 13.6268 14.5834 14.5345 13.6808C15.4423 12.7783 16.5482 12.327 17.852 12.327C19.1455 12.327 20.2419 12.7808 21.1413 13.6885C22.0406 14.5962 22.4902 15.6968 22.4902 16.9905C22.4902 18.284 22.0406 19.383 21.1413 20.2875C20.2419 21.192 19.1455 21.6443 17.852 21.6443Z" />
    </svg>
  ),
  ICQr: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox={`0 0 24 24`}
      fill="currentColor"
    >
      <path d="M2.5 7.01925V2.5H7.01925V4H4V7.01925H2.5ZM2.5 21.5V16.9808H4V20H7.01925V21.5H2.5ZM16.9808 21.5V20H20V16.9808H21.5V21.5H16.9808ZM20 7.01925V4H16.9808V2.5H21.5V7.01925H20ZM17.2212 17.2212H18.577V18.577H17.2212V17.2212ZM17.2212 14.5095H18.577V15.8652H17.2212V14.5095ZM15.8652 15.8652H17.2212V17.2212H15.8652V15.8652ZM14.5095 17.2212H15.8652V18.577H14.5095V17.2212ZM13.1538 15.8652H14.5095V17.2212H13.1538V15.8652ZM15.8652 13.1538H17.2212V14.5095H15.8652V13.1538ZM14.5095 14.5095H15.8652V15.8652H14.5095V14.5095ZM13.1538 13.1538H14.5095V14.5095H13.1538V13.1538ZM18.577 5.423V10.8462H13.1538V5.423H18.577ZM10.8463 13.1538V18.577H5.423V13.1538H10.8463ZM10.8463 5.423V10.8462H5.423V5.423H10.8463ZM9.65375 17.3845V14.3463H6.6155V17.3845H9.65375ZM9.65375 9.65375V6.6155H6.6155V9.65375H9.65375ZM17.3845 9.65375V6.6155H14.3462V9.65375H17.3845Z" />
    </svg>
  ),
  ICSupport: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M11 21V19H19V11.9C19 9.95 18.3208 8.29583 16.9625 6.9375C15.6042 5.57917 13.95 4.9 12 4.9C10.05 4.9 8.39583 5.57917 7.0375 6.9375C5.67917 8.29583 5 9.95 5 11.9V18H4C3.45 18 2.97917 17.8042 2.5875 17.4125C2.19583 17.0208 2 16.55 2 16V14C2 13.65 2.0875 13.3208 2.2625 13.0125C2.4375 12.7042 2.68333 12.4583 3 12.275L3.075 10.95C3.20833 9.81667 3.5375 8.76667 4.0625 7.8C4.5875 6.83333 5.24583 5.99167 6.0375 5.275C6.82917 4.55833 7.7375 4 8.7625 3.6C9.7875 3.2 10.8667 3 12 3C13.1333 3 14.2083 3.2 15.225 3.6C16.2417 4 17.15 4.55417 17.95 5.2625C18.75 5.97083 19.4083 6.80833 19.925 7.775C20.4417 8.74167 20.775 9.79167 20.925 10.925L21 12.225C21.3167 12.375 21.5625 12.6 21.7375 12.9C21.9125 13.2 22 13.5167 22 13.85V16.15C22 16.4833 21.9125 16.8 21.7375 17.1C21.5625 17.4 21.3167 17.625 21 17.775V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H11Z" />
    </svg>
  ),
  ICWysiwyg: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M6.66667 28C5.93333 28 5.30556 27.7389 4.78333 27.2167C4.26111 26.6944 4 26.0667 4 25.3333V6.66667C4 5.93333 4.26111 5.30556 4.78333 4.78333C5.30556 4.26111 5.93333 4 6.66667 4H25.3333C26.0667 4 26.6944 4.26111 27.2167 4.78333C27.7389 5.30556 28 5.93333 28 6.66667V25.3333C28 26.0667 27.7389 26.6944 27.2167 27.2167C26.6944 27.7389 26.0667 28 25.3333 28H6.66667ZM6.66667 25.3333H25.3333V9.33333H6.66667V25.3333ZM9.33333 16V13.3333H22.6667V16H9.33333ZM9.33333 21.3333V18.6667H17.3333V21.3333H9.33333Z" />
    </svg>
  ),
  ICMoreVert: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M10.0026 16.6663C9.54427 16.6663 9.15191 16.5031 8.82552 16.1768C8.49913 15.8504 8.33594 15.458 8.33594 14.9997C8.33594 14.5413 8.49913 14.149 8.82552 13.8226C9.15191 13.4962 9.54427 13.333 10.0026 13.333C10.4609 13.333 10.8533 13.4962 11.1797 13.8226C11.5061 14.149 11.6693 14.5413 11.6693 14.9997C11.6693 15.458 11.5061 15.8504 11.1797 16.1768C10.8533 16.5031 10.4609 16.6663 10.0026 16.6663ZM10.0026 11.6663C9.54427 11.6663 9.15191 11.5031 8.82552 11.1768C8.49913 10.8504 8.33594 10.458 8.33594 9.99967C8.33594 9.54134 8.49913 9.14898 8.82552 8.82259C9.15191 8.4962 9.54427 8.33301 10.0026 8.33301C10.4609 8.33301 10.8533 8.4962 11.1797 8.82259C11.5061 9.14898 11.6693 9.54134 11.6693 9.99967C11.6693 10.458 11.5061 10.8504 11.1797 11.1768C10.8533 11.5031 10.4609 11.6663 10.0026 11.6663ZM10.0026 6.66634C9.54427 6.66634 9.15191 6.50315 8.82552 6.17676C8.49913 5.85037 8.33594 5.45801 8.33594 4.99967C8.33594 4.54134 8.49913 4.14898 8.82552 3.82259C9.15191 3.4962 9.54427 3.33301 10.0026 3.33301C10.4609 3.33301 10.8533 3.4962 11.1797 3.82259C11.5061 4.14898 11.6693 4.54134 11.6693 4.99967C11.6693 5.45801 11.5061 5.85037 11.1797 6.17676C10.8533 6.50315 10.4609 6.66634 10.0026 6.66634Z" />
    </svg>
  ),
  ICHelp: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M15.9346 24.0003C16.4013 24.0003 16.7957 23.8392 17.118 23.517C17.4402 23.1948 17.6013 22.8003 17.6013 22.3337C17.6013 21.867 17.4402 21.4725 17.118 21.1503C16.7957 20.8281 16.4013 20.667 15.9346 20.667C15.468 20.667 15.0735 20.8281 14.7513 21.1503C14.4291 21.4725 14.268 21.867 14.268 22.3337C14.268 22.8003 14.4291 23.1948 14.7513 23.517C15.0735 23.8392 15.468 24.0003 15.9346 24.0003ZM14.7346 18.867H17.2013C17.2013 18.1337 17.2846 17.5559 17.4513 17.1337C17.618 16.7114 18.0902 16.1337 18.868 15.4003C19.4457 14.8225 19.9013 14.2725 20.2346 13.7503C20.568 13.2281 20.7346 12.6003 20.7346 11.867C20.7346 10.6225 20.2791 9.66699 19.368 9.00033C18.4569 8.33366 17.3791 8.00033 16.1346 8.00033C14.868 8.00033 13.8402 8.33366 13.0513 9.00033C12.2624 9.66699 11.7124 10.467 11.4013 11.4003L13.6013 12.267C13.7124 11.867 13.9624 11.4337 14.3513 10.967C14.7402 10.5003 15.3346 10.267 16.1346 10.267C16.8457 10.267 17.3791 10.4614 17.7346 10.8503C18.0902 11.2392 18.268 11.667 18.268 12.1337C18.268 12.5781 18.1346 12.9948 17.868 13.3837C17.6013 13.7725 17.268 14.1337 16.868 14.467C15.8902 15.3337 15.2902 15.9892 15.068 16.4337C14.8457 16.8781 14.7346 17.6892 14.7346 18.867ZM16.0013 29.3337C14.1569 29.3337 12.4235 28.9837 10.8013 28.2837C9.17908 27.5837 7.76797 26.6337 6.56797 25.4337C5.36797 24.2337 4.41797 22.8225 3.71797 21.2003C3.01797 19.5781 2.66797 17.8448 2.66797 16.0003C2.66797 14.1559 3.01797 12.4225 3.71797 10.8003C4.41797 9.1781 5.36797 7.76699 6.56797 6.56699C7.76797 5.36699 9.17908 4.41699 10.8013 3.71699C12.4235 3.01699 14.1569 2.66699 16.0013 2.66699C17.8457 2.66699 19.5791 3.01699 21.2013 3.71699C22.8235 4.41699 24.2346 5.36699 25.4346 6.56699C26.6346 7.76699 27.5846 9.1781 28.2846 10.8003C28.9846 12.4225 29.3346 14.1559 29.3346 16.0003C29.3346 17.8448 28.9846 19.5781 28.2846 21.2003C27.5846 22.8225 26.6346 24.2337 25.4346 25.4337C24.2346 26.6337 22.8235 27.5837 21.2013 28.2837C19.5791 28.9837 17.8457 29.3337 16.0013 29.3337ZM16.0013 26.667C18.9791 26.667 21.5013 25.6337 23.568 23.567C25.6346 21.5003 26.668 18.9781 26.668 16.0003C26.668 13.0225 25.6346 10.5003 23.568 8.43366C21.5013 6.36699 18.9791 5.33366 16.0013 5.33366C13.0235 5.33366 10.5013 6.36699 8.43464 8.43366C6.36797 10.5003 5.33464 13.0225 5.33464 16.0003C5.33464 18.9781 6.36797 21.5003 8.43464 23.567C10.5013 25.6337 13.0235 26.667 16.0013 26.667Z" />
    </svg>
  ),
  ICDescription: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M10.6654 24.0003H21.332V21.3337H10.6654V24.0003ZM10.6654 18.667H21.332V16.0003H10.6654V18.667ZM7.9987 29.3337C7.26536 29.3337 6.63759 29.0725 6.11536 28.5503C5.59314 28.0281 5.33203 27.4003 5.33203 26.667V5.33366C5.33203 4.60033 5.59314 3.97255 6.11536 3.45033C6.63759 2.9281 7.26536 2.66699 7.9987 2.66699H18.6654L26.6654 10.667V26.667C26.6654 27.4003 26.4043 28.0281 25.882 28.5503C25.3598 29.0725 24.732 29.3337 23.9987 29.3337H7.9987ZM17.332 12.0003V5.33366H7.9987V26.667H23.9987V12.0003H17.332Z" />
    </svg>
  ),
  ICShiled: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M15.9997 29.3327C12.9108 28.5549 10.3608 26.7827 8.34967 24.016C6.33856 21.2493 5.33301 18.1771 5.33301 14.7993V6.66602L15.9997 2.66602L26.6663 6.66602V14.7993C26.6663 18.1771 25.6608 21.2493 23.6497 24.016C21.6386 26.7827 19.0886 28.5549 15.9997 29.3327ZM15.9997 26.5327C18.3108 25.7994 20.2219 24.3327 21.733 22.1327C23.2441 19.9327 23.9997 17.4882 23.9997 14.7993V8.49935L15.9997 5.49935L7.99967 8.49935V14.7993C7.99967 17.4882 8.75523 19.9327 10.2663 22.1327C11.7775 24.3327 13.6886 25.7994 15.9997 26.5327Z" />
    </svg>
  ),
  ICManual: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 32 32"
      fill="currentColor"
    >
      <path d="M18.6663 13.2007V10.934C19.3997 10.6229 20.1497 10.3895 20.9163 10.234C21.683 10.0784 22.4886 10.0007 23.333 10.0007C23.9108 10.0007 24.4775 10.0451 25.033 10.134C25.5886 10.2229 26.133 10.334 26.6663 10.4673V12.6007C26.133 12.4007 25.5941 12.2507 25.0497 12.1507C24.5052 12.0507 23.933 12.0007 23.333 12.0007C22.4886 12.0007 21.6775 12.1062 20.8997 12.3173C20.1219 12.5284 19.3775 12.8229 18.6663 13.2007ZM18.6663 20.534V18.2673C19.3997 17.9562 20.1497 17.7229 20.9163 17.5673C21.683 17.4118 22.4886 17.334 23.333 17.334C23.9108 17.334 24.4775 17.3784 25.033 17.4673C25.5886 17.5562 26.133 17.6673 26.6663 17.8007V19.934C26.133 19.734 25.5941 19.584 25.0497 19.484C24.5052 19.384 23.933 19.334 23.333 19.334C22.4886 19.334 21.6775 19.434 20.8997 19.634C20.1219 19.834 19.3775 20.134 18.6663 20.534ZM18.6663 16.8673V14.6007C19.3997 14.2895 20.1497 14.0562 20.9163 13.9007C21.683 13.7451 22.4886 13.6673 23.333 13.6673C23.9108 13.6673 24.4775 13.7118 25.033 13.8007C25.5886 13.8895 26.133 14.0007 26.6663 14.134V16.2673C26.133 16.0673 25.5941 15.9173 25.0497 15.8173C24.5052 15.7173 23.933 15.6673 23.333 15.6673C22.4886 15.6673 21.6775 15.7729 20.8997 15.984C20.1219 16.1951 19.3775 16.4895 18.6663 16.8673ZM8.66634 21.334C9.71078 21.334 10.7275 21.4506 11.7163 21.684C12.7052 21.9173 13.6886 22.2673 14.6663 22.734V9.60065C13.7552 9.06732 12.7886 8.66732 11.7663 8.40065C10.7441 8.13398 9.71078 8.00065 8.66634 8.00065C7.86634 8.00065 7.0719 8.07843 6.28301 8.23398C5.49412 8.38954 4.73301 8.62287 3.99967 8.93398V22.134C4.77745 21.8673 5.54967 21.6673 6.31634 21.534C7.08301 21.4007 7.86634 21.334 8.66634 21.334ZM17.333 22.734C18.3108 22.2673 19.2941 21.9173 20.283 21.684C21.2719 21.4506 22.2886 21.334 23.333 21.334C24.133 21.334 24.9163 21.4007 25.683 21.534C26.4497 21.6673 27.2219 21.8673 27.9997 22.134V8.93398C27.2663 8.62287 26.5052 8.38954 25.7163 8.23398C24.9275 8.07843 24.133 8.00065 23.333 8.00065C22.2886 8.00065 21.2552 8.13398 20.233 8.40065C19.2108 8.66732 18.2441 9.06732 17.333 9.60065V22.734ZM15.9997 26.6673C14.933 25.8229 13.7775 25.1673 12.533 24.7006C11.2886 24.234 9.99967 24.0007 8.66634 24.0007C7.73301 24.0007 6.81634 24.1229 5.91634 24.3673C5.01634 24.6118 4.15523 24.9562 3.33301 25.4007C2.86634 25.6451 2.41634 25.634 1.98301 25.3673C1.54967 25.1007 1.33301 24.7118 1.33301 24.2006V8.13398C1.33301 7.88954 1.39412 7.65621 1.51634 7.43398C1.63856 7.21176 1.8219 7.0451 2.06634 6.93398C3.08856 6.40065 4.15523 6.00065 5.26634 5.73398C6.37745 5.46732 7.51079 5.33398 8.66634 5.33398C9.95523 5.33398 11.2163 5.50065 12.4497 5.83398C13.683 6.16732 14.8663 6.66732 15.9997 7.33398C17.133 6.66732 18.3163 6.16732 19.5497 5.83398C20.783 5.50065 22.0441 5.33398 23.333 5.33398C24.4886 5.33398 25.6219 5.46732 26.733 5.73398C27.8441 6.00065 28.9108 6.40065 29.933 6.93398C30.1775 7.0451 30.3608 7.21176 30.483 7.43398C30.6052 7.65621 30.6663 7.88954 30.6663 8.13398V24.2006C30.6663 24.7118 30.4497 25.1007 30.0163 25.3673C29.583 25.634 29.133 25.6451 28.6663 25.4007C27.8441 24.9562 26.983 24.6118 26.083 24.3673C25.183 24.1229 24.2663 24.0007 23.333 24.0007C21.9997 24.0007 20.7108 24.234 19.4663 24.7006C18.2219 25.1673 17.0663 25.8229 15.9997 26.6673Z" />
    </svg>
  ),
  ICGlobal: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        d="M8.00065 14.6673C7.08954 14.6673 6.22843 14.4923 5.41732 14.1423C4.60621 13.7923 3.89787 13.3145 3.29232 12.709C2.68676 12.1034 2.20898 11.3951 1.85898 10.584C1.50898 9.77287 1.33398 8.91176 1.33398 8.00065C1.33398 7.07843 1.50898 6.21454 1.85898 5.40898C2.20898 4.60343 2.68676 3.89787 3.29232 3.29232C3.89787 2.68676 4.60621 2.20898 5.41732 1.85898C6.22843 1.50898 7.08954 1.33398 8.00065 1.33398C8.92287 1.33398 9.78676 1.50898 10.5923 1.85898C11.3979 2.20898 12.1034 2.68676 12.709 3.29232C13.3145 3.89787 13.7923 4.60343 14.1423 5.40898C14.4923 6.21454 14.6673 7.07843 14.6673 8.00065C14.6673 8.91176 14.4923 9.77287 14.1423 10.584C13.7923 11.3951 13.3145 12.1034 12.709 12.709C12.1034 13.3145 11.3979 13.7923 10.5923 14.1423C9.78676 14.4923 8.92287 14.6673 8.00065 14.6673ZM8.00065 13.3007C8.28954 12.9007 8.53954 12.484 8.75065 12.0507C8.96176 11.6173 9.13398 11.1562 9.26732 10.6673H6.73398C6.86732 11.1562 7.03954 11.6173 7.25065 12.0507C7.46176 12.484 7.71176 12.9007 8.00065 13.3007ZM6.26732 13.034C6.06732 12.6673 5.89232 12.2868 5.74232 11.8923C5.59232 11.4979 5.46732 11.0895 5.36732 10.6673H3.40065C3.72287 11.2229 4.12565 11.7062 4.60898 12.1173C5.09232 12.5284 5.6451 12.834 6.26732 13.034ZM9.73398 13.034C10.3562 12.834 10.909 12.5284 11.3923 12.1173C11.8757 11.7062 12.2784 11.2229 12.6007 10.6673H10.634C10.534 11.0895 10.409 11.4979 10.259 11.8923C10.109 12.2868 9.93398 12.6673 9.73398 13.034ZM2.83398 9.33398H5.10065C5.06732 9.11176 5.04232 8.89232 5.02565 8.67565C5.00898 8.45898 5.00065 8.23398 5.00065 8.00065C5.00065 7.76732 5.00898 7.54232 5.02565 7.32565C5.04232 7.10898 5.06732 6.88954 5.10065 6.66732H2.83398C2.77843 6.88954 2.73676 7.10898 2.70898 7.32565C2.68121 7.54232 2.66732 7.76732 2.66732 8.00065C2.66732 8.23398 2.68121 8.45898 2.70898 8.67565C2.73676 8.89232 2.77843 9.11176 2.83398 9.33398ZM6.43398 9.33398H9.56732C9.60065 9.11176 9.62565 8.89232 9.64232 8.67565C9.65898 8.45898 9.66732 8.23398 9.66732 8.00065C9.66732 7.76732 9.65898 7.54232 9.64232 7.32565C9.62565 7.10898 9.60065 6.88954 9.56732 6.66732H6.43398C6.40065 6.88954 6.37565 7.10898 6.35898 7.32565C6.34232 7.54232 6.33398 7.76732 6.33398 8.00065C6.33398 8.23398 6.34232 8.45898 6.35898 8.67565C6.37565 8.89232 6.40065 9.11176 6.43398 9.33398ZM10.9007 9.33398H13.1673C13.2229 9.11176 13.2645 8.89232 13.2923 8.67565C13.3201 8.45898 13.334 8.23398 13.334 8.00065C13.334 7.76732 13.3201 7.54232 13.2923 7.32565C13.2645 7.10898 13.2229 6.88954 13.1673 6.66732H10.9007C10.934 6.88954 10.959 7.10898 10.9757 7.32565C10.9923 7.54232 11.0007 7.76732 11.0007 8.00065C11.0007 8.23398 10.9923 8.45898 10.9757 8.67565C10.959 8.89232 10.934 9.11176 10.9007 9.33398ZM10.634 5.33398H12.6007C12.2784 4.77843 11.8757 4.2951 11.3923 3.88398C10.909 3.47287 10.3562 3.16732 9.73398 2.96732C9.93398 3.33398 10.109 3.71454 10.259 4.10898C10.409 4.50343 10.534 4.91176 10.634 5.33398ZM6.73398 5.33398H9.26732C9.13398 4.8451 8.96176 4.38398 8.75065 3.95065C8.53954 3.51732 8.28954 3.10065 8.00065 2.70065C7.71176 3.10065 7.46176 3.51732 7.25065 3.95065C7.03954 4.38398 6.86732 4.8451 6.73398 5.33398ZM3.40065 5.33398H5.36732C5.46732 4.91176 5.59232 4.50343 5.74232 4.10898C5.89232 3.71454 6.06732 3.33398 6.26732 2.96732C5.6451 3.16732 5.09232 3.47287 4.60898 3.88398C4.12565 4.2951 3.72287 4.77843 3.40065 5.33398Z"
        fillOpacity="0.8"
      />
    </svg>
  ),
  ICFacebook: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#ic-facebook-clip)">
        <path
          d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 23.9859 5.85094 30.6053 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5434 6.25C21.2934 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.12 10.5 18.5 11.7334 18.5 13V16H22.9375L22.2281 20.625H18.5V31.8056C26.1491 30.6053 32 23.9859 32 16Z"
          fill="#1877F2"
        />
        <path
          d="M22.2281 20.625L22.9375 16H18.5V13C18.5 11.7334 19.12 10.5 21.1075 10.5H23.125V6.5625C23.125 6.5625 21.2934 6.25 19.5434 6.25C15.8888 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C15.1566 32.0648 16.8434 32.0648 18.5 31.8056V20.625H22.2281Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="ic-facebook-clip">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ICInstagram: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#ic-instagram-clip)">
        <path
          d="M12.0055 0.183594C7.07078 0.183594 5.62756 0.188685 5.34702 0.211957C4.33432 0.296139 3.70416 0.455594 3.01764 0.797412C2.48856 1.06014 2.0713 1.36468 1.65949 1.79159C0.909518 2.57014 0.454986 3.52796 0.290445 4.6665C0.210448 5.21923 0.187176 5.33196 0.182449 8.15523C0.180631 9.09632 0.182449 10.3349 0.182449 11.9961C0.182449 16.927 0.187903 18.3689 0.211539 18.6489C0.293354 19.6343 0.447895 20.2543 0.775158 20.9325C1.40059 22.2307 2.5951 23.2052 4.00233 23.5689C4.48959 23.6943 5.02776 23.7634 5.71864 23.7961C6.01136 23.8089 8.99491 23.818 11.9803 23.818C14.9656 23.818 17.951 23.8143 18.2364 23.7998C19.0364 23.7621 19.501 23.6998 20.0146 23.567C21.4309 23.2016 22.6036 22.2416 23.2417 20.9252C23.5626 20.2634 23.7254 19.6198 23.799 18.6858C23.815 18.4821 23.8217 15.2354 23.8217 11.993C23.8217 8.75014 23.8145 5.50941 23.7985 5.30578C23.7239 4.35669 23.5612 3.7185 23.2299 3.04396C22.9581 2.49178 22.6563 2.07941 22.2181 1.65778C21.4362 0.910866 20.4798 0.456321 19.3402 0.291957C18.7881 0.212139 18.6781 0.188503 15.8527 0.183594H12.0055Z"
          fill="url(#ic-instagram-radial-0)"
        />
        <path
          d="M12.0055 0.183594C7.07078 0.183594 5.62756 0.188685 5.34702 0.211957C4.33432 0.296139 3.70416 0.455594 3.01764 0.797412C2.48856 1.06014 2.0713 1.36468 1.65949 1.79159C0.909518 2.57014 0.454986 3.52796 0.290445 4.6665C0.210448 5.21923 0.187176 5.33196 0.182449 8.15523C0.180631 9.09632 0.182449 10.3349 0.182449 11.9961C0.182449 16.927 0.187903 18.3689 0.211539 18.6489C0.293354 19.6343 0.447895 20.2543 0.775158 20.9325C1.40059 22.2307 2.5951 23.2052 4.00233 23.5689C4.48959 23.6943 5.02776 23.7634 5.71864 23.7961C6.01136 23.8089 8.99491 23.818 11.9803 23.818C14.9656 23.818 17.951 23.8143 18.2364 23.7998C19.0364 23.7621 19.501 23.6998 20.0146 23.567C21.4309 23.2016 22.6036 22.2416 23.2417 20.9252C23.5626 20.2634 23.7254 19.6198 23.799 18.6858C23.815 18.4821 23.8217 15.2354 23.8217 11.993C23.8217 8.75014 23.8145 5.50941 23.7985 5.30578C23.7239 4.35669 23.5612 3.7185 23.2299 3.04396C22.9581 2.49178 22.6563 2.07941 22.2181 1.65778C21.4362 0.910866 20.4798 0.456321 19.3402 0.291957C18.7881 0.212139 18.6781 0.188503 15.8527 0.183594H12.0055Z"
          fill="url(#ic-instagram-radial-1)"
        />
        <path
          d="M12.0012 3.27344C9.63106 3.27344 9.33362 3.2838 8.40274 3.32616C7.47367 3.36871 6.83951 3.5158 6.28462 3.73162C5.71064 3.95453 5.22374 4.25271 4.73867 4.73798C4.25323 5.22307 3.95505 5.70998 3.73142 6.2838C3.51507 6.83889 3.3678 7.47326 3.32598 8.40198C3.28435 9.33289 3.27344 9.63053 3.27344 12.0007C3.27344 14.3709 3.28398 14.6674 3.32616 15.5983C3.36889 16.5274 3.51598 17.1616 3.73161 17.7165C3.95469 18.2905 4.25286 18.7774 4.73812 19.2625C5.22301 19.748 5.70991 20.0469 6.28353 20.2698C6.83878 20.4856 7.47313 20.6327 8.40201 20.6753C9.33289 20.7176 9.63015 20.728 12.0001 20.728C14.3704 20.728 14.6669 20.7176 15.5978 20.6753C16.5269 20.6327 17.1617 20.4856 17.717 20.2698C18.2908 20.0469 18.777 19.748 19.2619 19.2625C19.7473 18.7774 20.0455 18.2905 20.2691 17.7167C20.4836 17.1616 20.6309 16.5273 20.6745 15.5985C20.7164 14.6676 20.7273 14.3709 20.7273 12.0007C20.7273 9.63053 20.7164 9.33307 20.6745 8.40216C20.6309 7.47307 20.4836 6.83889 20.2691 6.28398C20.0455 5.70998 19.7473 5.22307 19.2619 4.73798C18.7764 4.25253 18.291 3.95435 17.7165 3.73162C17.1601 3.5158 16.5256 3.36871 15.5965 3.32616C14.6656 3.2838 14.3693 3.27344 11.9984 3.27344H12.0012ZM11.2183 4.84616C11.4506 4.8458 11.7099 4.84616 12.0012 4.84616C14.3313 4.84616 14.6075 4.85453 15.5276 4.89635C16.3785 4.93526 16.8403 5.07744 17.1479 5.19689C17.5552 5.35507 17.8455 5.54416 18.1508 5.84962C18.4563 6.15507 18.6453 6.44598 18.8039 6.85326C18.9233 7.16053 19.0657 7.62235 19.1044 8.47326C19.1462 9.39326 19.1553 9.66962 19.1553 11.9987C19.1553 14.3278 19.1462 14.6042 19.1044 15.5242C19.0655 16.3751 18.9233 16.8369 18.8039 17.1442C18.6457 17.5514 18.4563 17.8414 18.1508 18.1467C17.8454 18.4522 17.5554 18.6413 17.1479 18.7994C16.8407 18.9194 16.3785 19.0613 15.5276 19.1002C14.6076 19.142 14.3313 19.1511 12.0012 19.1511C9.67088 19.1511 9.39471 19.142 8.47473 19.1002C7.62385 19.0609 7.16205 18.9187 6.85424 18.7993C6.44698 18.6411 6.15608 18.452 5.85063 18.1465C5.54519 17.8411 5.3561 17.5509 5.19756 17.1434C5.07811 16.8362 4.93575 16.3743 4.89702 15.5234C4.85521 14.6034 4.84684 14.3271 4.84684 11.9965C4.84684 9.66598 4.85521 9.39107 4.89702 8.47107C4.93593 7.62017 5.07811 7.15835 5.19756 6.85071C5.35574 6.44344 5.54519 6.15253 5.85063 5.84707C6.15608 5.54162 6.44698 5.35253 6.85424 5.19398C7.16186 5.07398 7.62385 4.93217 8.47473 4.89307C9.2798 4.85671 9.59179 4.8458 11.2183 4.84398V4.84616ZM16.6596 6.29526C16.0814 6.29526 15.6123 6.7638 15.6123 7.34216C15.6123 7.92035 16.0814 8.38944 16.6596 8.38944C17.2377 8.38944 17.7068 7.92035 17.7068 7.34216C17.7068 6.76398 17.2377 6.29489 16.6596 6.29489V6.29526ZM12.0012 7.51889C9.52616 7.51889 7.51949 9.52562 7.51949 12.0007C7.51949 14.4758 9.52616 16.4816 12.0012 16.4816C14.4762 16.4816 16.4821 14.4758 16.4821 12.0007C16.4821 9.52562 14.4762 7.51889 12.0012 7.51889ZM12.0012 9.09162C13.6077 9.09162 14.9102 10.394 14.9102 12.0007C14.9102 13.6073 13.6077 14.9098 12.0012 14.9098C10.3945 14.9098 9.09217 13.6073 9.09217 12.0007C9.09217 10.394 10.3945 9.09162 12.0012 9.09162Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="ic-instagram-radial-0"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.46107 25.6383) rotate(-90) scale(23.4234 21.7909)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          id="ic-instagram-radial-1"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(2.05559 10.2667 -42.3291 8.47576 -3.7782 1.88617)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <clipPath id="ic-instagram-clip">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ICGoogle: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M39.6104 20.4607C39.6104 19.1012 39.5002 17.7343 39.265 16.3968H20.4004V24.0984H31.2033C30.755 26.5823 29.3146 28.7796 27.2055 30.1759V35.1732H33.6505C37.4352 31.6898 39.6104 26.5456 39.6104 20.4607Z"
        fill="#4285F4"
      />
      <path
        d="M20.4004 40.0014C25.7945 40.0014 30.3434 38.2303 33.6578 35.1732L27.2128 30.1759C25.4197 31.3958 23.1048 32.0866 20.4077 32.0866C15.19 32.0866 10.766 28.5665 9.17863 23.8338H2.52788V28.9854C5.92307 35.739 12.8384 40.0014 20.4004 40.0014Z"
        fill="#34A853"
      />
      <path
        d="M9.1713 23.8338C8.33353 21.3499 8.33353 18.6602 9.1713 16.1763V11.0247H2.5279C-0.308767 16.676 -0.308787 23.3341 2.52788 28.9854L9.1713 23.8338Z"
        fill="#FBBC04"
      />
      <path
        d="M20.4004 7.9161C23.2517 7.87201 26.0076 8.94494 28.0726 10.9144L33.7827 5.20436C30.1671 1.80917 25.3682 -0.0574433 20.4004 0.00134778C12.8384 0.00134778 5.92309 4.26373 2.5279 11.0247L9.1713 16.1763C10.7513 11.4362 15.1827 7.9161 20.4004 7.9161Z"
        fill="#EA4335"
      />
    </svg>
  ),
  ICDeselect: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path d="M13.1797 15.0672L9.44635 11.3339H4.66302V6.55052L0.929688 2.81719L1.86302 1.86719L14.1297 14.1339L13.1797 15.0672ZM5.99635 10.0005H8.11302L5.99635 7.88385V10.0005ZM11.3297 9.45052L9.99635 8.11719V6.00052H7.87969L6.54635 4.66719H11.3297V9.45052ZM3.32969 12.6672V14.0005C2.96302 14.0005 2.64913 13.87 2.38802 13.6089C2.12691 13.3477 1.99635 13.0339 1.99635 12.6672H3.32969ZM1.99635 11.3339V10.0005H3.32969V11.3339H1.99635ZM1.99635 8.66719V7.33385H3.32969V8.66719H1.99635ZM1.99635 6.00052V4.66719H3.32969V6.00052H1.99635ZM4.66302 14.0005V12.6672H5.99635V14.0005H4.66302ZM4.66302 3.33385V2.00052H5.99635V3.33385H4.66302ZM7.32969 14.0005V12.6672H8.66302V14.0005H7.32969ZM7.32969 3.33385V2.00052H8.66302V3.33385H7.32969ZM9.99635 14.0005V12.6672H11.3297V14.0005H9.99635ZM9.99635 3.33385V2.00052H11.3297V3.33385H9.99635ZM12.663 11.3339V10.0005H13.9964V11.3339H12.663ZM12.663 8.66719V7.33385H13.9964V8.66719H12.663ZM12.663 6.00052V4.66719H13.9964V6.00052H12.663ZM12.663 3.33385V2.00052C13.0297 2.00052 13.3436 2.13108 13.6047 2.39219C13.8658 2.6533 13.9964 2.96719 13.9964 3.33385H12.663Z" />
    </svg>
  ),
  ICVisa: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 34 24"
      fill="none"
    >
      <rect width="34" height="24" rx="1" fill="#F7F7F7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.751 15.8579H8.69129L7.14674 9.79198C7.07343 9.51295 6.91776 9.26627 6.68879 9.15001C6.11737 8.85784 5.4877 8.62531 4.80078 8.50804V8.2745H8.11886C8.57681 8.2745 8.92026 8.62531 8.97751 9.03274L9.77891 13.4083L11.8376 8.2745H13.8401L10.751 15.8579ZM14.985 15.8579H13.0398L14.6415 8.2745H16.5868L14.985 15.8579ZM19.1035 10.3753C19.1607 9.96689 19.5042 9.73335 19.9049 9.73335C20.5346 9.67471 21.2205 9.79199 21.7929 10.0832L22.1364 8.45042C21.5639 8.21688 20.9343 8.09961 20.3628 8.09961C18.4748 8.09961 17.101 9.15002 17.101 10.6078C17.101 11.7169 18.0741 12.2992 18.761 12.65C19.5042 12.9998 19.7904 13.2334 19.7332 13.5832C19.7332 14.1079 19.1607 14.3414 18.5893 14.3414C17.9024 14.3414 17.2155 14.1665 16.5868 13.8743L16.2433 15.5081C16.9303 15.7992 17.6734 15.9165 18.3603 15.9165C20.4773 15.9741 21.7929 14.9247 21.7929 13.3496C21.7929 11.3661 19.1035 11.2498 19.1035 10.3753ZM28.6008 15.8579L27.0562 8.2745H25.3972C25.0537 8.2745 24.7103 8.50804 24.5958 8.85784L21.7356 15.8579H23.7381L24.1378 14.7498H26.5983L26.8273 15.8579H28.6008ZM25.6834 10.3167L26.2548 13.1747H24.653L25.6834 10.3167Z"
        fill="#172B85"
      />
    </svg>
  ),
  ICMasterCard: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 34 24"
      fill="none"
    >
      <rect width="34" height="24" rx="1" fill="#F7F7F7" />
      <path
        d="M21.5771 5.03027C25.322 5.03027 28.3584 8.03016 28.3584 11.7305C28.3583 15.4307 25.322 18.4307 21.5771 18.4307C19.8982 18.4306 18.3629 17.8259 17.1787 16.8271C15.9945 17.8258 14.4591 18.4307 12.7803 18.4307C9.03566 18.4304 6.00011 15.4305 6 11.7305C6 8.0303 9.03559 5.0305 12.7803 5.03027C14.459 5.03027 15.9945 5.63435 17.1787 6.63281C18.3629 5.63422 19.8983 5.0303 21.5771 5.03027Z"
        fill="#ED0006"
      />
      <path
        d="M21.5781 5.03027C25.3229 5.03035 28.3584 8.03021 28.3584 11.7305C28.3583 15.4306 25.3229 18.4306 21.5781 18.4307C19.8992 18.4307 18.3639 17.8258 17.1797 16.8271C18.6368 15.5983 19.5624 13.7718 19.5625 11.7305C19.5625 9.68897 18.6371 7.86171 17.1797 6.63281C18.3639 5.63427 19.8993 5.03027 21.5781 5.03027Z"
        fill="#F9A000"
      />
      <path
        d="M17.1787 6.63281C18.6362 7.86171 19.5615 9.68889 19.5615 11.7305C19.5614 13.7718 18.6361 15.5983 17.1787 16.8271C15.7217 15.5983 14.797 13.7716 14.7969 11.7305C14.7969 9.68919 15.7216 7.86171 17.1787 6.63281Z"
        fill="#FF5E00"
      />
    </svg>
  ),
  ICJCB: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 34 24"
      fill="none"
    >
      <rect width="34" height="24" rx="1" fill="#F7F7F7" />
      <path
        d="M21.9837 11.9542C22.515 11.9658 23.0493 11.9308 23.5784 11.9724C24.1143 12.0724 24.2434 12.8836 23.7674 13.1493C23.4425 13.3243 23.0567 13.2145 22.7045 13.2454H21.9837V11.9542ZM23.8856 10.4928C24.0036 10.9095 23.602 11.2835 23.2008 11.2262H21.9837C21.9923 10.8333 21.9671 10.4068 21.9961 10.0346C22.4836 10.0484 22.9757 10.0066 23.4604 10.0564C23.6687 10.1088 23.843 10.28 23.8856 10.4928ZM26.8145 4.31448C26.8372 5.11012 26.8178 5.94781 26.8243 6.75959C26.8228 10.06 26.8275 13.3603 26.8217 16.6609C26.8003 17.8978 25.7042 18.9726 24.4758 18.9972C23.2463 19.0022 22.0166 18.998 20.7869 18.9994V14.0099C22.1267 14.003 23.4672 14.0239 24.8065 13.9994C25.4277 13.9604 26.1083 13.5505 26.1372 12.8668C26.2103 12.1801 25.5629 11.7051 24.9483 11.6301C24.712 11.624 24.7189 11.5613 24.9483 11.5339C25.5345 11.4072 25.9949 10.8004 25.8224 10.1928C25.6754 9.55368 24.969 9.30631 24.3815 9.30754C23.1834 9.2994 21.9852 9.30641 20.7871 9.30404C20.7949 8.37256 20.771 7.44008 20.8 6.50928C20.8949 5.2947 22.0187 4.29307 23.2298 4.3148C24.4248 4.31462 25.6197 4.31462 26.8145 4.31457V4.31448Z"
        fill="url(#paint0_linear_4492_36031)"
      />
      <path
        d="M7.24671 6.6353C7.27731 5.40035 8.37818 4.33439 9.60494 4.31635C10.8299 4.31257 12.0551 4.3158 13.2801 4.31471C13.2767 8.44657 13.2867 12.5789 13.275 16.7105C13.2279 17.9305 12.139 18.9761 10.9256 18.9977C9.69828 19.0022 8.47083 18.9983 7.24348 18.9996V13.8418C8.43565 14.1235 9.68582 14.2434 10.902 14.0566C11.629 13.9396 12.4244 13.5826 12.6706 12.8283C12.8517 12.1832 12.7497 11.5042 12.7767 10.842V9.30427H10.6719C10.6624 10.3213 10.6913 11.3401 10.6567 12.3559C10.5999 12.9803 9.9816 13.377 9.39272 13.3558C8.66241 13.3636 7.2152 12.8266 7.2152 12.8266C7.21157 10.9211 7.23639 8.53468 7.24671 6.63548V6.6353Z"
        fill="url(#paint1_linear_4492_36031)"
      />
      <path
        d="M14.0654 9.92476C13.9546 9.94826 14.0431 9.54738 14.0148 9.3953C14.0223 8.43377 13.999 7.47119 14.0276 6.51034C14.1223 5.29063 15.2547 4.2865 16.4707 4.31505H20.0517C20.0483 8.44691 20.0582 12.5792 20.0466 16.7109C19.9994 17.9308 18.9104 18.9764 17.697 18.998C16.4696 19.0027 15.2422 18.9988 14.0147 18.9999V13.349C14.853 14.0368 15.9923 14.1438 17.0367 14.1457C17.824 14.1454 18.6067 14.024 19.3713 13.8424V12.8072C18.5097 13.2366 17.4968 13.5094 16.5416 13.2627C15.8753 13.0968 15.3916 12.4529 15.4024 11.7653C15.3252 11.0502 15.7444 10.2952 16.4471 10.0827C17.3196 9.80951 18.2704 10.0184 19.0883 10.3735C19.2635 10.4653 19.4413 10.5791 19.3713 10.2862V9.47245C18.0035 9.14703 16.5479 9.02729 15.1737 9.3813C14.776 9.4935 14.3885 9.66367 14.0654 9.92485V9.92476Z"
        fill="url(#paint2_linear_4492_36031)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4492_36031"
          x1="20.7456"
          y1="11.343"
          x2="26.7862"
          y2="11.343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B03A" />
          <stop offset="1" stopColor="#55B330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4492_36031"
          x1="7.11505"
          y1="11.7978"
          x2="13.1811"
          y2="11.7978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F6EB6" />
          <stop offset="1" stopColor="#006DBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4492_36031"
          x1="14.0059"
          y1="11.4858"
          x2="20.0505"
          y2="11.4858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DE0D3D" />
          <stop offset="1" stopColor="#E30138" />
        </linearGradient>
      </defs>
    </svg>
  ),
  ICAmex: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 34 24"
      fill="none"
    >
      <rect width="34" height="24" rx="1" fill="#1F72CD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.09517 8.5L2.91406 15.7467H6.7223L7.19441 14.5913H8.27355L8.74566 15.7467H12.9375V14.8649L13.311 15.7467H15.4793L15.8528 14.8462V15.7467H24.5706L25.6307 14.6213L26.6232 15.7467L31.1009 15.7561L27.9097 12.1436L31.1009 8.5H26.6927L25.6608 9.60463L24.6995 8.5H15.2156L14.4013 10.3704L13.5678 8.5H9.7675V9.35186L9.34474 8.5H6.09517ZM6.83205 9.52905H8.68836L10.7984 14.4431V9.52905H12.8319L14.4617 13.0524L15.9637 9.52905H17.987V14.7291H16.7558L16.7458 10.6544L14.9509 14.7291H13.8495L12.0446 10.6544V14.7291H9.51179L9.03162 13.5633H6.43745L5.95827 14.728H4.60123L6.83205 9.52905ZM24.1196 9.52905H19.1134V14.726H24.0421L25.6307 13.0036L27.1618 14.726H28.7624L26.436 12.1426L28.7624 9.52905H27.2313L25.6507 11.2316L24.1196 9.52905ZM7.73508 10.4089L6.8804 12.4856H8.58876L7.73508 10.4089ZM20.3497 11.555V10.6057V10.6048H23.4734L24.8364 12.1229L23.413 13.6493H20.3497V12.613H23.0808V11.555H20.3497Z"
        fill="white"
      />
    </svg>
  ),
  ICZaloPay: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M14.2313 0.5H4.76869C2.41116 0.5 0.5 2.40266 0.5 4.74972V14.2503C0.5 16.5973 2.41116 18.5 4.76869 18.5H14.2313C16.5888 18.5 18.5 16.5973 18.5 14.2503V4.74972C18.5 2.40266 16.5888 0.5 14.2313 0.5Z"
        fill="white"
        stroke="#EAEAEA"
        strokeMiterlimit="10"
      />
      <path
        d="M2.27081 5.34037C2.10634 4.32505 2.79951 3.36879 3.81937 3.20505L16.5781 1.15495C15.9195 0.740748 15.1392 0.5 14.3026 0.5H4.83998C2.48259 0.5 0.571289 2.4028 0.571289 4.74972V14.2503C0.571289 16.4499 2.24978 18.2585 4.4014 18.4776L2.27156 5.34037H2.27081Z"
        fill="#0068FF"
      />
      <path
        d="M11.6453 6.16645C11.5642 6.08346 11.4605 6.04234 11.3351 6.04234C11.1504 6.04234 11.0152 6.13057 10.9303 6.30701C10.7493 6.09543 10.5015 5.98926 10.1876 5.98926C9.81059 5.98926 9.49367 6.1343 9.23683 6.42365C8.97998 6.713 8.85156 7.06589 8.85156 7.48234C8.85156 7.89879 8.97998 8.25169 9.23683 8.54103C9.49367 8.83038 9.81059 8.97543 10.1876 8.97543C10.5015 8.97543 10.7493 8.86926 10.9303 8.65767C11.0152 8.83412 11.1504 8.92234 11.3351 8.92234C11.4605 8.92234 11.5642 8.88122 11.6453 8.79823C11.7264 8.71524 11.7669 8.61356 11.7669 8.49393V6.4715C11.7669 6.35187 11.7264 6.25019 11.6453 6.1672V6.16645ZM10.7448 7.98402C10.6397 8.11935 10.494 8.18664 10.31 8.18664C10.126 8.18664 9.98032 8.11935 9.87518 7.98402C9.77004 7.8487 9.71747 7.68197 9.71747 7.48234C9.71747 7.28272 9.77004 7.11599 9.87518 6.98066C9.98032 6.84533 10.1253 6.77804 10.31 6.77804C10.4947 6.77804 10.6397 6.84533 10.7448 6.98066C10.85 7.11599 10.9025 7.28272 10.9025 7.48234C10.9025 7.68197 10.85 7.8487 10.7448 7.98402Z"
        fill="#0068FF"
      />
      <path
        d="M12.7459 8.79821C12.6648 8.8812 12.5611 8.92232 12.4357 8.92232C12.3103 8.92232 12.2067 8.8812 12.1256 8.79821C12.0445 8.71522 12.0039 8.61354 12.0039 8.49391V4.87372C12.0039 4.7541 12.0445 4.65242 12.1256 4.56942C12.2067 4.48643 12.3103 4.44531 12.4357 4.44531C12.5611 4.44531 12.6648 4.48643 12.7459 4.56942C12.827 4.65242 12.8676 4.7541 12.8676 4.87372V8.49391C12.8676 8.61428 12.827 8.71522 12.7459 8.79821Z"
        fill="#0068FF"
      />
      <path
        d="M15.6094 6.42267C15.3323 6.13333 14.9793 5.98828 14.5505 5.98828C14.1216 5.98828 13.7717 6.13108 13.5006 6.41744C13.2287 6.70305 13.0928 7.05819 13.0928 7.48137C13.0928 7.90454 13.2287 8.25968 13.5006 8.54529C13.7724 8.8309 14.1224 8.97445 14.5505 8.97445C14.9785 8.97445 15.3323 8.83015 15.6094 8.54006C15.8752 8.25744 16.0082 7.90454 16.0082 7.48137C16.0082 7.05819 15.8752 6.70529 15.6094 6.42267ZM14.986 7.98305C14.8809 8.11837 14.736 8.18566 14.5512 8.18566C14.3665 8.18566 14.2215 8.11837 14.1164 7.98305C14.0112 7.84772 13.9587 7.68099 13.9587 7.48137C13.9587 7.28174 14.0112 7.11501 14.1164 6.97968C14.2215 6.84436 14.3665 6.77707 14.5512 6.77707C14.736 6.77707 14.8809 6.84436 14.986 6.97968C15.0912 7.11501 15.1438 7.28174 15.1438 7.48137C15.1438 7.68099 15.0912 7.84772 14.986 7.98305Z"
        fill="#0068FF"
      />
      <path
        d="M8.37305 6.08852C8.67871 5.69599 8.83116 5.43207 8.83116 5.29599C8.83116 4.98123 8.63215 4.82422 8.23412 4.82422H6.13581C5.97059 4.82422 5.84368 4.8631 5.75281 4.94085C5.66269 5.01861 5.61687 5.11955 5.61687 5.24366C5.61687 5.36777 5.66193 5.46871 5.75281 5.54646C5.84368 5.62422 5.97059 5.6631 6.13581 5.6631H7.57699L5.73178 8.03618C5.61086 8.1917 5.55078 8.32927 5.55078 8.44964C5.55078 8.79506 5.77984 8.96702 6.23795 8.96702H8.40309C8.7493 8.96702 8.92203 8.82272 8.92203 8.53338C8.92203 8.24403 8.7493 8.09973 8.40309 8.09973H6.81096L8.37305 6.08927V6.08852Z"
        fill="#0068FF"
      />
      <path
        d="M7.26968 11.2029H6.73047V12.3177H7.26968C7.4319 12.3177 7.56257 12.2653 7.66321 12.1599C7.76384 12.0545 7.81341 11.9214 7.81341 11.7599C7.81341 11.5984 7.76309 11.4653 7.66321 11.3599C7.56257 11.2545 7.4319 11.2021 7.26968 11.2021V11.2029Z"
        fill="#03CA77"
      />
      <path
        d="M9.95817 12.251C9.78694 12.251 9.65326 12.3138 9.55563 12.4386C9.458 12.5635 9.40918 12.7183 9.40918 12.9029C9.40918 13.0876 9.458 13.2416 9.55563 13.3672C9.65326 13.4921 9.78694 13.5549 9.95817 13.5549C10.1294 13.5549 10.2631 13.4921 10.3607 13.3672C10.4583 13.2424 10.5071 13.0876 10.5071 12.9029C10.5071 12.7183 10.4583 12.5642 10.3607 12.4386C10.2631 12.3138 10.1286 12.251 9.95817 12.251Z"
        fill="#03CA77"
      />
      <path
        d="M13.7653 9.6084H5.95188C5.69128 9.6084 5.47949 9.81849 5.47949 10.0779V14.6357C5.47949 14.8951 5.69053 15.1052 5.95188 15.1052H12.1199C12.0545 15.0439 12.0222 14.9721 12.0222 14.8899C12.0222 14.8226 12.0372 14.7523 12.068 14.6783L12.3587 14.0346L11.5543 12.0353C11.5311 11.9785 11.519 11.9164 11.519 11.8491C11.519 11.7617 11.5558 11.6877 11.6302 11.6278C11.7045 11.5673 11.7819 11.5374 11.863 11.5374C12.0417 11.5374 12.1634 11.6226 12.2272 11.7946L12.7282 13.1591L13.2644 11.7946C13.332 11.6234 13.4529 11.5374 13.6286 11.5374C13.7097 11.5374 13.7871 11.5673 13.8614 11.6278C13.9358 11.6884 13.9726 11.7624 13.9726 11.8491C13.9726 11.9164 13.9606 11.9785 13.9373 12.0353L12.7454 14.9153C12.7131 14.9961 12.6733 15.0589 12.6275 15.106H13.7645C14.0251 15.106 14.2369 14.8959 14.2369 14.6364V10.0787C14.2369 9.81924 14.0259 9.60915 13.7645 9.60915L13.7653 9.6084ZM8.24693 12.6746C8.0006 12.8989 7.69044 13.011 7.31719 13.011H6.73066V13.8738C6.73066 14.0039 6.69387 14.1041 6.61952 14.1759C6.54517 14.2477 6.45054 14.2835 6.33413 14.2835C6.21773 14.2835 6.1231 14.2477 6.04875 14.1759C5.9744 14.1041 5.9376 14.0032 5.9376 13.8738V10.9183C5.9376 10.6447 6.07503 10.5078 6.3499 10.5078H7.2849C7.67617 10.5078 7.9991 10.6245 8.25444 10.8577C8.50978 11.091 8.63746 11.3931 8.63746 11.7654C8.63746 12.1377 8.50678 12.4435 8.24618 12.6753L8.24693 12.6746ZM11.3073 13.8379C11.3073 13.9493 11.2697 14.0428 11.1946 14.1198C11.1195 14.1968 11.0234 14.2349 10.907 14.2349C10.7358 14.2349 10.6111 14.1534 10.533 13.9897C10.3655 14.1856 10.1365 14.2835 9.84582 14.2835C9.49735 14.2835 9.20371 14.1497 8.9664 13.882C8.72908 13.6144 8.61042 13.2877 8.61042 12.9019C8.61042 12.5161 8.72908 12.1893 8.9664 11.9217C9.20371 11.654 9.49735 11.5202 9.84582 11.5202C10.1365 11.5202 10.3655 11.6181 10.533 11.814C10.6111 11.651 10.7365 11.5688 10.907 11.5688C11.0234 11.5688 11.1188 11.6069 11.1946 11.6839C11.2697 11.7609 11.3073 11.8544 11.3073 11.9658V13.8379Z"
        fill="#03CA77"
      />
    </svg>
  ),
  ICZalo: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ flex: '1 0 0', alignSelf: 'stretch' }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#ic-zalo-clip)">
        <path
          d="M6.32247 19.5686V1.16399L5.55847 0.652344C2.31007 1.95637 0.0136719 5.12906 0.0136719 8.84368V15.1525C0.0136719 20.0304 3.96802 23.9848 8.84598 23.9848H15.1548C18.1338 23.9848 20.7589 22.5035 22.3575 20.243V19.5686H6.32247Z"
          fill="#2962FF"
        />
        <path
          d="M15.1547 0.0117188H8.84592C7.68195 0.0117188 6.57413 0.242621 5.55652 0.65143C3.4538 2.69296 1.90625 6.02274 1.90625 8.84403C1.90625 13.1157 2.49675 15.6165 4.24807 18.0593C4.38434 18.2492 4.4733 18.4713 4.48529 18.704C4.51241 19.2308 4.4039 20.1961 3.45443 21.0648C3.35223 21.1582 3.41721 21.3291 3.55537 21.3348C4.14966 21.3607 5.34896 21.326 6.5817 20.7815C6.9331 20.6263 7.33307 20.6535 7.67249 20.8339C9.76259 21.9436 12.2104 22.0925 14.5238 22.0925C17.4738 22.0925 20.4156 21.4364 22.3575 20.2529C23.3801 18.8113 23.987 17.0543 23.987 15.1528V8.84403C23.987 3.96607 20.0327 0.0117188 15.1547 0.0117188Z"
          fill="#EEEEEE"
        />
        <path
          d="M20.0435 13.8918C18.7395 13.8918 17.6777 12.83 17.6777 11.526C17.6777 10.2219 18.7395 9.16016 20.0435 9.16016C21.3476 9.16016 22.4093 10.2219 22.4093 11.526C22.4093 12.83 21.3476 13.8918 20.0435 13.8918ZM20.0435 10.1065C19.2612 10.1065 18.6241 10.7437 18.6241 11.526C18.6241 12.3082 19.2612 12.9454 20.0435 12.9454C20.8258 12.9454 21.463 12.3082 21.463 11.526C21.463 10.7437 20.8258 10.1065 20.0435 10.1065Z"
          fill="#2962FF"
        />
        <path
          d="M16.7315 13.8928H16.1006C15.9265 13.8928 15.7852 13.7514 15.7852 13.5773V8.21484H16.7315V13.8928Z"
          fill="#2962FF"
        />
        <path
          d="M13.8927 9.31788V9.6453C13.4959 9.345 13.0076 9.16016 12.4732 9.16016C11.1692 9.16016 10.1074 10.2219 10.1074 11.526C10.1074 12.83 11.1692 13.8918 12.4732 13.8918C13.0076 13.8918 13.4959 13.7069 13.8927 13.4066V13.5763C13.8927 13.7504 14.034 13.8918 14.2081 13.8918H14.839V9.31788H13.8927ZM12.4732 12.9454C11.6909 12.9454 11.0537 12.3082 11.0537 11.526C11.0537 10.7437 11.6909 10.1065 12.4732 10.1065C13.2555 10.1065 13.8927 10.7437 13.8927 11.526C13.8927 12.3082 13.2555 12.9454 12.4732 12.9454Z"
          fill="#2962FF"
        />
        <path
          d="M10.2648 8.21484H5.21778V9.16116H8.57469L5.06006 13.2619H5.07647C4.97363 13.395 4.90234 13.554 4.90234 13.735V13.8928H9.63394C9.80806 13.8928 9.94938 13.7514 9.94938 13.5773V12.9464H6.59247L10.1071 8.84572H10.0907C10.1935 8.71261 10.2648 8.55363 10.2648 8.37256V8.21484Z"
          fill="#2962FF"
        />
      </g>
      <defs>
        <clipPath id="ic-zalo-clip">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ICProduct: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path
        d="M3.75 6V14.25H14.25V6H12V12L9 10.5L6 12V6H3.75ZM3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39687 15.0156 2.25 14.6625 2.25 14.25V4.89375C2.25 4.71875 2.27813 4.55 2.33438 4.3875C2.39062 4.225 2.475 4.075 2.5875 3.9375L3.525 2.79375C3.6625 2.61875 3.83438 2.48438 4.04063 2.39062C4.24688 2.29688 4.4625 2.25 4.6875 2.25H13.3125C13.5375 2.25 13.7531 2.29688 13.9594 2.39062C14.1656 2.48438 14.3375 2.61875 14.475 2.79375L15.4125 3.9375C15.525 4.075 15.6094 4.225 15.6656 4.3875C15.7219 4.55 15.75 4.71875 15.75 4.89375V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM4.05 4.5H13.95L13.3125 3.75H4.6875L4.05 4.5ZM7.5 6V9.5625L9 8.8125L10.5 9.5625V6H7.5Z"
        fillOpacity="0.6"
      />
    </svg>
  ),
  ICOverview: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M14.7563 15.2813L15.2813 14.7563L13.875 13.35V11.25H13.125V13.65L14.7563 15.2813ZM3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39687 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39687 2.98438 2.69063 2.69063C2.98438 2.39687 3.3375 2.25 3.75 2.25H14.25C14.6625 2.25 15.0156 2.39687 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V8.775C15.5125 8.6625 15.2688 8.56563 15.0188 8.48438C14.7688 8.40313 14.5125 8.34375 14.25 8.30625V3.75H3.75V14.25H8.2875C8.325 14.525 8.38438 14.7875 8.46563 15.0375C8.54688 15.2875 8.64375 15.525 8.75625 15.75H3.75ZM3.75 13.5V14.25V3.75V8.30625V8.25V13.5ZM5.25 12.75H8.30625C8.34375 12.4875 8.40313 12.2313 8.48438 11.9813C8.56563 11.7313 8.65625 11.4875 8.75625 11.25H5.25V12.75ZM5.25 9.75H9.825C10.225 9.375 10.6719 9.0625 11.1656 8.8125C11.6594 8.5625 12.1875 8.39375 12.75 8.30625V8.25H5.25V9.75ZM5.25 6.75H12.75V5.25H5.25V6.75ZM13.5 17.25C12.4625 17.25 11.5781 16.8844 10.8469 16.1531C10.1156 15.4219 9.75 14.5375 9.75 13.5C9.75 12.4625 10.1156 11.5781 10.8469 10.8469C11.5781 10.1156 12.4625 9.75 13.5 9.75C14.5375 9.75 15.4219 10.1156 16.1531 10.8469C16.8844 11.5781 17.25 12.4625 17.25 13.5C17.25 14.5375 16.8844 15.4219 16.1531 16.1531C15.4219 16.8844 14.5375 17.25 13.5 17.25Z" />
    </svg>
  ),
  ICChart: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M6.75 12.75H5.25V7.5H6.75V12.75ZM9.75 12.75H8.25V5.25H9.75V12.75ZM12.75 12.75H11.25V9.75H12.75V12.75ZM14.25 14.25H3.75V3.75H14.25V14.25ZM14.25 2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V3.75C15.75 2.925 15.075 2.25 14.25 2.25Z" />
    </svg>
  ),
  ICCampaign: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path d="M13.5 9.75V8.25H16.5V9.75H13.5ZM14.4 15L12 13.2L12.9 12L15.3 13.8L14.4 15ZM12.9 6L12 4.8L14.4 3L15.3 4.2L12.9 6ZM3.75 14.25V11.25H3C2.5875 11.25 2.23438 11.1031 1.94063 10.8094C1.64687 10.5156 1.5 10.1625 1.5 9.75V8.25C1.5 7.8375 1.64687 7.48438 1.94063 7.19063C2.23438 6.89688 2.5875 6.75 3 6.75H6L9.75 4.5V13.5L6 11.25H5.25V14.25H3.75ZM8.25 10.8375V7.1625L6.4125 8.25H3V9.75H6.4125L8.25 10.8375ZM10.5 11.5125V6.4875C10.8375 6.7875 11.1094 7.15313 11.3156 7.58438C11.5219 8.01562 11.625 8.4875 11.625 9C11.625 9.5125 11.5219 9.98438 11.3156 10.4156C11.1094 10.8469 10.8375 11.2125 10.5 11.5125Z" />
    </svg>
  ),
  ICInventory: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 18 18"
      fill="currentColor"
    >
      <path
        d="M3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69063 16.0594C2.39688 15.7656 2.25 15.4125 2.25 15V6.54375C2.025 6.40625 1.84375 6.22813 1.70625 6.00938C1.56875 5.79063 1.5 5.5375 1.5 5.25V3C1.5 2.5875 1.64687 2.23438 1.94063 1.94063C2.23438 1.64687 2.5875 1.5 3 1.5H15C15.4125 1.5 15.7656 1.64687 16.0594 1.94063C16.3531 2.23438 16.5 2.5875 16.5 3V5.25C16.5 5.5375 16.4313 5.79063 16.2938 6.00938C16.1563 6.22813 15.975 6.40625 15.75 6.54375V15C15.75 15.4125 15.6031 15.7656 15.3094 16.0594C15.0156 16.3531 14.6625 16.5 14.25 16.5H3.75ZM3.75 6.75V15H14.25V6.75H3.75ZM3 5.25H15V3H3V5.25ZM6.75 10.5H11.25V9H6.75V10.5Z"
        fillOpacity="0.6"
      />
    </svg>
  ),
  ICNavigateBefore: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" />
    </svg>
  ),
  ICNavigateNext: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z" />
    </svg>
  ),
  ICOpenFullScreen: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="self-stretch grow"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M3 21V13H5V17.6L17.6 5H13V3H21V11H19V6.4L6.4 19H11V21H3Z" />
    </svg>
  ),
};
